var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/common/utilities/country-selector.js
var CountrySelector = class extends HTMLElement {
  constructor() {
    super();
    this._onCountryChangedListener = this._onCountryChanged.bind(this);
  }
  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement.addEventListener("change", this._onCountryChangedListener);
    if (this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.getAttribute("country")));
      this.countryElement.dispatchEvent(new Event("change"));
    } else {
      this._onCountryChanged();
    }
  }
  disconnectedCallback() {
    this.countryElement.removeEventListener("change", this._onCountryChangedListener);
  }
  _onCountryChanged() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.getAttribute("data-provinces"));
    this.provinceElement.parentElement.hidden = provinces.length === 0;
    if (provinces.length === 0) {
      return;
    }
    this.provinceElement.innerHTML = "";
    provinces.forEach((data) => {
      const selected = data[1] === this.getAttribute("province");
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
};
if (!window.customElements.get("country-selector")) {
  window.customElements.define("country-selector", CountrySelector);
}

// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      // Shopify: 1 134,65 (the decimal mark is a comma).
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// js/common/utilities/cached-fetch.js
var cachedMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  return fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}

// js/common/utilities/extract-section-id.js
function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// js/common/utilities/dom.js
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}

// js/common/utilities/player.js
var _callback, _duration, _remainingTime, _startTime, _timer, _state, _onVisibilityChangeListener, _onVisibilityChange, onVisibilityChange_fn;
var Player = class extends EventTarget {
  constructor(durationInSec, stopOnVisibility = true) {
    super();
    __privateAdd(this, _onVisibilityChange);
    __privateAdd(this, _callback, void 0);
    __privateAdd(this, _duration, void 0);
    __privateAdd(this, _remainingTime, void 0);
    __privateAdd(this, _startTime, void 0);
    __privateAdd(this, _timer, void 0);
    __privateAdd(this, _state, "paused");
    __privateAdd(this, _onVisibilityChangeListener, __privateMethod(this, _onVisibilityChange, onVisibilityChange_fn).bind(this));
    __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent("player:end")));
    __privateSet(this, _duration, __privateSet(this, _remainingTime, durationInSec * 1e3));
    if (stopOnVisibility) {
      document.addEventListener("visibilitychange", __privateGet(this, _onVisibilityChangeListener));
    }
  }
  pause() {
    if (__privateGet(this, _state) !== "started") {
      return;
    }
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "paused");
    __privateSet(this, _remainingTime, __privateGet(this, _remainingTime) - ((/* @__PURE__ */ new Date()).getTime() - __privateGet(this, _startTime)));
    this.dispatchEvent(new CustomEvent("player:pause"));
  }
  resume(restartTimer = false) {
    if (__privateGet(this, _state) !== "stopped") {
      if (restartTimer) {
        this.start();
      } else {
        clearTimeout(__privateGet(this, _timer));
        __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
        __privateSet(this, _state, "started");
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
        this.dispatchEvent(new CustomEvent("player:resume"));
      }
    }
  }
  start() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
    __privateSet(this, _state, "started");
    __privateSet(this, _remainingTime, __privateGet(this, _duration));
    __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
    this.dispatchEvent(new CustomEvent("player:start"));
  }
  stop() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "stopped");
    this.dispatchEvent(new CustomEvent("player:stop"));
  }
};
_callback = new WeakMap();
_duration = new WeakMap();
_remainingTime = new WeakMap();
_startTime = new WeakMap();
_timer = new WeakMap();
_state = new WeakMap();
_onVisibilityChangeListener = new WeakMap();
_onVisibilityChange = new WeakSet();
onVisibilityChange_fn = function() {
  if (document.visibilityState === "hidden") {
    this.pause();
  } else if (document.visibilityState === "visible") {
    this.resume();
  }
};

// js/common/actions/confirm-button.js
var ConfirmButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (!window.confirm(this.getAttribute("data-message") ?? "Are you sure you wish to do this?")) {
        event.preventDefault();
      }
    });
  }
};
if (!window.customElements.get("confirm-button")) {
  window.customElements.define("confirm-button", ConfirmButton, { extends: "button" });
}

// js/common/actions/controls.js
var PageDots = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.items = Array.from(this.children);
    this.items.forEach((button, index) => button.addEventListener("click", () => this.select(index), { signal: this._abortController.signal }));
    this.addEventListener("control:filter", this._filterItems, { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("carousel:change", (event) => this.select(event.detail.index, false), { signal: this._abortController.signal });
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.items.indexOf(event.target)));
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
  get selectedIndex() {
    return this.items.findIndex((button) => button.getAttribute("aria-current") === "true");
  }
  select(selectedIndex, dispatchEvent = true) {
    if (this.hasAttribute("align-selected")) {
      this.scrollTo({
        left: this.items[selectedIndex].offsetLeft - this.clientWidth / 2 + this.items[selectedIndex].clientWidth / 2,
        top: this.items[selectedIndex].offsetTop - this.clientHeight / 2 - this.items[selectedIndex].clientHeight / 2,
        behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
      });
    }
    if (this.selectedIndex === selectedIndex) {
      return;
    }
    this.items.forEach((button, index) => button.setAttribute("aria-current", selectedIndex === index ? "true" : "false"));
    if (dispatchEvent) {
      this._dispatchEvent(selectedIndex);
    }
  }
  _filterItems(event) {
    this.items.forEach((item, index) => item.hidden = event.detail.filteredIndexes.includes(index));
  }
  _dispatchEvent(index) {
    (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:select", { bubbles: true, cancelable: true, detail: { index } }));
  }
};
var PrevButton = class extends HTMLButtonElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:prev", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "start", { signal: this._abortController.signal });
      this.controlledElement.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "start" ? false : this.disabled, { signal: this._abortController.signal });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
};
var NextButton = class extends HTMLButtonElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:next", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "end", { signal: this._abortController.signal });
      this.controlledElement.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "end" ? false : this.disabled, { signal: this._abortController.signal });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
};
if (!window.customElements.get("page-dots")) {
  window.customElements.define("page-dots", PageDots);
}
if (!window.customElements.get("prev-button")) {
  window.customElements.define("prev-button", PrevButton, { extends: "button" });
}
if (!window.customElements.get("next-button")) {
  window.customElements.define("next-button", NextButton, { extends: "button" });
}

// js/common/actions/copy-button.js
import { timeline } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var CopyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.append(this.contentElement, this.animationElement);
    this.addEventListener("click", this._copyToClipboard.bind(this));
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__feedback">  
        <svg role="presentation" focusable="false" fill="none" width="18px" height="18px" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
          <path d="m6 9.8 2.63 2.8L14 7" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
    `).firstElementChild;
  }
  async _copyToClipboard() {
    if (!navigator.clipboard) {
      return;
    }
    await navigator.clipboard.writeText(this.getAttribute("data-text") || "");
    timeline([
      [this.contentElement, { y: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15, at: "+0.5" }],
      [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
    ]);
  }
};
if (!window.customElements.get("copy-button")) {
  window.customElements.define("copy-button", CopyButton, { extends: "button" });
}

// js/common/actions/custom-button.js
import { animate, timeline as timeline2, stagger } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var CustomButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    if (this.type === "submit" && this.form) {
      this.form.addEventListener("submit", () => this.setAttribute("aria-busy", "true"));
    }
    this.append(this.contentElement, this.animationElement);
    window.addEventListener("pageshow", () => this.removeAttribute("aria-busy"));
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild;
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === "true") {
      timeline2([
        [this.contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
      animate(this.animationElement.children, { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      timeline2([
        [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
    }
  }
};
if (!window.customElements.get("custom-button")) {
  window.customElements.define("custom-button", CustomButton, { extends: "button" });
}

// js/common/actions/share-button.js
var ShareButton = class extends HTMLButtonElement {
  constructor() {
    super();
    if (navigator.share) {
      this.addEventListener("click", this._showSystemShare);
    }
  }
  _showSystemShare() {
    navigator.share({
      title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
      url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
    });
  }
};
if (!window.customElements.get("share-button")) {
  window.customElements.define("share-button", ShareButton, { extends: "button" });
}

// js/common/animation/heading.js
import { stagger as stagger2 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
function getHeadingKeyframe(element, options = {}) {
  if (!element) {
    return [];
  }
  const splitLines = element.querySelector("split-lines")?.lines;
  if (window.themeVariables.settings.headingApparition === "fade" || !splitLines) {
    return [element, { opacity: [0, 1] }, { duration: 0.2, ...options }];
  } else {
    element.style.opacity = "1";
    switch (window.themeVariables.settings.headingApparition) {
      case "split_fade":
        return [splitLines, { transform: ["translateY(0.5em)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.3, delay: stagger2(0.1), ...options }];
      case "split_clip":
        return [splitLines, { clipPath: ["inset(0 0 100% 0)", "inset(0 0 -0.3em 0)"], transform: ["translateY(100%)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.7, delay: stagger2(0.15), easing: [0.22, 1, 0.36, 1], ...options }];
      case "split_rotation":
        const rotatedSpans = splitLines.map((line) => line.querySelector("span"));
        rotatedSpans.forEach((span) => span.style.transformOrigin = "top left");
        splitLines.forEach((line) => line.style.clipPath = "inset(0 0 -0.3em 0)");
        return [rotatedSpans, { transform: ["translateY(0.5em) rotateZ(5deg)", "translateY(0) rotateZ(0)"], opacity: [0, 1] }, { duration: 0.4, delay: stagger2(0.1), ...options }];
    }
  }
}

// js/common/animation/reveal-items.js
import { animate as animate2, stagger as stagger3, inView } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var _reveal, reveal_fn;
var RevealItems = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _reveal);
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, __privateMethod(this, _reveal, reveal_fn).bind(this), { margin: this.getAttribute("margin") ?? "-50px 0px" });
    }
  }
};
_reveal = new WeakSet();
reveal_fn = function() {
  this.style.opacity = "1";
  animate2(
    this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children,
    { opacity: [0, 1], transform: ["translateY(15px)", "translateY(0)"] },
    { duration: 0.35, delay: stagger3(0.05, { easing: "ease-out" }), easing: "ease" }
  );
};
if (!window.customElements.get("reveal-items")) {
  window.customElements.define("reveal-items", RevealItems);
}

// js/common/behavior/custom-cursor.js
var _abortController, _onPointerLeave, onPointerLeave_fn, _onPointerMove, onPointerMove_fn;
var CustomCursor = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onPointerLeave);
    __privateAdd(this, _onPointerMove);
    __privateAdd(this, _abortController, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController, new AbortController());
    this.parentElement.addEventListener("pointermove", __privateMethod(this, _onPointerMove, onPointerMove_fn).bind(this), { passive: true, signal: __privateGet(this, _abortController).signal });
    this.parentElement.addEventListener("pointerleave", __privateMethod(this, _onPointerLeave, onPointerLeave_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
};
_abortController = new WeakMap();
_onPointerLeave = new WeakSet();
onPointerLeave_fn = function() {
  this.classList.remove("is-visible", "is-half-start", "is-half-end");
};
_onPointerMove = new WeakSet();
onPointerMove_fn = function(event) {
  if (event.target.matches("button, a[href], button :scope, a[href] :scope")) {
    return this.classList.remove("is-visible");
  }
  const parentBoundingRect = this.parentElement.getBoundingClientRect(), parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, isOnStartHalfPart = event.pageX < parentXCenter;
  this.classList.toggle("is-half-start", isOnStartHalfPart);
  this.classList.toggle("is-half-end", !isOnStartHalfPart);
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

// js/common/behavior/gesture-area.js
var _domElement, _thresholdDistance, _thresholdTime, _signal, _firstClientX, _tracking, _start, _touchStart, touchStart_fn, _preventTouch, preventTouch_fn, _gestureStart, gestureStart_fn, _gestureMove, gestureMove_fn, _gestureEnd, gestureEnd_fn;
var GestureArea = class {
  constructor(domElement, { thresholdDistance = 80, thresholdTime = 500, signal = null } = {}) {
    __privateAdd(this, _touchStart);
    __privateAdd(this, _preventTouch);
    __privateAdd(this, _gestureStart);
    __privateAdd(this, _gestureMove);
    __privateAdd(this, _gestureEnd);
    __privateAdd(this, _domElement, void 0);
    __privateAdd(this, _thresholdDistance, void 0);
    __privateAdd(this, _thresholdTime, void 0);
    __privateAdd(this, _signal, void 0);
    __privateAdd(this, _firstClientX, void 0);
    __privateAdd(this, _tracking, false);
    __privateAdd(this, _start, {});
    __privateSet(this, _domElement, domElement);
    __privateSet(this, _thresholdDistance, thresholdDistance);
    __privateSet(this, _thresholdTime, thresholdTime);
    __privateSet(this, _signal, signal);
    __privateGet(this, _domElement).addEventListener("touchstart", __privateMethod(this, _touchStart, touchStart_fn).bind(this), { passive: true, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("touchmove", __privateMethod(this, _preventTouch, preventTouch_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerdown", __privateMethod(this, _gestureStart, gestureStart_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointermove", __privateMethod(this, _gestureMove, gestureMove_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerup", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerleave", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointercancel", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
  }
};
_domElement = new WeakMap();
_thresholdDistance = new WeakMap();
_thresholdTime = new WeakMap();
_signal = new WeakMap();
_firstClientX = new WeakMap();
_tracking = new WeakMap();
_start = new WeakMap();
_touchStart = new WeakSet();
touchStart_fn = function(event) {
  __privateSet(this, _firstClientX, event.touches[0].clientX);
};
_preventTouch = new WeakSet();
preventTouch_fn = function(event) {
  if (Math.abs(event.touches[0].clientX - __privateGet(this, _firstClientX)) > 10) {
    event.preventDefault();
  }
};
_gestureStart = new WeakSet();
gestureStart_fn = function(event) {
  __privateSet(this, _tracking, true);
  __privateSet(this, _start, {
    time: (/* @__PURE__ */ new Date()).getTime(),
    x: event.clientX,
    y: event.clientY
  });
};
_gestureMove = new WeakSet();
gestureMove_fn = function(event) {
  if (__privateGet(this, _tracking)) {
    event.preventDefault();
  }
};
_gestureEnd = new WeakSet();
gestureEnd_fn = function(event) {
  if (!__privateGet(this, _tracking)) {
    return;
  }
  __privateSet(this, _tracking, false);
  const now = (/* @__PURE__ */ new Date()).getTime(), deltaTime = now - __privateGet(this, _start).time, deltaX = event.clientX - __privateGet(this, _start).x, deltaY = event.clientY - __privateGet(this, _start).y;
  if (deltaTime > __privateGet(this, _thresholdTime)) {
    return;
  }
  let matchedEvent;
  if (deltaX === 0 && deltaY === 0 && !event.target.matches("a, button, a :scope, button :scope")) {
    matchedEvent = "tap";
  } else if (deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swiperight";
  } else if (-deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeleft";
  } else if (deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipedown";
  } else if (-deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeup";
  }
  if (matchedEvent) {
    __privateGet(this, _domElement).dispatchEvent(new CustomEvent(matchedEvent, { bubbles: true, composed: true, detail: { originalEvent: event } }));
  }
};

// js/common/behavior/height-observer.js
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateCustomProperties.bind(this)).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) {
      this._writeHeight(this.clientHeight);
    }
    this._publishLiveHeight();
    if (!this._recoverHeight) {
      this._recoverHeight = () => {
        this._publishLiveHeight();
      };
      window.addEventListener("focus", this._recoverHeight);
      document.addEventListener("visibilitychange", this._recoverHeight);
    }
  }
  disconnectedCallback() {
    if (!this._recoverHeight) return;
    window.removeEventListener("focus", this._recoverHeight);
    document.removeEventListener("visibilitychange", this._recoverHeight);
    this._recoverHeight = null;
  }
  _publishLiveHeight(attempt = 0) {
    const liveHeight = this.getBoundingClientRect().height;
    if (liveHeight > 0) {
      this._writeHeight(liveHeight);
      return;
    }
    if (attempt >= 30) return;
    requestAnimationFrame(() => this._publishLiveHeight(attempt + 1));
  }
  _updateCustomProperties(entries) {
    requestAnimationFrame(() => {
      entries.forEach((entry) => {
        if (entry.target !== this) return;
        const height = this._readEntryHeight(entry);
        if (height > 0) {
          this._writeHeight(height);
          return;
        }
        requestAnimationFrame(() => {
          const liveHeight = this.getBoundingClientRect().height;
          if (liveHeight > 0) this._writeHeight(liveHeight);
          else if (document.hasFocus()) this._writeHeight(0, true);
        });
      });
    });
  }
  _readEntryHeight(entry) {
    const borderSize = entry.borderBoxSize;
    const blockSize = borderSize ? borderSize.length > 0 ? borderSize[0].blockSize : borderSize.blockSize : 0;
    const contentHeight = entry.contentRect ? entry.contentRect.height : 0;
    return Math.max(blockSize || 0, contentHeight || 0, this.getBoundingClientRect().height || 0);
  }
  _writeHeight(height, allowZero = false) {
    const name = this.getAttribute("variable");
    if (!name) return;
    const property = `--${name}-height`;
    const next = Math.round(height);
    if (!(next > 0)) {
      const current = parseFloat(document.documentElement.style.getPropertyValue(property));
      if (current > 0 && !allowZero) return;
    }
    document.documentElement.style.setProperty(property, `${next > 0 ? next : 0}px`);
  }
};
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}

// js/common/behavior/safe-sticky.js
import { inView as inView2 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var _resizeObserver, _checkPositionListener, _initialTop, _lastKnownY, _currentTop, _position, _recalculateStyles, recalculateStyles_fn, _checkPosition, checkPosition_fn;
var SafeSticky = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _recalculateStyles);
    __privateAdd(this, _checkPosition);
    __privateAdd(this, _resizeObserver, new ResizeObserver(__privateMethod(this, _recalculateStyles, recalculateStyles_fn).bind(this)));
    __privateAdd(this, _checkPositionListener, throttle(__privateMethod(this, _checkPosition, checkPosition_fn).bind(this)));
    __privateAdd(this, _initialTop, 0);
    __privateAdd(this, _lastKnownY, 0);
    /* we could initialize it to window.scrollY but this avoids a costly reflow */
    __privateAdd(this, _currentTop, 0);
    __privateAdd(this, _position, "relative");
  }
  connectedCallback() {
    inView2(this, () => {
      __privateGet(this, _resizeObserver).observe(this);
      window.addEventListener("scroll", __privateGet(this, _checkPositionListener));
      return () => {
        __privateGet(this, _resizeObserver).unobserve(this);
        window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
      };
    }, { margin: "500px" });
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
  }
};
_resizeObserver = new WeakMap();
_checkPositionListener = new WeakMap();
_initialTop = new WeakMap();
_lastKnownY = new WeakMap();
_currentTop = new WeakMap();
_position = new WeakMap();
_recalculateStyles = new WeakSet();
recalculateStyles_fn = function() {
  this.style.removeProperty("top");
  const computedStyles = getComputedStyle(this);
  __privateSet(this, _initialTop, parseInt(computedStyles.top));
  __privateSet(this, _position, computedStyles.position);
  __privateMethod(this, _checkPosition, checkPosition_fn).call(this);
};
_checkPosition = new WeakSet();
checkPosition_fn = function() {
  if (__privateGet(this, _position) !== "sticky") {
    return this.style.removeProperty("top");
  }
  let bounds = this.getBoundingClientRect(), maxTop = bounds.top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop), minTop = this.clientHeight - window.innerHeight + 20;
  if (window.scrollY < __privateGet(this, _lastKnownY)) {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY)));
  } else {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY));
  }
  __privateSet(this, _currentTop, Math.min(Math.max(__privateGet(this, _currentTop), -minTop), maxTop, __privateGet(this, _initialTop)));
  __privateSet(this, _lastKnownY, window.scrollY);
  this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`;
};
if (!window.customElements.get("safe-sticky")) {
  window.customElements.define("safe-sticky", SafeSticky);
}

// js/common/behavior/scroll-area.js
var ScrollArea = class {
  constructor(element, abortController2 = null) {
    this._element = element;
    this._allowTriggerNearingStartEvent = false;
    this._allowTriggerLeavingStartEvent = true;
    this._allowTriggerNearingEndEvent = true;
    this._allowTriggerLeavingEndEvent = false;
    new ResizeObserver(throttle(this._checkIfScrollable.bind(this))).observe(element);
    this._element.addEventListener("scroll", throttle(this._onScroll.bind(this)), { signal: abortController2?.signal });
  }
  get scrollNearingThreshold() {
    return 125;
  }
  get scrollDirection() {
    if (this._element.scrollWidth > this._element.clientWidth) {
      return "inline";
    } else if (this._element.scrollHeight > this._element.clientHeight) {
      return "block";
    } else {
      return "none";
    }
  }
  _checkIfScrollable() {
    this._element.classList.toggle("is-scrollable", this.scrollDirection !== "none");
  }
  _onScroll() {
    clearTimeout(this._scrollTimeout);
    this._lastScrollPosition = this._lastScrollPosition ?? (this.scrollDirection === "inline" ? Math.abs(this._element.scrollLeft) : Math.abs(this._element.scrollTop));
    let direction;
    if (this.scrollDirection === "inline") {
      direction = this._lastScrollPosition > Math.abs(this._element.scrollLeft) ? "start" : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollLeft);
    } else {
      direction = this._lastScrollPosition > Math.abs(this._element.scrollTop) ? "start" : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollTop);
    }
    const scrollPosition = Math.round(Math.abs(this.scrollDirection === "inline" ? this._element.scrollLeft : this._element.scrollTop)), scrollMinusSize = Math.round(this.scrollDirection === "inline" ? this._element.scrollWidth - this._element.clientWidth : this._element.scrollHeight - this._element.clientHeight);
    if (direction === "start" && this._allowTriggerNearingStartEvent && scrollPosition <= this.scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = false;
      this._allowTriggerLeavingStartEvent = true;
      this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "start" } }));
    } else if (direction === "end" && scrollPosition > this.scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = true;
      if (this._allowTriggerLeavingStartEvent) {
        this._allowTriggerLeavingStartEvent = false;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "start" } }));
      }
    }
    if (direction === "end" && this._allowTriggerNearingEndEvent && scrollMinusSize <= scrollPosition + this.scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = false;
      this._allowTriggerLeavingEndEvent = true;
      this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "end" } }));
    } else if (direction === "start" && scrollMinusSize > scrollPosition + this.scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = true;
      if (this._allowTriggerLeavingEndEvent) {
        this._allowTriggerLeavingEndEvent = false;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "end" } }));
      }
    }
    if (window.onscrollend === void 0) {
      this._scrollTimeout = setTimeout(() => {
        this._element.dispatchEvent(new CustomEvent("scrollend", { bubbles: true, composed: true }));
      }, 75);
    }
  }
};

// js/common/behavior/scroll-progress.js
var ScrollProgress = class extends HTMLElement {
  connectedCallback() {
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }
  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
  }
  _updateScrollProgress() {
    const scrollLeft = document.dir === "ltr" ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft), advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
    this.style.setProperty("--scroll-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
  }
};
if (!window.customElements.get("scroll-progress")) {
  window.customElements.define("scroll-progress", ScrollProgress);
}

// js/common/behavior/scroll-shadow.js
var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      display: var(--scroll-shadow-display, block);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, linear-gradient(to bottom, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-bottom, linear-gradient(to top, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-left, linear-gradient(to right, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-right, linear-gradient(to left, rgb(var(--background)), rgb(var(--background) / 0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`;
var Updater = class {
  constructor(targetElement) {
    this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
  }
  start(element) {
    if (this.element) {
      this.stop();
    }
    if (element) {
      element.addEventListener("scroll", this.scheduleUpdate);
      this.resizeObserver.observe(element);
      this.element = element;
    }
  }
  stop() {
    if (!this.element) {
      return;
    }
    this.element.removeEventListener("scroll", this.scheduleUpdate);
    this.resizeObserver.unobserve(this.element);
    this.element = null;
  }
  update(targetElement, style) {
    if (!this.element) {
      return;
    }
    const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
    const scroll2 = {
      top: Math.max(this.element.scrollTop, 0),
      bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
      left: Math.max(this.element.scrollLeft, 0),
      right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
    };
    requestAnimationFrame(() => {
      for (const position of ["top", "bottom", "left", "right"]) {
        targetElement.style.setProperty(
          `--${position}`,
          `${scroll2[position] > maxSize ? maxSize : scroll2[position]}px`
        );
      }
    });
  }
};
var ScrollShadow = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).innerHTML = template;
    this.updater = new Updater(this.shadowRoot.lastElementChild);
  }
  connectedCallback() {
    this.shadowRoot.querySelector("slot").addEventListener("slotchange", this.start);
    this.start();
  }
  disconnectedCallback() {
    this.updater.stop();
  }
  start() {
    if (this.firstElementChild) {
      this.updater.start(this.firstElementChild);
    }
  }
};
if ("ResizeObserver" in window && !window.customElements.get("scroll-shadow")) {
  window.customElements.define("scroll-shadow", ScrollShadow);
}

// js/common/behavior/split-lines.js
var _requireSplit, _lastScreenWidth, _split, split_fn, _onWindowResized, onWindowResized_fn;
var SplitLines = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _split);
    __privateAdd(this, _onWindowResized);
    __privateAdd(this, _requireSplit, true);
    __privateAdd(this, _lastScreenWidth, window.innerWidth);
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment("<slot></slot>"));
    window.addEventListener("resize", throttle(__privateMethod(this, _onWindowResized, onWindowResized_fn).bind(this)));
    new MutationObserver(__privateMethod(this, _split, split_fn).bind(this, true)).observe(this, { characterData: true, attributes: false, childList: false, subtree: true });
  }
  connectedCallback() {
    __privateMethod(this, _split, split_fn).call(this);
  }
  get lines() {
    return Array.from(this.shadowRoot.children);
  }
};
_requireSplit = new WeakMap();
_lastScreenWidth = new WeakMap();
_split = new WeakSet();
split_fn = function(force = false) {
  if (!__privateGet(this, _requireSplit) && !force) {
    return;
  }
  this.shadowRoot.innerHTML = this.textContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
  const bounds = /* @__PURE__ */ new Map();
  Array.from(this.shadowRoot.children).forEach((letter) => {
    const key = Math.round(letter.getBoundingClientRect().top);
    bounds.set(key, (bounds.get(key) || "").concat(letter.textContent));
  });
  this.shadowRoot.replaceChildren(...Array.from(bounds.values(), (line) => document.createRange().createContextualFragment(`
      <span style="display: inline-block;">
        <span style="display: block">${line}</span>
      </span>
    `)));
  __privateSet(this, _requireSplit, false);
};
_onWindowResized = new WeakSet();
onWindowResized_fn = function() {
  if (__privateGet(this, _lastScreenWidth) === window.innerWidth) {
    return;
  }
  __privateMethod(this, _split, split_fn).call(this, true);
  __privateSet(this, _lastScreenWidth, window.innerWidth);
};
if (!window.customElements.get("split-lines")) {
  window.customElements.define("split-lines", SplitLines);
}

// js/common/behavior/visibility-progress.js
import { scroll } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var VisibilityProgress = class extends HTMLElement {
  connectedCallback() {
    scroll((info) => {
      this.style.setProperty("--visibility-progress", info.y.progress);
    }, {
      target: this,
      offset: ["start end", "end start"]
    });
  }
};
if (!window.customElements.get("visibility-progress")) {
  window.customElements.define("visibility-progress", VisibilityProgress);
}

// js/common/carousel/effect-carousel.js
import { timeline as timeline3, inView as inView3 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";

// js/common/carousel/base-carousel.js
var BaseCarousel = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this._reloaded = false;
    if (Shopify.designMode) {
      this.closest(".shopify-section").addEventListener("shopify:section:select", (event) => this._reloaded = event.detail.load);
    }
    if (this.items.length > 1) {
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          let index = this.items.indexOf(event.target);
          if (index < 0) {
            const selector = this.getAttribute("selector");
            const slide = selector ? event.target.closest(selector) : event.target.closest(":scope > *");
            if (slide) {
              index = this.items.indexOf(slide);
            }
          }
          if (index >= 0) {
            this.select(index, { animate: !event.detail.load });
          }
        });
      }
      if (this.hasAttribute("adaptive-height")) {
        this.addEventListener("carousel:settle", this._adjustHeight);
        this._adjustHeight();
      }
      this.addEventListener("carousel:select", this._preloadImages, { signal: this._abortController.signal });
      this.addEventListener("carousel:filter", this._filterItems, { signal: this._abortController.signal });
      this.addEventListener("control:prev", this.previous, { signal: this._abortController.signal });
      this.addEventListener("control:next", this.next, { signal: this._abortController.signal });
      this.addEventListener("control:select", (event) => this.select(event.detail.index), { signal: this._abortController.signal });
    }
    if (this.selectedIndex === 0) {
      this._dispatchEvent("carousel:select", 0);
    } else {
      this.select(this.selectedIndex, { animate: false, force: true });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get items() {
    if (this.hasAttribute("reversed")) {
      return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children).reverse();
    } else {
      return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children);
    }
  }
  get visibleItems() {
    return this.items.filter((item) => item.offsetParent !== null);
  }
  get selectedIndex() {
    return this._selectedIndex = this._selectedIndex ?? parseInt(this.getAttribute("initial-index") || 0);
  }
  get selectedIndexAmongVisible() {
    return this.visibleItems.indexOf(this.selectedSlide);
  }
  get loop() {
    return false;
  }
  get selectedSlide() {
    return this.items[this.selectedIndex];
  }
  get previousSlide() {
    return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible - 1 + this.visibleItems.length) % this.visibleItems.length : Math.max(this.selectedIndexAmongVisible - 1, 0)];
  }
  get nextSlide() {
    return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible + 1 + this.visibleItems.length) % this.visibleItems.length : Math.min(this.selectedIndexAmongVisible + 1, this.visibleItems.length - 1)];
  }
  previous(animate11 = true) {
    this.select(this.items.indexOf(this.previousSlide), { direction: "previous", animate: animate11 });
  }
  next(animate11 = true) {
    this.select(this.items.indexOf(this.nextSlide), { direction: "next", animate: animate11 });
  }
  _transitionTo(fromSlide, toSlide, options = {}) {
  }
  _adjustHeight() {
    if (this.hasAttribute("adaptive-height") && this.selectedSlide.clientHeight !== this.clientHeight) {
      this.style.maxHeight = `${this.selectedSlide.clientHeight}px`;
    }
  }
  _filterItems(event) {
    this.items.forEach((item, index) => item.hidden = event.detail.filteredIndexes.includes(index));
  }
  _preloadImages() {
    [this.previousSlide, this.nextSlide].forEach((item) => {
      if (item) {
        Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
      }
    });
  }
  _dispatchEvent(eventName, index) {
    this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { slide: this.items[index], index } }));
  }
};

// js/common/carousel/effect-carousel.js
var EffectCarousel = class extends BaseCarousel {
  connectedCallback() {
    super.connectedCallback();
    if (this.items.length > 1) {
      if (this.swipeable) {
        new GestureArea(this, { signal: this._abortController.signal });
        this.addEventListener("swipeleft", this.next, { signal: this._abortController.signal });
        this.addEventListener("swiperight", this.previous, { signal: this._abortController.signal });
      }
      if (this.hasAttribute("autoplay")) {
        this._player = new Player(this.getAttribute("autoplay"));
        this._player.addEventListener("player:end", this.next.bind(this));
        inView3(this, () => this._player.resume(true));
        if (Shopify.designMode) {
          this.addEventListener("shopify:block:select", () => this._player.stop(), { signal: this._abortController.signal });
          this.addEventListener("shopify:block:deselect", () => this._player.start(), { signal: this._abortController.signal });
        }
      }
    }
  }
  get player() {
    return this._player;
  }
  get loop() {
    return true;
  }
  get swipeable() {
    return this.getAttribute("swipeable") !== "false";
  }
  async select(index, { direction, animate: animate11 = true } = {}) {
    const indexBeforeChange = this.selectedIndex;
    this._selectedIndex = index;
    this._dispatchEvent("carousel:select", index);
    if (!direction) {
      direction = index > indexBeforeChange ? "next" : "previous";
    }
    if (index !== indexBeforeChange) {
      const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
      this._dispatchEvent("carousel:change", index);
      this.player?.pause();
      await this._transitionTo(fromSlide, toSlide, { direction, animate: animate11 });
      this.player?.resume(true);
      this._dispatchEvent("carousel:settle", index);
    }
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate11 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    const timelineControls = timeline3([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { at: "<", zIndex: { easing: "step-end" } }]
    ], { duration: animate11 ? 0.3 : 0 });
    return timelineControls.finished;
  }
};
if (!window.customElements.get("effect-carousel")) {
  window.customElements.define("effect-carousel", EffectCarousel);
}

// js/common/carousel/scroll-carousel.js
var ScrollCarousel = class extends BaseCarousel {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(this._adjustHeight.bind(this))).observe(this);
    }
  }
  connectedCallback() {
    this._hasPendingProgrammaticScroll = false;
    this._scrollArea = new ScrollArea(this, this._abortController);
    super.connectedCallback();
    this.addEventListener("scroll", throttle(this._onCarouselScroll.bind(this)), { signal: this._abortController.signal });
    this.addEventListener("scrollend", this._onScrollSettled, { signal: this._abortController.signal });
  }
  get itemOffset() {
    return this.visibleItems.length < 2 ? 0 : this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
  }
  get slidesPerPage() {
    return this.visibleItems.length < 2 ? 1 : Math.floor((this.clientWidth - this.visibleItems[0].offsetLeft) / (Math.abs(this.itemOffset) - (parseInt(getComputedStyle(this).gap) || 0)));
  }
  get totalPages() {
    return this.visibleItems.length < 2 ? 1 : this.visibleItems.length - this.slidesPerPage + 1;
  }
  select(index, { animate: animate11 = true, force = false } = {}) {
    const indexBeforeChange = this.selectedIndex;
    if (!this.offsetParent || this._scrollArea.scrollDirection === "none") {
      return this._selectedIndex = index;
    }
    const indexAmongVisible = this.visibleItems.indexOf(this.items[index]);
    index = this.items.indexOf(this.visibleItems[Math.min(this.totalPages, indexAmongVisible)]);
    this._selectedIndex = index;
    this._dispatchEvent("carousel:select", index);
    if (index !== indexBeforeChange || force) {
      const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
      this._dispatchEvent("carousel:change", index);
      this._transitionTo(fromSlide, toSlide, { animate: animate11 });
    }
  }
  /**
   * Transition using the scrollTo method. To prevent the intersection observer to caught up the change, we set up
   * a "hasPendingProgrammaticScroll" variable to true, that is set back to false once the scroll has settled
   */
  _transitionTo(fromSlide, toSlide, { animate: animate11 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let slideAlign = this._extractSlideAlign(toSlide), scrollAmount = 0;
    switch (slideAlign) {
      case "start":
        scrollAmount = this.itemOffset * this.visibleItems.indexOf(toSlide);
        break;
      case "center":
        scrollAmount = toSlide.offsetLeft - (this.clientWidth / 2 - (parseInt(getComputedStyle(this).scrollPaddingInline) || 0)) + toSlide.clientWidth / 2;
        break;
    }
    this._hasPendingProgrammaticScroll = animate11;
    this.scrollTo({ left: scrollAmount, behavior: animate11 ? "smooth" : "auto" });
  }
  /**
   * Update the index when manually scrolling (which allows to update the controls)
   */
  _onCarouselScroll() {
    if (this._hasPendingProgrammaticScroll || this._scrollArea.scrollDirection === "none") {
      return;
    }
    const newIndex = this.items.indexOf(this.visibleItems[Math.round(this.scrollLeft / this.itemOffset)]);
    if (newIndex !== this.selectedIndex) {
      this._selectedIndex = newIndex;
      this._dispatchEvent("carousel:select", this.selectedIndex);
      this._dispatchEvent("carousel:change", this.selectedIndex);
    }
  }
  /**
   * On the scroll has settled we dispatch the event (which covers both programmatic scroll and swipe)
   */
  _onScrollSettled() {
    this._hasPendingProgrammaticScroll = false;
    this._dispatchEvent("carousel:settle", this.selectedIndex);
  }
  _adjustHeight() {
    this.style.maxHeight = null;
    if (this._scrollArea.scrollDirection !== "none") {
      super._adjustHeight();
    }
  }
  _extractSlideAlign(slide) {
    return getComputedStyle(slide).scrollSnapAlign === "center" ? "center" : "start";
  }
};
if (!window.customElements.get("scroll-carousel")) {
  window.customElements.define("scroll-carousel", ScrollCarousel);
}

// js/common/cart/cart-count.js
import { animate as animate3 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";

// js/common/cart/fetch-cart.js
var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var fetchCart = createCartPromise();
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail["cart"];
});
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});

// js/common/cart/cart-count.js
var CartCount = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<span><slot></slot></span>"));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    document.addEventListener("cart:change", (event) => this.itemCount = event.detail["cart"]["item_count"], { signal: this._abortController.signal });
    document.addEventListener("cart:refresh", this._updateFromServer.bind(this), { signal: this._abortController.signal });
    window.addEventListener("pageshow", this._updateFromServer.bind(this));
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  async _updateFromServer() {
    this.itemCount = (await fetchCart)["item_count"];
  }
  get itemCount() {
    return parseInt(this.innerText);
  }
  set itemCount(count) {
    if (this.itemCount === count) {
      return;
    }
    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      this.innerText = count;
    } else if (this.itemCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      this.innerText = count;
    } else {
      (async () => {
        await animate3(this.shadowRoot.firstElementChild, { transform: ["translateY(-50%)"], opacity: 0 }, { duration: 0.25, easing: [1, 0, 0, 1] }).finished;
        this.innerText = count;
        animate3(this.shadowRoot.firstElementChild, { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 }, { duration: 0.25, easing: [1, 0, 0, 1] });
      })();
    }
  }
};
if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

// js/common/cart/cart-drawer.js
import { animate as animate4 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";

// js/common/overlay/dialog-element.js
import { FocusTrap, Delegate } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var _lockLayerCount, _isLocked;
var _DialogElement = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _isLocked, false);
    this.addEventListener("dialog:force-close", (event) => {
      this.hide();
      event.stopPropagation();
    });
  }
  static get observedAttributes() {
    return ["id", "open"];
  }
  connectedCallback() {
    if (this.id) {
      this.delegate.off().on("click", `[aria-controls="${this.id}"]`, this._onToggleClicked.bind(this));
    }
    this._abortController = new AbortController();
    this.setAttribute("role", "dialog");
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load), { signal: this._abortController.signal });
      this.addEventListener("shopify:block:deselect", this.hide, { signal: this._abortController.signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("handle-section-events")) {
          this._shopifySection.addEventListener("shopify:section:select", (event) => this.show(!event.detail.load), { signal: this._abortController.signal });
          this._shopifySection.addEventListener("shopify:section:deselect", this.hide.bind(this), { signal: this._abortController.signal });
        }
        this._shopifySection.addEventListener("shopify:section:unload", () => this.remove(), { signal: this._abortController.signal });
      }
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
    this.delegate.off();
    this.focusTrap?.deactivate({ onDeactivate: false });
    if (__privateGet(this, _isLocked)) {
      __privateSet(this, _isLocked, false);
      document.documentElement.classList.toggle("lock", --__privateWrapper(_DialogElement, _lockLayerCount)._ > 0);
    }
  }
  show(animate11 = true) {
    if (this.open) {
      return;
    }
    this.setAttribute("open", animate11 ? "" : "immediate");
    return waitForEvent(this, "dialog:after-show");
  }
  hide() {
    if (!this.open) {
      return;
    }
    this.removeAttribute("open");
    return waitForEvent(this, "dialog:after-hide");
  }
  get delegate() {
    return this._delegate = this._delegate || new Delegate(document.body);
  }
  get controls() {
    return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`));
  }
  get open() {
    return this.hasAttribute("open");
  }
  get shouldTrapFocus() {
    return true;
  }
  get shouldLock() {
    return false;
  }
  /**
   * Sometimes (especially for drawer) we need to ensure that an element is on top of everything else. To do that,
   * we need to move the element to the body. We are doing that on open, and then restore the initial position on
   * close
   */
  get shouldAppendToBody() {
    return false;
  }
  get initialFocus() {
    if (this.hasAttribute("initial-focus")) {
      const selector = this.getAttribute("initial-focus");
      const initialFocusTarget = selector ? this.querySelector(selector) || this.shadowRoot?.querySelector(selector) : null;
      if (initialFocusTarget) {
        return initialFocusTarget;
      }
    }
    return this.hasAttribute("tabindex") ? this : this.querySelector('input:not([type="hidden"])') || false;
  }
  get preventScrollWhenTrapped() {
    return true;
  }
  get focusTrap() {
    return this._focusTrap = this._focusTrap || new FocusTrap.createFocusTrap([this, this.shadowRoot], {
      onDeactivate: this.hide.bind(this),
      allowOutsideClick: this._allowOutsideClick.bind(this),
      initialFocus: window.matchMedia("screen and (pointer: fine)").matches ? this.initialFocus : false,
      fallbackFocus: this,
      preventScroll: this.preventScrollWhenTrapped
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "id":
        if (newValue) {
          this.delegate.off().on("click", `[aria-controls="${this.id}"]`, this._onToggleClicked.bind(this));
        }
        break;
      case "open":
        this.controls.forEach((toggle) => toggle.setAttribute("aria-expanded", newValue === null ? "false" : "true"));
        if (oldValue === null && (newValue === "" || newValue === "immediate")) {
          this.removeAttribute("inert");
          this._originalParentBeforeAppend = null;
          if (this.shouldAppendToBody && this.parentElement !== document.body) {
            this._originalParentBeforeAppend = this.parentElement;
            document.body.append(this);
          }
          const showTransitionPromise = this._showTransition(newValue !== "immediate") || Promise.resolve();
          showTransitionPromise.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:after-show", { bubbles: true }));
          });
          if (this.shouldTrapFocus) {
            this.focusTrap.activate({
              checkCanFocusTrap: () => showTransitionPromise
            });
          }
          if (this.shouldLock) {
            __privateSet(_DialogElement, _lockLayerCount, __privateGet(_DialogElement, _lockLayerCount) + 1);
            __privateSet(this, _isLocked, true);
            document.documentElement.classList.add("lock");
          }
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute("inert", "");
          const hideTransitionPromise = this._hideTransition() || Promise.resolve();
          hideTransitionPromise.then(() => {
            if (this.parentElement === document.body && this._originalParentBeforeAppend) {
              this._originalParentBeforeAppend.appendChild(this);
              this._originalParentBeforeAppend = null;
            }
            this.dispatchEvent(new CustomEvent("dialog:after-hide", { bubbles: true }));
          });
          this.focusTrap?.deactivate({
            checkCanReturnFocus: () => hideTransitionPromise
          });
          if (this.shouldLock) {
            __privateSet(this, _isLocked, false);
            document.documentElement.classList.toggle("lock", --__privateWrapper(_DialogElement, _lockLayerCount)._ > 0);
          }
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        break;
    }
  }
  /* Those methods are used to perform custom show/hide transition, and must return a promise */
  _showTransition(animate11 = true) {
  }
  _hideTransition() {
  }
  /* By default, a focus element is deactivated when you click outside it */
  _allowOutsideClick(event) {
    if ("TouchEvent" in window && event instanceof TouchEvent) {
      return this._allowOutsideClickTouch(event);
    } else {
      return this._allowOutsideClickMouse(event);
    }
  }
  _allowOutsideClickTouch(event) {
    event.target.addEventListener("touchend", (subEvent) => {
      const endTarget = document.elementFromPoint(subEvent.changedTouches.item(0).clientX, subEvent.changedTouches.item(0).clientY);
      if (!this.contains(endTarget)) {
        this.hide();
      }
    }, { once: true });
    return false;
  }
  _allowOutsideClickMouse(event) {
    if (event.type !== "click") {
      return false;
    }
    if (!this.contains(event.target)) {
      this.hide();
    }
    let target = event.target, closestControl = event.target.closest("[aria-controls]");
    if (closestControl && closestControl.getAttribute("aria-controls") === this.id) {
      target = closestControl;
    }
    return this.id !== target.getAttribute("aria-controls");
  }
  _onToggleClicked(event) {
    event?.preventDefault();
    this.open ? this.hide() : this.show();
  }
};
var DialogElement = _DialogElement;
_lockLayerCount = new WeakMap();
_isLocked = new WeakMap();
__privateAdd(DialogElement, _lockLayerCount, 0);
var CloseButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true })));
  }
};
if (!window.customElements.get("dialog-element")) {
  window.customElements.define("dialog-element", DialogElement);
}
if (!window.customElements.get("close-button")) {
  window.customElements.define("close-button", CloseButton, { extends: "button" });
}

// js/common/overlay/drawer.js
import { animate as motionAnimate, timeline as motionTimeline } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var reduceDrawerAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches || JSON.parse("false");
var Drawer = class extends DialogElement {
  constructor() {
    super();
    const template2 = document.getElementById(this.template).content.cloneNode(true);
    this.attachShadow({ mode: "open" }).appendChild(template2);
    this.shadowRoot.addEventListener("slotchange", (event) => this._updateSlotVisibility(event.target));
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => this._updateSlotVisibility(slot));
  }
  get template() {
    return this.getAttribute("template") || "drawer-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return true;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "bottom" : this.getAttribute("open-from") || "right";
  }
  _getClipPathProperties() {
    switch (this.openFrom) {
      case "left":
        return document.dir === "ltr" ? ["inset(0 100% 0 0 round 8px)", "inset(0 0 0 0 round 8px"] : ["inset(0 0 0 100% round 8px)", "inset(0 0 0 0 round 8px"];
      case "right":
        return document.dir === "ltr" ? ["inset(0 0 0 100% round 8px)", "inset(0 0 0 0 round 8px"] : ["inset(0 100% 0 0 round 8px)", "inset(0 0 0 0 round 8px"];
      case "bottom":
        return ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"];
      case "top":
        return ["inset(0 0 100% 0 round 8px)", "inset(0 0 0 0 round 8px"];
    }
  }
  _setInitialPosition() {
    this.style.left = document.dir === "ltr" && this.openFrom === "left" || document.dir === "rtl" && this.openFrom === "right" ? "0px" : null;
    this.style.right = this.style.left === "" ? "0px" : null;
    this.style.bottom = this.openFrom === "bottom" ? "0px" : null;
    this.style.top = this.style.bottom === "" ? "0px" : null;
  }
  _showTransition(animate11 = true) {
    let animationControls;
    this._setInitialPosition();
    if (reduceDrawerAnimation) {
      animationControls = motionAnimate(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 });
    } else {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: this._getClipPathProperties() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    }
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }
  _hideTransition() {
    let animationControls;
    if (reduceDrawerAnimation) {
      animationControls = motionAnimate(this, { opacity: [1, 0], visibility: ["visibility", "hidden"] }, { duration: 0.2 });
    } else {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: this._getClipPathProperties().reverse() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    }
    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
  _updateSlotVisibility(slot) {
    if (!["header", "footer", "body"].includes(slot.name)) {
      return;
    }
    slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
  }
};
if (!window.customElements.get("x-drawer")) {
  window.customElements.define("x-drawer", Drawer);
}

// js/common/overlay/popover.js
import { animate as motionAnimate2, timeline as motionTimeline2 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var Popover = class extends DialogElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.getElementById(this.template).content.cloneNode(true));
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    this.controls.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    if (this.hasAttribute("close-on-listbox-select")) {
      this.addEventListener("listbox:select", this.hide, { signal: this._abortController.signal });
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open") {
      if (newValue === null) {
        this._unlockScroll();
      } else {
        this._lockScroll();
      }
    }
  }
  get template() {
    return this.getAttribute("template") || "popover-default-template";
  }
  get shouldLock() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get shouldAppendToBody() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get anchor() {
    return {
      vertical: this.getAttribute("anchor-vertical") || "start",
      horizontal: this.getAttribute("anchor-horizontal") || "end"
    };
  }
  _lockScroll() {
    if (window.matchMedia("screen and (min-width: 1000px)").matches) {
      document.documentElement.classList.add("globalnav-noscroll");
    }
  }
  _unlockScroll() {
    document.documentElement.classList.remove("globalnav-noscroll");
  }
  _showTransition(animate11 = true) {
    let animationControls, content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    this.style.display = "block";
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      this.style.left = "0px";
      this.style.right = null;
      this.style.bottom = "0px";
      this.style.top = null;
      animationControls = motionTimeline2([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    } else {
      let spacingBlockValue = "var(--popover-anchor-block-spacing)", spacingInlineValue = "var(--popover-anchor-inline-spacing)";
      this.style.left = this.anchor.horizontal === "start" ? spacingInlineValue : null;
      this.style.right = this.anchor.horizontal === "end" ? spacingInlineValue : null;
      if (this.anchor.vertical === "center") {
        this.style.top = `calc(50% - ${parseInt(this.clientHeight / 2)}px)`;
        this.style.bottom = null;
      } else {
        this.style.top = this.anchor.vertical === "end" ? `calc(100% + ${spacingBlockValue})` : null;
        this.style.bottom = this.anchor.vertical === "start" ? `calc(100% + ${spacingBlockValue})` : null;
      }
      animationControls = motionTimeline2([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: "none" }, { at: "<", duration: 0 }],
        [content.children, { opacity: 1 }, { at: "<", duration: 0 }]
      ]);
    }
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished;
  }
  _hideTransition() {
    let animationControls;
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline2([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: [null, "inset(100% 0 0 0 round 8px)"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    } else {
      animationControls = motionAnimate2(this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 });
    }
    
    // 隐藏弹窗时，将 title 复原
    const title = this.getAttribute("default-title");
    if (title) {
      setTimeout(() => {
        this.querySelector(".dialog-title-text").textContent = title;
      }, 400);
    }
    
    return animationControls.finished.then(() => {
      this.style.display = "none";
      // Openers may switch the dialog layout (data-layout="overview" in #product-info-dialog); reset it once closed.
      if (!this.open) {
        this.removeAttribute("data-layout");
      }
    });
  }
};
if (!window.customElements.get("x-popover")) {
  window.customElements.define("x-popover", Popover);
}

// js/common/overlay/privacy-bar.js
import { Delegate as Delegate2 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var PrivacyBar = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate2(this);
    window.Shopify.loadFeatures([{
      name: "consent-tracking-api",
      version: "0.1",
      onLoad: this._onConsentLibraryLoaded.bind(this)
    }]);
    if (Shopify.designMode) {
      const section = this.closest(".shopify-section");
      section.addEventListener("shopify:section:select", this.show.bind(this));
      section.addEventListener("shopify:section:deselect", this.hide.bind(this));
    }
  }
  connectedCallback() {
    this._delegate.on("click", '[data-action="accept"]', this._acceptPolicy.bind(this));
    this._delegate.on("click", '[data-action="decline"]', this._declinePolicy.bind(this));
    this._delegate.on("click", '[data-action="close"]', this.hide.bind(this));
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  show() {
    this.hidden = false;
  }
  hide() {
    this.hidden = true;
  }
  _onConsentLibraryLoaded() {
    if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
      this.show();
    }
  }
  _acceptPolicy() {
    window.Shopify.customerPrivacy.setTrackingConsent(true, this.hide.bind(this));
  }
  _declinePolicy() {
    window.Shopify.customerPrivacy.setTrackingConsent(false, this.hide.bind(this));
  }
};
if (!window.customElements.get("privacy-bar")) {
  window.customElements.define("privacy-bar", PrivacyBar);
}

// js/common/cart/cart-drawer.js
var CartDrawer = class extends Drawer {
  constructor() {
    super();
    this._onPrepareBundledSectionsListener = this._onPrepareBundledSections.bind(this);
    this._onCartChangedListener = this._onCartChanged.bind(this);
    this._onCartRefreshListener = this._onCartRefresh.bind(this);
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
    window.addEventListener("pageshow", this._onPageShow.bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("cart:prepare-bundled-sections", this._onPrepareBundledSectionsListener);
    document.addEventListener("cart:change", this._onCartChangedListener);
    document.addEventListener("cart:refresh", this._onCartRefreshListener);
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("cart:prepare-bundled-sections", this._onPrepareBundledSectionsListener);
    document.removeEventListener("cart:change", this._onCartChangedListener);
    document.removeEventListener("cart:refresh", this._onCartRefreshListener);
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return "right";
  }
  _getClipPathProperties() {
    return super._getClipPathProperties().map((value) => value.replaceAll(" round 8px", ""));
  }
  _onPrepareBundledSections(event) {
    event.detail.sections.push(extractSectionId(this));
  }
  /**
   * Update the cart drawer content when cart content changes.
   */
  async _onCartChanged(event) {
    const klarnaCartDrawer = document.querySelector('#shopify-osm-klarna-cart-drawer');
    if(event.detail.cart && klarnaCartDrawer) {
      klarnaCartDrawer.dataset.purchaseAmount = event.detail.cart.total_price;
    }

    const updatedDrawerContent = new DOMParser().parseFromString(event.detail.cart["sections"][extractSectionId(this)], "text/html");
    if (event.detail.cart["item_count"] > 0) {
      const currentLineItemsElement = this.querySelector(".cart-drawer__line-items"), updatedLineItemsElement = updatedDrawerContent.querySelector(".cart-drawer__line-items");
      if (!currentLineItemsElement) {
        this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
      } else {
        const shouldUpdateLineItemsImmediately =
          event.detail.baseEvent === "variant:add" || event.detail.baseEvent === "line-item:change";
        if (shouldUpdateLineItemsImmediately) {
          currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
        } else {
          setTimeout(() => {
            currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
          }, 1250);
        }
        this.querySelector('[slot="footer"]').replaceChildren(...updatedDrawerContent.querySelector('[slot="footer"]').childNodes);
      }
    } else {
      await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
      this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
      const emptyState = this.querySelector(".empty-state");
      if (emptyState) {
        animate4(emptyState, { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
      }
    }
  }
  /**
   * Handle the case when the page is served from BF cache
   */
  _onPageShow(event) {
    if (!event.persisted) {
      return;
    }
    this._onCartRefresh();
  }
  /**
   * Listeners called when a new variant has been added
   */
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "drawer" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    this.show();
  }
  /**
   * Force a complete refresh of the cart drawer (this is called by dispatching the 'cart:refresh' on the document)
   */
  async _onCartRefresh() {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = await (await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)).text();
    this.replaceChildren(...tempDiv.querySelector("#cart-drawer").children);
  }
};
var CartNotificationDrawer = class extends Drawer {
  constructor() {
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
  async hide() {
    super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "popover" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    const tempContent = document.createElement("div");
    tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    this.replaceChildren(...tempContent.querySelector(".shopify-section").children);
    this.show();
  }
};
var LineItem = class extends HTMLElement {
  connectedCallback() {
    this.pillLoaderElement = this.querySelector("pill-loader");
    this.addEventListener("line-item:will-change", this._onWillChange.bind(this));
    this.addEventListener("line-item:change", this._onChanged.bind(this));
  }
  _onWillChange() {
    this.pillLoaderElement.setAttribute("aria-busy", "true");
  }
  async _onChanged(event) {
    this.pillLoaderElement.removeAttribute("aria-busy");
    if (event.detail.cart["item_count"] === 0 || event.detail.quantity !== 0) {
      return;
    }
    let marginCompensation = 0;
    if (this.nextElementSibling) {
      marginCompensation = `-${getComputedStyle(this.nextElementSibling).paddingTop}`;
    }
    await animate4(this, { height: [`${this.clientHeight}px`, 0], marginBottom: [0, marginCompensation], overflow: "hidden", opacity: [1, 0] }, { duration: 0.2, easing: "ease" }).finished;
    this.remove();
  }
};
if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}
if (!window.customElements.get("cart-notification-drawer")) {
  window.customElements.define("cart-notification-drawer", CartNotificationDrawer);
}
if (!window.customElements.get("line-item")) {
  window.customElements.define("line-item", LineItem);
}

// js/common/cart/cart-note.js
var CartNote = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.getAttribute("name") !== "note") {
      return;
    }
    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: event.target.value }),
      keepalive: true
      // Allows to make sure the request is fired even when submitting the form
    });
  }
};
var CartNoteDialog = class extends DialogElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.value === "") {
      this.controls.forEach((control) => control.innerHTML = `<span class="link text-sm cart-drawer__note-trigger">${window.themeVariables.strings.addOrderNote}</span>`);
    } else {
      this.controls.forEach((control) => control.innerHTML = `<span class="link text-sm cart-drawer__note-trigger">${window.themeVariables.strings.editOrderNote}</span>`);
    }
  }
};
if (!window.customElements.get("cart-note")) {
  window.customElements.define("cart-note", CartNote);
}
if (!window.customElements.get("cart-note-dialog")) {
  window.customElements.define("cart-note-dialog", CartNoteDialog);
}

// js/common/cart/free-shipping-bar.js
var FreeShippingBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  async connectedCallback() {
    this.threshold = Math.round(this.threshold * (Shopify.currency.rate || 1));
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "threshold":
        progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
  }
  _updateMessage() {
    const messageElement = this.querySelector("span");
    if (this.totalPrice >= this.threshold) {
      messageElement.innerHTML = this.getAttribute("reached-message");
    } else {
      const replacement = `<span class="bold text-accent">${formatMoney(this.threshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
      messageElement.innerHTML = this.getAttribute("unreached-message").replace(new RegExp("({{.*}})", "g"), replacement);
    }
  }
  _onCartChanged(event) {
    const priceForItems = event.detail["cart"]["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0), cartDiscount = event.detail["cart"]["cart_level_discount_applications"].reduce((sum, discountAllocation) => sum + discountAllocation["total_allocated_amount"], 0);
    this.totalPrice = priceForItems - cartDiscount;
  }
};
if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}

// js/common/cart/line-item-quantity.js
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onQuantityChanged);
    this.addEventListener("click", this._onRemoveLinkClicked);
  }
  _onQuantityChanged(event) {
    if (this._pendingChange || !event.target.hasAttribute("data-line-key")) {
      return;
    }
    this._changeLineItemQuantity(event.target.getAttribute("data-line-key"), parseInt(event.target.value));
  }
  _onRemoveLinkClicked(event) {
    const removeLink = event.target.closest("a");
    if (!removeLink || !removeLink.href.includes("/cart/change")) {
      return;
    }
    event.preventDefault();
    const url = new URL(removeLink.href);
    this._changeLineItemQuantity(url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")));
  }
  /**
   * @returns {HTMLElement | null}
   */
  _getQuantitySelector() {
    return this.querySelector("quantity-selector");
  }
  async _changeLineItemQuantity(lineKey, targetQuantity) {
    if (this._pendingChange) {
      return;
    }
    this._pendingChange = true;
    const quantitySelector = this._getQuantitySelector();
    quantitySelector?.setBusy(true);
    try {
      if (window.themeVariables.settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
        return;
      }
      const lineItem = this.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle
        })
      })).json();
      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
    } finally {
      this._pendingChange = false;
      // DOM may be replaced by cart:change; only unlock if this node is still connected.
      if (this.isConnected) {
        this._getQuantitySelector()?.setBusy(false);
      }
    }
  }
};
if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

// js/common/cart/shipping-estimator.js
var ShippingEstimator = class extends HTMLElement {
  constructor() {
    super();
    this._estimateShippingListener = this._estimateShipping.bind(this);
  }
  connectedCallback() {
    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;
    this.submitButton.addEventListener("click", this._estimateShippingListener);
  }
  disconnectedCallback() {
    this.submitButton.removeEventListener("click", this._estimateShippingListener);
  }
  /**
   * @doc https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
   */
  async _estimateShipping(event) {
    event.preventDefault();
    const zip = this.querySelector('[name="address[zip]"]').value, country = this.querySelector('[name="address[country]"]').value, province = this.querySelector('[name="address[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const prepareResponse = await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(zip, country, province);
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
    this.resultsElement.hidden = false;
    this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(zip, country, province) {
    const response = await fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
    const responseAsText = await response.text();
    if (responseAsText === "null") {
      return this._getAsyncShippingRates(zip, country, province);
    } else {
      return JSON.parse(responseAsText)["shipping_rates"];
    }
  }
  _formatShippingRates(shippingRates) {
    let formattedShippingRates = shippingRates.map((shippingRate) => {
      return `<li>${shippingRate["presentment_name"]}: ${shippingRate["currency"]} ${shippingRate["price"]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${shippingRates.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : shippingRates.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${formattedShippingRates === "" ? "" : `<ul class="list-disc" role="list">${formattedShippingRates}</ul>`}
      </div>
    `;
  }
  _formatError(errors) {
    let formattedShippingRates = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${formattedShippingRates}</ul>
      </div>
    `;
  }
};
if (!window.customElements.get("shipping-estimator")) {
  window.customElements.define("shipping-estimator", ShippingEstimator);
}

// js/common/facets/facet-apply-button.js
var FacetApplyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._closeDrawer);
    this._form = document.querySelector("#facet-form");
    this._form.addEventListener("change", this._updateCount.bind(this));
    this.filterCountElement = document.createElement("span");
    this.appendChild(this.filterCountElement);
  }
  connectedCallback() {
    this._updateCount();
  }
  _updateCount() {
    const form = new FormData(this._form);
    this.filterCountElement.innerText = ` (${Array.from(form.values()).filter((item) => item !== "").length})`;
  }
  async _closeDrawer() {
    this.closest("facet-drawer").hide();
  }
};
if (!window.customElements.get("facet-apply-button")) {
  window.customElements.define("facet-apply-button", FacetApplyButton, { extends: "button" });
}

// js/common/facets/facet-dialog.js
var FacetDialog = class extends DialogElement {
  get initialFocus() {
    return false;
  }
};
if (!window.customElements.get("facet-dialog")) {
  window.customElements.define("facet-dialog", FacetDialog);
}

// js/common/facets/facet-drawer.js
var FacetDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener("dialog:after-hide", this._submitForm);
  }
  _submitForm() {
    this.querySelector("#facet-form").dispatchEvent(new Event("submit"));
  }
};
if (!window.customElements.get("facet-drawer")) {
  window.customElements.define("facet-drawer", FacetDrawer);
}

// js/common/facets/facet-floating-filter.js
import { animate as animate5 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var FacetFloatingFilter = class extends HTMLElement {
  connectedCallback() {
    const footer = document.querySelector(".shopify-section--footer");
    if (!footer) return;
    new IntersectionObserver(this._onFooterVisibilityChanged.bind(this), { rootMargin: "50px 0px" }).observe(footer);
  }
  _onFooterVisibilityChanged(entries) {
    if (entries[0].isIntersecting) {
      animate5(this, { opacity: 0, transform: [null, "translateY(15px)"], visibility: "hidden" }, { duration: 0.15 });
    } else {
      animate5(this, { opacity: 1, transform: [null, "translateY(0)"], visibility: "visible" }, { duration: 0.15 });
    }
  }
};
if (!window.customElements.get("facet-floating-filter")) {
  window.customElements.define("facet-floating-filter", FacetFloatingFilter);
}

// js/common/facets/facet-form.js
var abortController = null;
var openElements = /* @__PURE__ */ new Set();
document.addEventListener("facet:update", async (event) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  shopifySection.classList.add("is-loading");
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");
  history.replaceState({}, "", clonedUrl.toString());
  try {
    const tempContent = new DOMParser().parseFromString(await (await cachedFetch(url.toString(), { signal: abortController.signal })).text(), "text/html");
    let storedFacetState = null;
    try {
      storedFacetState = JSON.parse(sessionStorage.getItem("collection-facet-details:" + location.pathname));
    } catch (error) {}
    Array.from(tempContent.querySelectorAll("details, facet-dialog")).forEach((item) => {
      const storageKey = item.getAttribute("data-facet-accordion") || item.id;
      if (!storageKey) return;
      let shouldOpen;
      if (storedFacetState && typeof storedFacetState === "object" && !Array.isArray(storedFacetState) && Object.prototype.hasOwnProperty.call(storedFacetState, storageKey)) {
        shouldOpen = !!storedFacetState[storageKey];
      } else if (Array.isArray(storedFacetState)) {
        shouldOpen = storedFacetState.includes(storageKey) || storedFacetState.includes(item.id);
      } else {
        shouldOpen = openElements.has(item.id);
      }
      if (shouldOpen) {
        item.setAttribute("open", "");
      } else {
        item.removeAttribute("open");
      }
    });
    shopifySection.replaceChildren(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
    shopifySection.classList.remove("is-loading");
    const scrollToElement = window.matchMedia("(min-width: 700px) and (max-width: 999px)").matches ? shopifySection.querySelector(".collection__results") : shopifySection.querySelector(".collection__results product-list"), scrollToBoundingRect = scrollToElement.getBoundingClientRect();
    if (scrollToBoundingRect.top < parseInt(getComputedStyle(scrollToElement).scrollPaddingTop || 0)) {
      scrollToElement.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  } catch (e) {
  }
});
var FacetForm = class extends HTMLFormElement {
  constructor() {
    super();
    this._isDirty = false;
    this.addEventListener("change", this._onFormChanged);
    this.addEventListener("submit", this._onFormSubmitted);
  }
  connectedCallback() {
    Array.from(this.querySelectorAll("details, facet-dialog")).forEach((disclosureElement) => {
      if (disclosureElement.id) {
        if (disclosureElement.open) {
          openElements.add(disclosureElement.id);
        } else {
          openElements.delete(disclosureElement.id);
        }
      }
      disclosureElement.querySelector("summary")?.addEventListener("click", () => {
        queueMicrotask(() => {
          if (!disclosureElement.id) return;
          if (disclosureElement.open) {
            openElements.add(disclosureElement.id);
          } else {
            openElements.delete(disclosureElement.id);
          }
        });
      });
      disclosureElement.addEventListener("toggle", () => {
        if (!disclosureElement.id) return;
        if (disclosureElement.open) {
          openElements.add(disclosureElement.id);
        } else {
          openElements.delete(disclosureElement.id);
        }
      });
    });
  }
  _buildUrl(deleteKeys) {
    const searchParams = new URLSearchParams(new FormData(this)),
      url = new URL(this.action);
    url.search = "";
   
    searchParams.forEach((value, key) => url.searchParams.append(key, value));
    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
      if (url.searchParams.get(optionToClear) === "") {
        url.searchParams.delete(optionToClear);
      }
    });
    if(deleteKeys && deleteKeys.length > 0) {
      deleteKeys.forEach((key) => {
        url.searchParams.delete(key);
      });
    }
    const currentView = new URL(window.location.href).searchParams.get("view");
    if (currentView && !url.searchParams.get("view")) {
      url.searchParams.set("view", currentView);
    }
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    return url;
  }
  _onFormChanged(event) {
    Array.from(this.querySelectorAll("details[id]")).forEach((disclosureElement) => {
      if (disclosureElement.open) {
        openElements.add(disclosureElement.id);
      } else {
        openElements.delete(disclosureElement.id);
      }
    });

    const radioList = ['filter.v.m.custom.product_model'];
    let deleteKeys = [];
    
    if (radioList.includes(event.target.name)) {
      deleteKeys.push('filter.p.m.custom.product_series')
    }
    
    this._isDirty = true;
    if (this.hasAttribute("update-on-change")) {
      const event = new CustomEvent("submit", {
        detail: {
          deleteKeys,
        },
        cancelable: true
      });
      this.dispatchEvent(event);
    } else {
      cachedFetch(this._buildUrl(deleteKeys).toString());
    }
  }
  _onFormSubmitted(event) {
    let deleteKeys = event?.detail?.deleteKeys || [];
    const radioList = ['filter.v.m.custom.product_model'];
    
    // 移动端会直接提交表单, 此时event.target为form元素
    if(event.target.tagName === 'FORM') {
      const formData = new FormData(event.target);
      formData.entries().forEach(([key, value]) => {
        if(radioList.includes(key)) {
          deleteKeys.push('filter.p.m.custom.product_series')
        }
      });
    }
    
    event.preventDefault();
    if (!this._isDirty) {
      return;
    }
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url: this._buildUrl(deleteKeys)
      }
    }));
    this._isDirty = false;
  }
};
if (!window.customElements.get("facet-form")) {
  window.customElements.define("facet-form", FacetForm, { extends: "form" });
}

// js/common/facets/facet-link.js
var FacetLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this._onFacetUpdate);
  }
  _onFacetUpdate(event) {
    event.preventDefault();
    const sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", ""), url = new URL(this.href);
    url.searchParams.set("section_id", sectionId);
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facet-link")) {
  window.customElements.define("facet-link", FacetLink, { extends: "a" });
}

// js/common/facets/facet-sort-by.js
var FacetSortBy = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("listbox:change", this._onValueChanged);
  }
  _onValueChanged(event) {
    const url = new URL(location.href), sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", "");
    url.searchParams.set("sort_by", event.detail.value);
    url.searchParams.set("section_id", sectionId);
    url.searchParams.delete("page");
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facet-sort-by")) {
  window.customElements.define("facet-sort-by", FacetSortBy);
}

// js/common/feedback/pill-loader.js
import { animate as animate6, timeline as timeline4, stagger as stagger4 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var PillLoader = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  connectedCallback() {
    this.innerHTML = `
      <div class="loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
        <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === "true") {
      timeline4([
        [this, { opacity: [0, 1], visibility: "visible", transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.15 }],
        [this.firstElementChild, { opacity: 1, transform: ["translateY(0)"] }, { duration: 0.15, at: "<" }],
        [this.lastElementChild, { opacity: 0 }, { duration: 0, at: "<" }]
      ]);
      animate6(this.firstElementChild.querySelectorAll("span"), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger4(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      timeline4([
        [this.firstElementChild, { opacity: 0, transform: ["translateY(0)", "translateY(-2px)"] }, { duration: 0.15 }],
        [this.lastElementChild, { opacity: 1, transform: ["translateY(2px)", "translateY(0)"] }, { duration: 0.15 }],
        [this, { opacity: 0, transform: ["translateY(0)", "translateY(-5px)"], visibility: "hidden" }, { duration: 0.15, at: "+0.8" }]
      ]);
    }
  }
};
if (!window.customElements.get("pill-loader")) {
  window.customElements.define("pill-loader", PillLoader);
}

// js/common/feedback/progress-bar.js
var ProgressBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    this.style.setProperty("--progress", `${Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"))}`);
  }
};
if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}

// js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.rangeLowerBound = this.querySelector('input[type="range"]:first-child');
    this.rangeHigherBound = this.querySelector('input[type="range"]:last-child');
    this.textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]');
    this.textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select(), { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select(), { signal: this._abortController.signal });
    this.textInputLowerBound.addEventListener("input", () => {
      this._applyTextInputToRange(this.textInputLowerBound, this.rangeLowerBound, "--range-min");
    }, { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("input", () => {
      this._applyTextInputToRange(this.textInputHigherBound, this.rangeHigherBound, "--range-max");
    }, { signal: this._abortController.signal });
    this.textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      this.rangeLowerBound.value = event.target.value;
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
      this._syncBoundLabels();
    }, { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      this.rangeHigherBound.value = event.target.value;
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
      this._syncBoundLabels();
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      this._syncBoundLabels();
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      this._syncBoundLabels();
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputLowerBound.value = event.target.value;
      this._syncBoundLabels();
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputHigherBound.value = event.target.value;
      this._syncBoundLabels();
    }, { signal: this._abortController.signal });
  }
  /**
   * Move the matching thumb while typing; labels follow the text field, not the stale thumb.
   * @param {HTMLInputElement} textInput
   * @param {HTMLInputElement} rangeInput
   * @param {string} cssVar
   */
  _applyTextInputToRange(textInput, rangeInput, cssVar) {
    const parsed = parseInt(textInput.value, 10);
    if (!Number.isFinite(parsed)) return;
    rangeInput.value = String(parsed);
    rangeInput.parentElement.style.setProperty(
      cssVar,
      `${parseInt(rangeInput.value, 10) / parseInt(rangeInput.max, 10) * 100}%`
    );
    this._syncBoundLabels();
  }
  /**
   * Keep bound labels on the shop money format during drag and while typing.
   * Labels follow the number fields when they have a value, so a stale thumb
   * cannot flash an intermediate amount (e.g. 1.965,00 kr vs input 2000).
   */
  _syncBoundLabels() {
    const minEl = this.querySelector('[data-bound="min"]');
    const maxEl = this.querySelector('[data-bound="max"]');
    if (!minEl && !maxEl) return;
    const settings = window.themeVariables && window.themeVariables.settings;
    const format = settings
      ? settings.currencyCodeEnabled
        ? settings.moneyWithCurrencyFormat
        : settings.moneyFormat
      : "";
    const minRaw = parseInt(this.textInputLowerBound.value, 10);
    const maxRaw = parseInt(this.textInputHigherBound.value, 10);
    const minMajor = Number.isFinite(minRaw) ? minRaw : parseInt(this.rangeLowerBound.value, 10);
    const maxMajor = Number.isFinite(maxRaw) ? maxRaw : parseInt(this.rangeHigherBound.value, 10);
    if (minEl) minEl.textContent = formatMoney(minMajor * 100, format);
    if (maxEl) maxEl.textContent = formatMoney(maxMajor * 100, format);
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// js/common/form/quantity-selector.js
var QuantitySelector = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this._isBusy = false;
    this.inputElement = this.querySelector("input");
    this.minusButton = this.querySelector("button:first-of-type");
    this.plusButton = this.querySelector("button:last-of-type");
    this.minusButton.addEventListener("click", () => this._step(-1), { signal: this._abortController.signal });
    this.plusButton.addEventListener("click", () => this._step(1), { signal: this._abortController.signal });
    this.inputElement.addEventListener("change", () => this._syncButtons(), { signal: this._abortController.signal });
    this.inputElement.addEventListener("input", () => this._syncButtons(), { signal: this._abortController.signal });
    // quantity-input (is=) may upgrade after this callback; sync from value now and again after upgrade.
    this._syncButtons();
    queueMicrotask(() => this._syncButtons());
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  /**
   * Read qty from value attribute/property so we do not depend on quantity-input having upgraded.
   * @returns {number}
   */
  _readQuantity() {
    return parseInt(this.inputElement?.value, 10);
  }
  /**
   * @returns {Object} Bounds with minQty and maxQty numbers.
   */
  _readBounds() {
    const min = parseInt(this.inputElement.getAttribute("min"), 10);
    const max = parseInt(this.inputElement.getAttribute("max"), 10);
    return {
      minQty: Number.isFinite(min) ? min : 1,
      maxQty: Number.isFinite(max) ? max : Number.MAX_VALUE
    };
  }
  /**
   * Lock controls while a cart quantity request is in flight.
   * @param {boolean} isBusy
   */
  setBusy(isBusy) {
    this._isBusy = Boolean(isBusy);
    this.toggleAttribute("aria-busy", this._isBusy);
    if (this.inputElement) {
      this.inputElement.readOnly = this._isBusy;
    }
    if (this._isBusy) {
      if (this.minusButton) this.minusButton.disabled = true;
      if (this.plusButton) this.plusButton.disabled = true;
      return;
    }
    this._syncButtons();
  }
  /**
   * Step quantity via +/- buttons and emit change so cart/line-item listeners update.
   * @param {number} delta
   */
  _step(delta) {
    if (this._isBusy || !this.inputElement) {
      return;
    }
    const previous = this._readQuantity();
    if (!Number.isFinite(previous)) {
      return;
    }
    const { minQty, maxQty } = this._readBounds();
    const next = Math.max(minQty, Math.min(previous + delta, maxQty));
    // Prefer quantity setter when upgraded; fall back to value for first paint.
    if (typeof this.inputElement.quantity === "number") {
      this.inputElement.quantity = next;
    } else {
      this.inputElement.value = String(next);
    }
    this._syncButtons();
    if (previous !== next) {
      this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
  /** Disable minus at min and plus at max (e.g. gray minus when qty is 1). */
  _syncButtons() {
    if (this._isBusy || !this.inputElement || !this.minusButton || !this.plusButton) {
      return;
    }
    const qty = this._readQuantity();
    const { minQty, maxQty } = this._readBounds();
    this.minusButton.disabled = !Number.isFinite(qty) || qty <= minQty;
    this.plusButton.disabled = !Number.isFinite(qty) || qty >= maxQty;
  }
};
var QuantityInput = class extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("input", this._onValueInput);
    this.addEventListener("change", this._onValueChanged);
    this.addEventListener("keydown", this._onKeyDown);
    this.addEventListener("focus", this.select);
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(quantity) {
    const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
    if (quantity === "") {
      return;
    }
    if (!isNumeric || quantity < 0) {
      quantity = parseInt(quantity) || 1;
    }
    this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
    this.size = Math.max(this.value.length + 1, 2);
  }
  _onValueInput() {
    this.quantity = this.value;
  }
  _onValueChanged() {
    if (this.value === "") {
      this.quantity = 1;
    }
  }
  _onKeyDown(event) {
    event.stopPropagation();
    const originalQuantity = this.quantity;
    if (event.key === "ArrowUp") {
      this.quantity = this.quantity + 1;
    } else if (event.key === "ArrowDown") {
      this.quantity = this.quantity - 1;
    }
    if (originalQuantity !== this.quantity) {
      this._abortController = new AbortController();
      this.addEventListener("blur", () => this.dispatchEvent(new Event("change", { bubbles: true })), { once: true, signal: this._abortController.signal });
    }
  }
};
if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}

// js/common/form/resizable-textarea.js
var ResizableTextarea = class extends HTMLTextAreaElement {
  constructor() {
    super();
    this.addEventListener("input", this._onInput);
  }
  _onInput() {
    this.style.height = "auto";
    this.style.height = this.scrollHeight + 2 + "px";
  }
};
if (!window.customElements.get("resizable-textarea")) {
  window.customElements.define("resizable-textarea", ResizableTextarea, { extends: "textarea" });
}

// js/common/list/listbox.js
var _accessibilityInitialized, _hiddenInput, _onOptionClicked, onOptionClicked_fn, _onInputChanged, onInputChanged_fn, _onKeyDown, onKeyDown_fn;
var Listbox = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onOptionClicked);
    __privateAdd(this, _onInputChanged);
    __privateAdd(this, _onKeyDown);
    __privateAdd(this, _accessibilityInitialized, false);
    __privateAdd(this, _hiddenInput, void 0);
    this.addEventListener("keydown", __privateMethod(this, _onKeyDown, onKeyDown_fn));
  }
  static get observedAttributes() {
    return ["aria-activedescendant"];
  }
  connectedCallback() {
    if (!__privateGet(this, _accessibilityInitialized)) {
      this.setAttribute("role", "listbox");
      __privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]'));
      __privateGet(this, _hiddenInput)?.addEventListener("change", __privateMethod(this, _onInputChanged, onInputChanged_fn).bind(this));
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        option.addEventListener("click", __privateMethod(this, _onOptionClicked, onOptionClicked_fn).bind(this));
        option.id = "option-" + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
        if (option.getAttribute("aria-selected") === "true") {
          this.setAttribute("aria-activedescendant", option.id);
        }
      });
      __privateSet(this, _accessibilityInitialized, true);
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "aria-activedescendant" && oldValue !== null && newValue !== oldValue) {
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        if (option.id === newValue) {
          option.setAttribute("aria-selected", "true");
          if (__privateGet(this, _hiddenInput) && __privateGet(this, _hiddenInput).value !== option.value) {
            __privateGet(this, _hiddenInput).value = option.value;
            __privateGet(this, _hiddenInput).dispatchEvent(new Event("change", { bubbles: true }));
          }
          if (this.hasAttribute("aria-owns")) {
            this.getAttribute("aria-owns").split(" ").forEach((boundId) => {
              document.getElementById(boundId).textContent = option.getAttribute("title") || option.innerText || option.value;
            });
          }
          option.dispatchEvent(new CustomEvent("listbox:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }
};
_accessibilityInitialized = new WeakMap();
_hiddenInput = new WeakMap();
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  this.setAttribute("aria-activedescendant", event.currentTarget.id);
  event.currentTarget.dispatchEvent(new CustomEvent("listbox:select", {
    bubbles: true,
    detail: {
      value: event.currentTarget.value
    }
  }));
};
_onInputChanged = new WeakSet();
onInputChanged_fn = function(event) {
  this.setAttribute("aria-activedescendant", this.querySelector(`[role="option"][value="${CSS.escape(event.target.value)}"]`).id);
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
if (!window.customElements.get("x-listbox")) {
  window.customElements.define("x-listbox", Listbox);
}

// js/common/media/image.js
function imageLoaded(imageOrArray) {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(imageOrArray.map((image) => {
    return new Promise((resolve) => {
      if (image.tagName === "IMG" && image.complete || !image.offsetParent) {
        resolve();
      } else {
        image.onload = () => resolve();
      }
    });
  }));
}
function generateSrcset(imageObject, widths = []) {
  const imageUrl = new URL(imageObject["src"]);
  return widths.filter((width) => width <= imageObject["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}
function createMediaImg(media, widths = [], properties = {}) {
  const image = new Image(media["preview_image"]["width"], media["preview_image"]["height"]), featuredMediaUrl = new URL(media["preview_image"]["src"]);
  for (const propertyKey in properties) {
    image.setAttribute(propertyKey, properties[propertyKey]);
  }
  image.alt = media["alt"];
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media["preview_image"], widths);
  return image;
}

// js/common/product/product-loader.js
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (this.loadedProducts[productHandle]) {
      return this.loadedProducts[productHandle];
    }
    this.loadedProducts[productHandle] = new Promise(async (resolve) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      // A product that is not published to the online store has no /products/<handle>.js (404), so the variant picker
      // never started in its admin preview (/products_preview?preview_key=...). That preview serves the same JSON at
      // products_preview.js; use it only for the previewed product.
      const previewKey = new URLSearchParams(window.location.search).get("preview_key");
      if (!response.ok && previewKey) {
        const previewResponse = await fetch(`${Shopify.routes.root}products_preview.js?preview_key=${encodeURIComponent(previewKey)}`);
        if (previewResponse.ok) {
          const previewProduct = await previewResponse.json();
          if (previewProduct.handle === productHandle) {
            resolve(previewProduct);
            return;
          }
        }
      }
      // The theme editor renders an unpublished product without a preview_key, and its .js is a 404 there too.
      // snippets/variant-picker.liquid prints the product for the editor only; use that copy.
      if (!response.ok && window.Shopify?.designMode) {
        const designModeProduct = document.querySelector(`script[data-design-mode-product="${CSS.escape(productHandle)}"]`);
        if (designModeProduct) {
          const { product, options } = JSON.parse(designModeProduct.textContent);
          resolve({ ...product, options });
          return;
        }
      }
      const responseAsJson = await response.json();
      resolve(responseAsJson);
    });
    return this.loadedProducts[productHandle];
  }
};
__publicField(ProductLoader, "loadedProducts", {});

// js/common/product/product-card.js
import { Delegate as Delegate3 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var ProductCard = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate3(this);
    this.addEventListener("pointerover", () => ProductLoader.load(this.getAttribute("handle")), { once: true });
  }
  connectedCallback() {
    this._delegate.on("change", '[type="radio"]', this._onSwatchChanged.bind(this));
    this._delegate.on("pointerover", '[type="radio"] + label', this._onSwatchHovered.bind(this), true);
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  async _onSwatchHovered(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target.control), primaryMediaElement = this.querySelector(".product-card__image--primary");
    if (firstMatchingVariant.hasOwnProperty("featured_media")) {
      this._createImageElement(firstMatchingVariant["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
    }
  }
  async _onSwatchChanged(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target);
    this.querySelectorAll(`a[href^="${this.product["url"]}"`).forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set("variant", firstMatchingVariant["id"]);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
    if (!firstMatchingVariant.hasOwnProperty("featured_media")) {
      return;
    }
    const primaryMediaElement = this.querySelector(".product-card__image--primary"), secondaryMediaElement = this.querySelector(".product-card__image--secondary");
    const newPrimaryMediaElement = this._createImageElement(firstMatchingVariant["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
    if (primaryMediaElement.src !== newPrimaryMediaElement.src) {
      secondaryMediaElement ? secondaryMediaElement.replaceWith(this._createImageElement(this.product["media"][firstMatchingVariant["featured_media"]["position"]] || this.product["media"][1], secondaryMediaElement.className, secondaryMediaElement.sizes)) : null;
      await primaryMediaElement.animate({ opacity: [1, 0] }, { duration: 250, easing: "ease-in", fill: "forwards" }).finished;
      await new Promise((resolve) => newPrimaryMediaElement.complete ? resolve() : newPrimaryMediaElement.onload = () => resolve());
      primaryMediaElement.replaceWith(newPrimaryMediaElement);
      newPrimaryMediaElement.animate({ opacity: [0, 1] }, { duration: 250, easing: "ease-in" });
    }
  }
  _createImageElement(media, classes, sizes) {
    const previewImage = media["preview_image"], image = new Image(previewImage["width"], previewImage["height"]);
    image.className = classes;
    image.alt = media["alt"];
    image.sizes = sizes;
    image.src = previewImage["src"];
    image.srcset = generateSrcset(previewImage, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800]);
    return image;
  }
  async _getMatchingVariant(target) {
    this.product = await ProductLoader.load(this.getAttribute("handle"));
    return this.product["variants"].find((variant) => variant[`option${target.closest("[data-option-position]").getAttribute("data-option-position")}`] === target.value);
  }
};
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}

var VariantCard = class extends HTMLElement {
  constructor() {
    super();
    this._handle = this.getAttribute("handle");
    this._variantId = this.getAttribute("variantId");
    this._buyText = this.getAttribute("buyText");
    this._moreText = this.getAttribute("moreText");
    this._soldOutText = this.getAttribute("soldOutText");
    this._icon = this.getAttribute("icon");
    this._loading = true;
    this._section = this.closest(".shopify-section");
  }

  async connectedCallback() {
    try {
      this.product = await ProductLoader.load(this._handle);
      this.variant = this.product.variants.find(v => v.id == this._variantId);
      
      this.enableCustomAfterPay = 'true';
      
      this.render();
      this.bindEvents();
    } catch (error) {
      console.error('VariantCard Error:', error);
    }
  }

  render() {
    const saving = (this.variant.compare_at_price - this.variant.price);
    let saleText = `Save {{ savings }}`;
    if(saving > 0) {
      // Whole amounts drop the .00, like every savings tag on the product page (money_without_trailing_zeros).
      saleText = saleText.replace('{{ savings }}', formatMoney(saving, currencyFormat).replace(/[.,]00(?=\D*$)/, ""));
    } else {
      saleText = '';
    }
    // get recommended image from window
    let imageUrl = `${this.variant.featured_image?.src ? this.variant.featured_image.src : this.product.featured_image}`;
    let recommendationText = '';
    let recommendationProductDescription = '';
    
    try {
      const recommendations = window?.variantMetafields[this.product.id] && window.variantMetafields[this.product.id][this._variantId]?.recommendations;
      console.log('recommendations: ', recommendations);
      if(recommendations.image) {
        imageUrl = recommendations.image;
      }
      if(recommendations.text) {
        recommendationText = recommendations.text;
      }
      if(recommendations.productDescription) {
        recommendationProductDescription = recommendations.productDescription;
      }
    } catch (error) {
      console.log(error);
    }
    console.log('imageUrl: ', imageUrl);
    
    this.innerHTML = `
      <article class="variant-card-wrapper">
        <div class="card-media">
          <img class="product-image" 
            src="${imageUrl}" 
            alt="${this.variant.name ? this.variant.name : this.product.title}" 
            loading="lazy"
          />
          <img class="ranking-icon" src="${this._icon}" />
          <div class="recommendation-text">
            ${recommendationText}
          </div>
          <div class="product-card__badge-list hidden" style="display: none;">
            <sold-out-badge ${this.variant.available ? 'hidden' : ''} class="badge badge--sold-out">Sold out</sold-out-badge>
            <on-sale-badge ${this.variant.available && this.variant.compare_at_price > this.variant.price ? '' : 'hidden'} discount-mode="saving" class="badge badge--on-sale">
              ${saleText}
            </on-sale-badge>
          </div>
        </div>

        <div class="card-content">
          <h3 class="product-title">${this.variant.title ? this.variant.title : this.product.title}</h3>
          
          <div class="product-desc prose">
            ${recommendationProductDescription ? recommendationProductDescription : this.product.description}
          </div>
          
          <div class="price-container product-info__price">
            <span class="current-price ${this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price ? 'text-on-sale' : ''}">${formatMoney(this.variant.price, currencyFormat)}</span>
            ${this.variant.compare_at_price ?
              `<span class="compare-price line-through text-subdued">${formatMoney(this.variant.compare_at_price, currencyFormat)}</span>` : ''}
          </div>
          
          ${this.enableCustomAfterPay == 'true' ? 
            `
              <custom-after-pay-msg
                id="shopify-custom-after-pay-msg-product-info"
                class="paypal-product-info custom-after-pay-msg custom-after-pay-msg__product-info"
                amount="${this.variant.price}"
              ></custom-after-pay-msg>
            ` : 
            `
              <klarna-placement
                class="paypal-product-info"
                data-theme="default"
                data-key="credit-promotion-badge"
                data-locale="en-NL"
                data-currency="EUR"
                data-purchase-amount="${this.variant.price}"
              ></klarna-placement>
            `
          }
          
          
          
          <div class="quick-actions-container">
            <button class="buying-button buy-now button button-md button--fill" data-action="add-to-cart" is="custom-button" ${this.variant.available ? '' : 'disabled'}>
              <span>${this.variant.available ? this._buyText : this._soldOutText}</span>
            </button>
            
            <a class="buying-button learn-more button button-md button--text" data-action="learn-more" is="a" href="${this.product.url}?variant=${this.variant.id}">
              <span>${this._moreText}</span>
            </a>
          </div>
        </div>
      </article>
    `;
  }

  // 绑定事件
  bindEvents() {
    this.querySelector('[data-action="add-to-cart"]')
      .addEventListener('click', (event) => this.handleAddToCart(event));
      
    this.querySelector('[data-action="learn-more"]')
      .addEventListener('click', async (event) => {
        event.preventDefault();
        // 上报数据
        const eventData = {
          event_id: 'buying_guide_click_learn_more',
          page_info: {
            url: window.location.href,
            section: this._section.id,
            module: 'VARIANT_CARD',
          },
          action: 'click',
          details: {
            element: event.target.outerHTML,
            target: `${this.product.url}?variant=${this.variant.id}`,
            variant_id: this._variantId,
            product_name: `${this.variant.title ? this.variant.title : this.product.title}`
          }
        }
        console.log('a eventData: ', eventData);
        trackData(eventData);
        
        window.open(`${this.product.url}?variant=${this.variant.id}`, '_blank');
      });
      
    const img = this.querySelector('.product-image');
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', () => {
        img.classList.add('loaded');
      });
    }
  }

  async handleAddToCart(event) {
    const section = this.closest(".shopify-section");
    
    // 上报数据
    const eventData = {
      event_id: 'buying_guide_click_buy_now',
      page_info: {
        url: window.location.href,
        section: this._section.id,
        module: 'VARIANT_CARD',
      },
      action: 'click',
      details: {
        element: event.target.outerHTML,
        target: this._variantId,
        variant_id: this._variantId,
        product_name: `${this.variant.title ? this.variant.title : this.product.title}`
      }
    }
    trackData(eventData);
    
    
    this.querySelector('[data-action="add-to-cart"]').setAttribute('disabled', 'disabled');
    this.querySelector('[data-action="add-to-cart"]').setAttribute('aria-busy', 'true');
    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: {
          sections: sectionsToBundle
        }
      }));
      
      let items = [{
        id: this._variantId,
        quantity: 1
      }];
      try {
        const gifts = window?.variantMetafields[this.product.id] && window.variantMetafields[this.product.id][this._variantId]?.gifts;
        if(gifts) {
          gifts.forEach(gift => {
            if(gift.available === false) return; // 不可用的赠品不加入购物车
            items.push({
              id: gift.variantId,
              quantity: gift.quantity
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
      
      const response = await fetch('/cart/add.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // id: this._variantId,
          // quantity: 1,
          items,
          sections: sectionsToBundle.join(",")
        }),
      });

      if (!response.ok) throw new Error('Add to cart failed');
      const responseJson = await response.json();
      if(response.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: cartContent.hasOwnProperty("items") ? cartContent["items"] : [cartContent],
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
        
      }
    } catch (error) {
      console.error('Cart Error:', error);
    } finally {
      this.querySelector('[data-action="add-to-cart"]').removeAttribute("aria-busy");
      this.querySelector('[data-action="add-to-cart"]').removeAttribute("disabled");
    }
  }
};

if (!window.customElements.get("variant-card")) {
  window.customElements.define("variant-card", VariantCard);
}

var ProductGift = class extends HTMLElement {
  constructor() {
    super();
    this._disableVariantChanged = this.getAttribute("disable-variant-changed") === "true";
    this._handle = this.getAttribute("handle");
    this._productForm = document.forms[this.getAttribute("form")];
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onClickListener = this._onClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._onClickListener);
    if(!this._disableVariantChanged) {
      this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);
    }
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this._productForm?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  async _onVariantChanged(event) {
    if (this._disableVariantChanged) {
      return;
    }
    if (event.detail.variant) {
      const section = this.closest(".shopify-section");
      const url = productVariantSectionUrl(this._handle, event.detail.variant.id, section.id.replace("shopify-section-", ""));
      const response = await fetch(url, { priority: "low" });
      const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html");
      // 变体切换后，需要隐藏或者替换内容
      const productGiftElement = tempDiv.querySelector("product-gift");
      if(!productGiftElement) {
        this.innerHTML = '';
        return;
      }
      const productGiftList = productGiftElement.querySelector(".product-gift-wrapper");
      
      if (productGiftList && productGiftList?.childElementCount > 0) {
        this.replaceChildren(...document.importNode(productGiftElement, true).childNodes);
        // 需要修改 product-gift 上的 main-variant 为当前的变体ID
        this.setAttribute('main-variant', event.detail.variant.id)
      } else {
        // 为空，需要隐藏
        this.innerHTML = '';
      }
    }
  }
  async _onClick(event) {
    const viewBox = event.target.closest(`.gift-item__title`);
    const itemBox = event.target.closest(`.gift-item`);

    if (viewBox) {
      const dialog = document.querySelector('#product-info-dialog');
      const dialogInfo = dialog.querySelector('.dialog-body-box');
      viewBox.classList.add('loading');

      // // get product html
      const url = `${Shopify.routes.root}products/${itemBox.dataset.handle}?variant=${itemBox.dataset.variant}`;
      const response = await fetch(url, { priority: 'low' });

      const tempDiv = new DOMParser().parseFromString(await response.text(), 'text/html');
      const productInfoElm = tempDiv.querySelector('#main .shopify-section--main-product');

      // remove children and css hide
      const addToCartBarWrapper = productInfoElm.querySelector('.add-to-cart-bar-wrapper');
      const quickBuyContent = productInfoElm.querySelector('#quickBuyContent');
      if (addToCartBarWrapper) addToCartBarWrapper.parentNode.removeChild(addToCartBarWrapper); // 使用父节点移除
      if (quickBuyContent) productInfoElm.removeChild(quickBuyContent);

      // dialogInfo.replaceChildren(...productInfoElm);
      dialogInfo.innerHTML = productInfoElm.outerHTML;

      dialog.setAttribute('data-layout', 'overview');
      dialog.setAttribute('open', '');
      viewBox.classList.remove('loading');
      return false;
    }
  }
};
if (!window.customElements.get("product-gift")) {
  window.customElements.define("product-gift", ProductGift);
}

// js/common/product/product-form.js
var ProductForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit);
  }
  connectedCallback() {
    this.id.disabled = false;
  }
  // 添加额外的商品
  async addExtraItem(items) {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify({ items }),
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.description || window.themeVariables.strings.cartError);
    }
  }
  // 添加赠品
  async addGifts() {
    // 需要是当前的主商品才需要加购赠品 
    const currentvariantID = this.querySelector('input[type="hidden"][name="id"]')?.value || null;
    const gifts = document.querySelectorAll('.product-info__gift  .gift-item');
    if(gifts.length > 0) {
      const variantID  = document.querySelector('product-gift').getAttribute('main-variant');
      if(variantID === currentvariantID) {
        let items = [];
         gifts.forEach(gift => {
            const id = gift.dataset?.variant;
            const quantity = gift.dataset?.quantity;
            items.push({id, quantity})
         })
        await this.addExtraItem(items);
      }
    }
  }
  async _onSubmit(event) {
    event.preventDefault();
    if (this._isSubmitting) return;
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    // One form owns the main, sticky and checkout controls for this operation.
    this._isSubmitting = true;
    const controls = Array.from(this.elements).filter((control) =>
      control.type === "submit" || control.matches('button[is="custom-checkout-button"]')
    );
    const states = controls.map((control) => ({
      control,
      disabled: control.disabled
    }));
    let unavailable = false;
    const lockControls = () => controls.forEach((control) => {
      control.disabled = true;
      control.setAttribute("aria-busy", "true");
    });
    const onVariantChange = (variantEvent) => {
      unavailable = !variantEvent.detail.variant?.available;
      lockControls();
    };
    this.addEventListener("variant:change", onVariantChange);
    lockControls();
    try {
      const dataItems = JSON.parse(this.dataset.items || "[]");
      // Snapshot the clicked selection before any accessory request can yield.
      // Gift/property inputs stay in their original FormData payload.
      const sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true, detail: { sections: sectionsToBundle }
      }));
      const formData = new FormData(this);
      formData.set("sections", sectionsToBundle.join(","));
      formData.set("sections_url", `${Shopify.routes.root}variants/${formData.get("id")}`);
      if (dataItems.length > 0) await this.addExtraItem(dataItems);
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      const responseJson = await response.json();
      if (!response.ok) throw new Error(responseJson.description || window.themeVariables.strings.cartError);
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
      if (!cartResponse.ok) throw new Error(window.themeVariables.strings.cartError);
      const cartContent = await cartResponse.json();
      cartContent.sections = responseJson.sections;
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: { items: responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson], cart: cartContent }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true, detail: { baseEvent: "variant:add", cart: cartContent }
      }));
    } catch (error) {
      // Network and malformed responses use the same translated, visible error path.
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: { error: error instanceof TypeError || error instanceof SyntaxError ? window.themeVariables.strings.cartError : error.message || window.themeVariables.strings.cartError }
      }));
    } finally {
      this.removeEventListener("variant:change", onVariantChange);
      states.forEach(({ control, disabled }) => {
        control.disabled = disabled || unavailable;
        // Always cleared, never restored: a submit button (CustomButton) can set aria-busy="true" from its own submit
        // listener before this handler snapshots the controls, and restoring that value left it loading and unclickable.
        control.removeAttribute("aria-busy");
      });
      this._isSubmitting = false;
    }
  }
};
if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm, { extends: "form" });
}

// js/common/product/product-form.js
var PromotionForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit);
  }
  connectedCallback() {
    this.id.disabled = false;
  }
  // 添加额外的商品
  async addExtraItem(items) {
    const extraItem = {
      items: items
    };

    console.log('extraItem: ', extraItem);

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(extraItem),
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });

    if (!response.ok) console.log('Upss something went wrong when addExtraItem');
  }
  // 添加赠品
  async addGifts() {
    // 获取 `data-gifts` 的 JSON 数据
    const giftsData = this.getAttribute('data-gifts');
    let items = [];

    if (giftsData) {
      try {
        items = JSON.parse(giftsData);
      } catch (error) {
        console.error("Gift data parsing error:", error);
      }
    }

    if (items.length > 0) {
      await this.addExtraItem(items);
    }
  }

  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const _dataItems = this.dataset?.items;
    const dataItems = JSON.parse(_dataItems || '[]');
    if(dataItems && dataItems.length > 0) {
      await this.addExtraItem(dataItems);
    }
    await this.addGifts();
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
  }
};
if (!window.customElements.get("promotion-form")) { 
  window.customElements.define("promotion-form", PromotionForm, { extends: "form" });
}

// 处理变体名称，模拟Liquid的 handle 过滤器
function processVariantNameForGTA(variantName) {
  // 模拟Liquid: split: '|' | first | handle
  
  // 1. 分割字符串，取第一部分
  const parts = variantName.split('|');
  const firstPart = parts[0].trim();
  
  // 2. 模拟Liquid的handleize过滤器
  //    - 转换为小写
  //    - 替换空格为连字符
  //    - 移除特殊字符
  //    - 处理连续连字符
  const gtaHandle = stringToHandle(firstPart);
  
  // 3. 添加前缀（根据你的Liquid代码）
  const gtaName = 'card-cart__' + gtaHandle;
  
  return gtaName;
}

// 将字符串转换为handle（模拟Liquid的handleize过滤器）
function stringToHandle(str) {
  if (!str) return '';
  
  // 转换为小写
  let handle = str.toLowerCase();
  
  // 移除 | 后面的所有内容（已经在split中处理）
  
  // 替换特殊字符和空格为连字符
  handle = handle
    .trim()                     // 去除首尾空格
    .replace(/\s+/g, '-')       // 空格替换为连字符
    .replace(/[^\w\-]+/g, '')   // 移除非字母数字和连字符的字符
    .replace(/\-\-+/g, '-')     // 合并多个连字符
    .replace(/^-+/, '')         // 去除开头的连字符
    .replace(/-+$/, '');        // 去除结尾的连字符
  
  return handle;
}

// js/common/product/product-form-listeners.js
var BuyButtons = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onCartErrorListener = this._onCartError.bind(this);
    this._isQuickAdd = this.hasAttribute("quick-add");
    console.log('this._isQuickAdd: ', this._isQuickAdd);
    this._quickAddCart = this.querySelector("button[type=\"submit\"]");
    console.log('this._quickAddCart: ', this._quickAddCart);
    this._quickAddBuy = this.querySelector('button[is="custom-checkout-button"]');
  }
  connectedCallback() {
    this._productForm = document.forms[this.getAttribute("form")];
    this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);
    this._productForm?.addEventListener("cart:error", this._onCartErrorListener);
  }
  disconnectedCallback() {
    this._productForm?.removeEventListener("variant:change", this._onVariantChangedListener);
    this._productForm?.removeEventListener("cart:error", this._onCartErrorListener);
  }
  _onVariantChanged(event) {
    console.log('=== event.detail.variant: ', event.detail.variant);
    // 更新 gta_name
    const newVariantName = event.detail.variant.title || event.detail.variant.name;
    const newGTAName = this._processVariantNameForGTA(newVariantName, this.getAttribute('data-gta') || '');
    console.log('newGTAName: ', newGTAName);
    this.setAttribute('data-gta', newGTAName);
    if(this._isQuickAdd && this._quickAddCart && this._quickAddBuy) {
      const cartGTAName = this._processVariantNameForGTA(newVariantName, this._quickAddCart.getAttribute('data-gta') || '');
      this._quickAddCart.setAttribute('data-gta', cartGTAName);
      const buyGTAName = this._processVariantNameForGTA(newVariantName, this._quickAddBuy.getAttribute('data-gta') || '');
      this._quickAddBuy.setAttribute('data-gta', buyGTAName);
    }
    
    const addToCartButton = this.querySelector('button[type="submit"]'), paymentButton = this.querySelector(".shopify-payment-button");
    // Theme Buy Now (snippets/buy-buttons.liquid): hidden and disabled with the Add To Cart button.
    const buyNowButton = this.querySelector(".buy-buttons__buy-now");
    if (buyNowButton) {
      const buyNowAvailable = Boolean(event.detail.variant?.["available"]);
      // The hidden attribute, not the .hidden class: the later .button display rule overrides the class.
      buyNowButton.hidden = !buyNowAvailable;
      buyNowButton.disabled = !buyNowAvailable;
    }
    addToCartButton.classList.remove("button--secondary", "button--subdued");
    addToCartButton.disabled = !event.detail.variant || !event.detail.variant["available"];
    const addToCartButtonText = addToCartButton.getAttribute("is") === "custom-button" ? addToCartButton.firstElementChild : addToCartButton;
    if (!event.detail.variant) {
      addToCartButtonText.innerHTML = window.themeVariables.strings.unavailableButton;
      addToCartButton.classList.add("button--subdued");
      if (paymentButton) {
        paymentButton.style.display = "none";
      }
    } else {
      addToCartButton.classList.add(event.detail.variant["available"] ? paymentButton || buyNowButton || this.hasAttribute("force-secondary-button") ? "button--secondary" : "button" : "button--subdued");
      addToCartButtonText.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.addToCartButton : window.themeVariables.strings.soldOutButton;
      if (paymentButton) {
        paymentButton.style.display = event.detail.variant["available"] ? "block" : "none";
      }
    }
  }
  _onCartError(event) {
    const errorBanner = document.createElement("div");
    errorBanner.classList.add("banner", "banner--error", "justify-center");
    errorBanner.setAttribute("role", "alert");
    errorBanner.style.gridColumn = "1/-1";
    errorBanner.style.marginBottom = "1rem";
    errorBanner.innerHTML = `
      <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
        <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
      </svg>
      
      <p></p>
    `;
    errorBanner.querySelector("p").textContent = event.detail.error;
    this.before(errorBanner);
    setTimeout(async () => {
      await errorBanner.animate({ opacity: [1, 0] }, { duration: 250, fill: "forwards" }).finished;
      errorBanner.remove();
    }, 5e3);
  }
  // 处理变体名称，模拟Liquid的 handle 过滤器
  _processVariantNameForGTA(variantName, currentGTA = '') {
    // 模拟Liquid: split: '|' | first | handle
    
    // 1. 分割字符串，取第一部分
    const parts = variantName.split('|');
    const firstPart = parts[0].trim();
    
    // 2. 模拟Liquid的handleize过滤器
    //    - 转换为小写
    //    - 替换空格为连字符
    //    - 移除特殊字符
    //    - 处理连续连字符
    const gtaHandle = stringToHandle(firstPart);
    
    // 3. 处理前缀
    // 获取当前的data-gta值
    // const currentGTA = this.getAttribute('data-gta') || '';
    
    // 分割前缀和后缀
    const lastUnderscoreIndex = currentGTA.lastIndexOf('__');
    
    let newGTA;
    if (lastUnderscoreIndex !== -1) {
      // 保留前缀，只更新后缀
      const prefix = currentGTA.substring(0, lastUnderscoreIndex + 2); // 包含 "__"
      newGTA = prefix + gtaHandle;
    } else {
      // 如果没有找到 "__"，使用默认前缀
      newGTA = 'cart__' + gtaHandle;
    }

    return newGTA;
  }
};
if (!window.customElements.get("buy-buttons")) {
  window.customElements.define("buy-buttons", BuyButtons);
}
// Read only the associated form, including controls linked through form="..." (same helper as the US theme), not the
// first quantity field on the page, which can belong to a quick-buy drawer of another product. When the Quantity and
// Buy buttons blocks both render a field, the visible one wins.
function getProductFormQuantity(form) {
  const field = form?.elements.namedItem("quantity");
  const fields = field instanceof RadioNodeList ? [...field] : [field].filter(Boolean);
  const input = fields.find((control) => control.getClientRects().length) ?? fields[0];
  const quantity = Number(input?.value ?? 1);
  return Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
}
var CustomCheckoutButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this._onClickListener = this._onClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this._onClickListener);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onClickListener);
  }
  _onClick(event) {
    if (this.disabled || this.getAttribute("aria-disabled") === "true" || this.classList.contains('hidden')) {
      console.warn('Sold out!');
      
      return false;
    }
    this._productForm = this.form;
    if (!this._productForm || this._productForm._isSubmitting) return;
    if (!this._productForm.checkValidity()) {
      this._productForm.reportValidity();
      return;
    }

    const mainProductQuantity = getProductFormQuantity(this._productForm);
    const variantIds = [...new FormData(this._productForm).getAll("id")];
    const mainProductId = variantIds[0];
    if (!/^[1-9]\d*$/.test(mainProductId) || variantIds.some((id) => id !== mainProductId)) return;
    const productID = this._productForm['product-id'].value;
    const items = JSON.parse(this._productForm.dataset?.items || '[]')

    // giftItems
    // const gifts = document.querySelectorAll('.product-info__gift  .gift-item');
    // let giftItems = [];
    // if(gifts.length > 0) {
    //    gifts.forEach(gift => {
    //       const id = gift.dataset?.variant;
    //       const quantity = gift.dataset?.quantity;
    //       giftItems.push({id, quantity})
    //    })
    // }
    
    // 更新 Buy Now 按钮获取赠品方式，直接从 全局变量中获取
    let giftItems = [];
    // Pages that publish no gift data (window.variantMetafields unset) still check out, just without gifts.
    const gifts = window.variantMetafields?.[productID]?.[mainProductId]?.gifts;
    if(Array.isArray(gifts)) {
      gifts.forEach(gift => {
        if(gift.available === false) return; // 不可用的赠品不加入购物车
        giftItems.push({
          id: gift.variantId,
          quantity: gift.quantity
        });
      });
    }

    let products = [{id: mainProductId, quantity: mainProductQuantity}, ...items, ...giftItems];
    let checkoutLink = '/cart/' + products.map(item => `${item.id}:${item.quantity}`).join(',');
    window.location.href = checkoutLink;
  }
}
if (!window.customElements.get("custom-checkout-button")) {
  window.customElements.define("custom-checkout-button", CustomCheckoutButton, { extends: "button" });
}
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (event.detail.variant) {
      const element = this.querySelector('[name="id"]');
      element.value = event.detail.variant["id"];
      element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};
if (!window.customElements.get("payment-terms")) {
  window.customElements.define("payment-terms", PaymentTerms);
}
var PickupAvailability = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
    this._abortController?.abort();
  }
  // Only the latest variant's response is applied; a failed or empty response clears the block instead of leaving the
  // previous variant's store availability on screen.
  async _onVariantChanged(event) {
    this._abortController?.abort();
    if (!event.detail.variant) {
      this.innerHTML = "";
      return;
    }
    const abortController = this._abortController = new AbortController();
    try {
      const response = await fetch(`${Shopify.routes.root}variants/${event.detail.variant["id"]}?section_id=pickup-availability`, { signal: abortController.signal });
      if (!response.ok) {
        throw new Error(`Pickup availability request failed with status ${response.status}`);
      }
      const element = document.createElement("div");
      element.innerHTML = await response.text();
      const freshAvailability = element.querySelector("pickup-availability");
      this.replaceChildren(...(freshAvailability ? freshAvailability.childNodes : []));
    } catch (error) {
      if (error.name !== "AbortError") {
        this.innerHTML = "";
      }
    }
  }
};
if (!window.customElements.get("pickup-availability")) {
  window.customElements.define("pickup-availability", PickupAvailability);
}
var CopyElementSlot = class extends HTMLElement {
  constructor() {
    super();

    // 选择要观察的目标元素
    const _targetNode = this.getAttribute("targetNode");
    const _wrapper = this.getAttribute("wrapper");
    const _copyNode = this.getAttribute("copyNode");

    const targetNode = document.querySelector(_targetNode);
    if(targetNode) {
      // 创建一个 MutationObserver 实例
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const copyNode = document.querySelector(_copyNode);
            // 检查目标元素是否已经添加到 DOM 中
            // 获取 outerHTML
            const outerHTML = copyNode.outerHTML;
            const wrapper = document.querySelector(_wrapper);
            wrapper.innerHTML = outerHTML;
            // 停止观察
            observer.disconnect();
          }
        }
      });
  
      // 配置观察选项
      const config = { childList: true, subtree: true };
  
      // 开始观察
      observer.observe(targetNode, config);
    }

  }
  connectedCallback() {

  }
  disconnectedCallback() {

  }
}
if (!window.customElements.get("copy-element-slot")) {
  window.customElements.define("copy-element-slot", CopyElementSlot);
}

var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var AddToCartPrice = class extends HTMLElement {
  constructor() {
    super();
    this._salePrice = 0;
    this._comparePrice = 0;
    this._form = document.forms[this.getAttribute("form")];
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-items') {
          this._calculateExtraItemsPrice(JSON.parse(mutation.target.dataset.items))
        }
      }
    });
  }
  connectedCallback() {
    const config = { attributes: true }; // 只观察属性变化
    this._observer.observe(this._form, config);
    this._form.dataset.mainProductPrice = this.dataset.price;
    this._form.dataset.mainProductComparePrice = this.dataset?.comparePrice || 0;
    this._form.dataset.itemsPriceTotal = 0;
    this._form.dataset.itemsComparePriceTotal = 0;
    this._form?.addEventListener("variant:change", this._onVariantChangedListener);
    this._setupSoldOutAction();
  }
  disconnectedCallback() {
    this._form?.removeEventListener("variant:change", this._onVariantChangedListener);
    this._observer.disconnect();
    this._soldOutController?.abort();
    clearTimeout(this._soldOutTimer);
    this._backInStockObserver?.disconnect();
    this._observedBackInStock = null;
  }
  // Sold-out variant: the bar stays visible and offers "Notify me" (the back-in-stock form #esc-oos-form, which the
  // Back in stock block or the SC app block mounts, possibly after load) or a disabled "Out of Stock" button.
  _setupSoldOutAction() {
    const wrapper = this.closest(".add-to-cart-bar-wrapper");
    const notify = wrapper?.querySelector("[data-add-to-cart-bar-notify]");
    if (!notify) return;
    this._soldOutController = new AbortController();
    notify.addEventListener("click", (event) => {
      // The desktop and the mobile add-to-cart-price of the same bar both bind this button; only the first handles a
      // click (the second would find the form already moved into the dialog and scroll the page behind it).
      if (event.defaultPrevented) return;
      event.preventDefault();
      const backInStock = this._getBackInStock();
      if (!backInStock) return;
      // A consent gate (snippets/consent-gate.liquid) keeps the form's controls disabled until its checkbox is ticked.
      // Moving the form into the dialog would leave that checkbox behind the modal, so take the customer to it instead.
      if (this._focusConsentGate(backInStock)) return;
      // Inline form (email field): show it in the shared dialog (Figma 1124-39684). Popup mode: open it with the app's button.
      const email = backInStock.querySelector("input[type='email'], input[name*='email' i]");
      if (email) {
        if (!this._openNotifyDialog(backInStock)) {
          backInStock.scrollIntoView({ behavior: "smooth", block: "center" });
          email.focus({ preventScroll: true });
        }
        return;
      }
      const trigger = backInStock.querySelector("button, a[href], [role='button']");
      if (trigger) {
        trigger.click();
      } else {
        backInStock.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, { signal: this._soldOutController.signal });
    this._syncSoldOutAction();
    // Apps mount #esc-oos-form after the theme connects: check again once the page has loaded.
    const resync = () => this._syncSoldOutAction();
    window.addEventListener("load", resync, { once: true, signal: this._soldOutController.signal });
    this._soldOutTimer = setTimeout(resync, 3000);
  }
  /**
   * The back-in-stock container of this bar's own product section. "Learn more" and gift openers inject other
   * products' main sections (each with its own #esc-oos-form) into #product-info-dialog, which comes before <main>,
   * so a document-wide id lookup can return one of those copies.
   */
  _getBackInStock() {
    const section = this.closest(".shopify-section") ?? this._form?.closest(".shopify-section");
    if (!section || section.closest("#product-info-dialog")) return null;
    return section.querySelector("#esc-oos-form");
  }
  /**
   * Scrolls to and focuses the unchecked consent gate whose target selectors match a gated control inside the
   * back-in-stock form. Returns false when no such gate exists, so the regular notify flow runs.
   */
  _focusConsentGate(backInStock) {
    const gatedControls = [...backInStock.querySelectorAll("[data-consent-gate-disabled], .is-consent-gated")];
    if (gatedControls.length === 0) return false;
    const gate = [...document.querySelectorAll("[data-consent-gate]:not([hidden])")].find((root) => {
      // Skip gates in other products' sections that an overview opener left in #product-info-dialog.
      if (root.closest("#product-info-dialog")) return false;
      const checkbox = root.querySelector("[data-consent-gate-checkbox]");
      if (!checkbox || checkbox.checked) return false;
      return (root.getAttribute("data-target-selectors") || "").split(/[\n,]+/).some((selector) => {
        const trimmedSelector = selector.trim();
        if (!trimmedSelector) return false;
        try {
          return gatedControls.some((control) => control.matches(trimmedSelector));
        } catch (error) {
          return false;
        }
      });
    });
    if (!gate) return false;
    gate.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto", block: "center" });
    gate.querySelector("[data-consent-gate-checkbox]").focus({ preventScroll: true });
    return true;
  }
  /**
   * Moves the back-in-stock app's form (its live DOM, so the app keeps its references) into #product-info-dialog
   * and puts it back as soon as the dialog closes, before any other opener can replace the dialog content.
   */
  _openNotifyDialog(home) {
    const dialog = document.getElementById("product-info-dialog");
    const body = dialog?.querySelector(".dialog-body-box");
    if (!body || !home.firstElementChild || dialog.open) return false;
    const placeholder = document.createComment("back-in-stock position");
    home.before(placeholder);
    const restore = () => {
      if (dialog.open) return;
      dialog.removeEventListener("toggle", restore);
      placeholder.replaceWith(home);
    };
    body.replaceChildren(home);
    dialog.setAttribute("data-layout", "notify");
    dialog.addEventListener("toggle", restore);
    dialog.setAttribute("open", "");
    return true;
  }
  /**
   * Offers "Notify me" only once the back-in-stock app has mounted something to act on in this section's
   * #esc-oos-form (the Back in stock block always renders it empty); otherwise the disabled "Out of Stock" button.
   * The app fills and clears the container after variant changes, so it is watched for that.
   */
  _syncSoldOutAction() {
    const wrapper = this.closest(".add-to-cart-bar-wrapper");
    const notify = wrapper?.querySelector("[data-add-to-cart-bar-notify]");
    const outOfStock = wrapper?.querySelector("[data-add-to-cart-bar-out-of-stock]");
    if (!notify) return;
    const backInStock = this._getBackInStock();
    this._observeBackInStock(backInStock);
    // While "Notify me" shows the form in the dialog its container is empty; keep the button as it is.
    const dialog = document.getElementById("product-info-dialog");
    if (dialog?.open && dialog.getAttribute("data-layout") === "notify") return;
    const hasBackInStock = Boolean(backInStock?.querySelector("input, button, a[href], [role='button']"));
    notify.hidden = !hasBackInStock;
    if (outOfStock) outOfStock.hidden = hasBackInStock;
  }
  _observeBackInStock(backInStock) {
    if (!backInStock || backInStock === this._observedBackInStock || !this.isConnected) return;
    this._backInStockObserver ??= new MutationObserver(() => this._syncSoldOutAction());
    this._backInStockObserver.disconnect();
    this._backInStockObserver.observe(backInStock, { childList: true, subtree: true });
    this._observedBackInStock = backInStock;
  }
  _calculateExtraItemsPrice(items) {
    const priceTotal = items.reduce((sum, item) => {
      return sum + (item.price * item.quantity);
    }, 0);

    const comparePriceTotal = items.reduce((sum, item) => {
      return sum + (item.comparePrice * item.quantity);
    }, 0);

    this._form.dataset.itemsPriceTotal = priceTotal;
    this._form.dataset.itemsComparePriceTotal = comparePriceTotal;

    this._handlePriceEle()
  }
  _handleDisplay(available) {
    const formId = this._form?.id;
    if (!formId) return;
    const section = this._form.closest('.shopify-section');
    const wrapper = section?.querySelector('.add-to-cart-bar-wrapper');
    if (!wrapper) return;
    const checkoutButtons = section?.querySelectorAll(`button[is="custom-checkout-button"][form="${formId}"]`) ?? [];
    wrapper.toggleAttribute('data-sold-out', !available);
    if (!available) this._syncSoldOutAction();
    checkoutButtons.forEach((btn) => {
      btn.classList.toggle('hidden', !available);
      btn.disabled = !available || Boolean(this._form._isSubmitting);
    });
  }
  _updateBarDetails(variant) {
    const wrapper = this.closest(".add-to-cart-bar-wrapper");
    if (!wrapper) return;
    const title = wrapper.querySelector("[data-add-to-cart-bar-title]");
    if (title) title.textContent = variant["option1"] && variant["title"] !== "Default Title" ? variant["option1"] : title.dataset.productTitle;
    // The desktop and the mobile bar each keep their savings tag next to their own price.
    const savingsEle = this.closest(".prices-boxs")?.querySelector("[data-add-to-cart-bar-savings]");
    if (!savingsEle) return;
    const savings = (variant["compare_at_price"] || 0) - variant["price"];
    savingsEle.hidden = savings <= 0;
    // Only the amount element is replaced, so formats that put the currency in its own word ("CHF 150", "150 €")
    // and translations that place the amount anywhere in the sentence keep their wording.
    const savingsAmount = savingsEle.querySelector("[data-add-to-cart-bar-savings-amount]");
    if (savings > 0 && savingsAmount) {
      savingsAmount.textContent = formatMoney(savings, currencyFormat).replace(/[.,]00(?=\D*$)/, "");
    }
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this._handleDisplay(variant.available);
    this._updateBarDetails(variant);

    this._form.dataset.mainProductPrice = variant["price"];
    this._form.dataset.mainProductComparePrice = variant["compare_at_price"] || 0;

    this._handlePriceEle()
  }
  _handlePriceEle() {
    const mainProductPrice = Number(this._form.dataset.mainProductPrice);
    const mainProductComparePrice = Number(this._form.dataset?.mainProductComparePrice || 0);
    const itemsPriceTotal = Number(this._form.dataset?.itemsPriceTotal || 0);
    const itemsComparePriceTotal = Number(this._form.dataset?.itemsComparePriceTotal || 0);

    const price = mainProductPrice + itemsPriceTotal;
    const comparePrice = mainProductComparePrice + itemsComparePriceTotal;

    const salePriceEle = this.querySelector('.sale-price .price');
    salePriceEle.innerText = formatMoney(price, currencyFormat);

    const comparePriceEle = this.querySelector('.compare-price .price');
    comparePriceEle.hidden = !(comparePrice > price);
    comparePriceEle.innerText = formatMoney(comparePrice, currencyFormat);
    this.classList.toggle("text-on-sale", comparePrice > price);
  }
};
var SalePrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.dataset.price = variant["price"];
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat)));
    this.classList.toggle("text-on-sale", variant["compare_at_price"] > variant["price"]);
  }
};
var PointPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    const discount = this.getAttribute("current_discount");
    if (isNaN(discount)) {
      return;
    }
    const discountedPrice = Math.floor(parseFloat(variant["price"] * 0.00001 * discount));
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = currencyFormat || window.themeVariables.settings.moneyFormat;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatString.replace(placeholderRegex, discountedPrice)));
  }
};
var CompareAtPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.dataset.price = variant["compare_at_price"] || 0;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["compare_at_price"], currencyFormat)));
    this.hidden = !(variant["compare_at_price"] > variant["price"]);
  }
};
var UnitPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant["unit_price"]) {
      return this.hidden = true;
    }
    const referenceValue = variant["unit_price_measurement"]["reference_value"] !== 1 ? variant["unit_price_measurement"]["reference_value"] : "";
    const node = document.createRange().createContextualFragment(
      `${formatMoney(variant["unit_price"])}/${referenceValue}${variant["unit_price_measurement"]["reference_unit"]}`
    );
    this.lastChild.replaceWith(node);
    this.hidden = false;
  }
};
if (!window.customElements.get("add-to-cart-price")) {
  window.customElements.define("add-to-cart-price", AddToCartPrice);
}
if (!window.customElements.get("sale-price")) {
  window.customElements.define("sale-price", SalePrice);
}
if (!window.customElements.get("point-price")) {
  window.customElements.define("point-price", PointPrice);
}
if (!window.customElements.get("compare-at-price")) {
  window.customElements.define("compare-at-price", CompareAtPrice);
}
if (!window.customElements.get("unit-price")) {
  window.customElements.define("unit-price", UnitPrice);
}
var _onVariantChanged, onVariantChanged_fn;
var SoldOutBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChanged, onVariantChanged_fn).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChanged = new WeakSet();
onVariantChanged_fn = function(event) {
  this.hidden = event.detail.variant["available"];
};
var _onVariantChangedSale, onVariantChangedSale_fn;
var SoldOnBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChangedSale);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChangedSale, onVariantChangedSale_fn).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChangedSale = new WeakSet();
onVariantChangedSale_fn = function(event) {
  this.hidden = !event.detail.variant["available"];
};

var _onVariantChangedSaleRegion, onVariantChangedSaleRegion_fn;
var SoldOnBadgeByRegion = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this._regionBadgeInfo = JSON.parse(this.getAttribute("badge-info-json") || null);
    this._deviceRegion = window.sessionStorage.getItem("deviceRegion") || null;
    __privateAdd(this, _onVariantChangedSaleRegion);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChangedSaleRegion, onVariantChangedSaleRegion_fn).bind(this));
  }
  async _initText(regionBadgeInfo = this._regionBadgeInfo) {
    let deviceRegion = this._deviceRegion;
    
    if(!this._deviceRegion) {
      const deviceRegionInfo = await fetch(
        window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + `&country[exclude]=${window.Shopify.country}`
          + '&language[enabled]=true'
          + `&language[exclude]=${window.Shopify.language}`
      ).then(r => r.json());
      console.log('deviceRegionInfo: ', deviceRegionInfo);
      deviceRegion = await window.Shopify?.customerPrivacy?.getRegion();
      if(deviceRegionInfo?.detected_values?.country?.handle) {
        deviceRegion = deviceRegionInfo.detected_values.country.handle
      }
      if(deviceRegionInfo.suggestions && deviceRegionInfo.suggestions.length > 0) {
        let suggestion = deviceRegionInfo.suggestions[0]?.parts?.country?.handle;
        deviceRegion = suggestion;
      }
      this._deviceRegion = deviceRegion;
      window.sessionStorage.setItem('deviceRegion', deviceRegion);
    }
    
    const findInfo = regionBadgeInfo.find(item => item.key.toLocaleUpperCase() === deviceRegion.toLocaleUpperCase());
    const firstInfo = findInfo ? findInfo : regionBadgeInfo[0];
    const text = firstInfo?.value || '';
    this.innerHTML = text;
  }
  connectedCallback() {
    this._initText();
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChangedSaleRegion = new WeakSet();
onVariantChangedSaleRegion_fn = function(event) {
  this.hidden = !event.detail.variant["available"];
};

var _onVariantChanged2, onVariantChanged_fn2;
var OnSaleBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged2);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChanged2, onVariantChanged_fn2).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChanged2 = new WeakSet();
onVariantChanged_fn2 = function(event) {
  const variant = event.detail.variant;
  if (variant["compare_at_price"] > variant["price"]) {
    this.hidden = false;
    if (this.hasAttribute("discount-mode")) {
      const savings = this.getAttribute("discount-mode") === "percentage" ? `${Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])}%` : formatMoney(variant["compare_at_price"] - variant["price"]).replace(/[.,]00(?=\D*$)/, "");
      this.innerHTML = `${window.themeVariables.strings.discountBadge.replace("@@", savings)}`;
    }
  } else {
    this.hidden = true;
  }
};
if (!window.customElements.get("sold-out-badge")) {
  window.customElements.define("sold-out-badge", SoldOutBadge);
}
if (!window.customElements.get("sold-on-badge")) {
  window.customElements.define("sold-on-badge", SoldOnBadge);
}
if (!window.customElements.get("sold-on-badge-by-region")) {
  window.customElements.define("sold-on-badge-by-region", SoldOnBadgeByRegion);
}
if (!window.customElements.get("on-sale-badge")) {
  window.customElements.define("on-sale-badge", OnSaleBadge);
}
var VariantInventory = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variantId = event.detail.variant ? event.detail.variant["id"] : null;
    Array.from(this.children).forEach((item) => item.toggleAttribute("hidden", variantId !== parseInt(item.getAttribute("data-variant-id"))));
  }
};
if (!window.customElements.get("variant-inventory")) {
  window.customElements.define("variant-inventory", VariantInventory);
}
var VariantMedia = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    this.sizesAttribute = this.querySelector("img").sizes;
    this.classAttribute = this.querySelector("img").className;
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  get widths() {
    return this.getAttribute("widths").split(",").map((width) => parseInt(width));
  }
  _onVariantChanged(event) {
    if (!event.detail.variant || !event.detail.variant["featured_media"]) {
      return;
    }
    this.replaceChildren(createMediaImg(event.detail.variant["featured_media"], this.widths, { "class": this.classAttribute, "sizes": this.sizesAttribute }));
  }
};
if (!window.customElements.get("variant-media")) {
  window.customElements.define("variant-media", VariantMedia);
}
var VariantSku = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.hidden = true;
    } else {
      this.innerText = `${window.themeVariables.strings.sku} ${event.detail.variant["sku"]}`;
      this.hidden = !event.detail.variant["sku"];
    }
  }
};
if (!window.customElements.get("variant-sku")) {
  window.customElements.define("variant-sku", VariantSku);
}

// js/common/product/product-gallery.js
import { PhotoSwipeLightbox } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var ProductGallery = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
    this._carousels = Array.from(this.querySelectorAll("media-carousel"));
    this._pageDots = Array.from(this.querySelectorAll("page-dots"));
    this._viewInSpaceButton = this.querySelector("[data-shopify-xr]");
    this._customCursor = this.querySelector(".product-gallery__cursor");
    this._counter = this.querySelector("[data-media-counter]");
    this.addEventListener("carousel:change", this._onCarouselChanged);
    if (this._viewInSpaceButton) {
      this.addEventListener("carousel:settle", this._updateViewInSpaceButton);
    }
    if (this.hasAttribute("allow-zoom")) {
      this.addEventListener("lightbox:open", (event) => this.openZoom(event.detail.index));
    }
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  get photoswipe() {
    if (this._photoswipe) {
      return this._photoswipe;
    }
    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import("//eu.mammotion.com/cdn/shop/t/22/assets/photoswipe.min.js?v=159632402815393782351766139973"),
      bgOpacity: 1,
      maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      // UX
      arrowPrev: false,
      arrowNext: false,
      counter: true,
      zoom: false,
      closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
        <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
        <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
        <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
      </svg>`
    });
    photoswipe.addFilter("thumbEl", (thumbEl, data) => data["thumbnailElement"]);
    photoswipe.on("uiRegister", () => {
      photoswipe.pswp.ui.registerElement({
        name: "bottom-bar",
        order: 5,
        appendTo: "wrapper",
        html: `
          <div class="pagination">
            <button class="pagination__item group" rel="prev">
              <span class="animated-arrow animated-arrow--reverse"></span>
            </button>
            
            <span class="pagination__current text-sm">
              <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
            </span>
            
            <button class="pagination__item group" rel="next">
              <span class="animated-arrow"></span>
            </button>
          </div>
        `,
        onInit: (el, pswp) => {
          el.querySelector(".pagination__page-count").innerText = pswp.getNumItems();
          el.querySelector('[rel="prev"]')?.addEventListener("click", () => pswp.prev());
          el.querySelector('[rel="next"]')?.addEventListener("click", () => pswp.next());
          pswp.on("change", () => {
            el.querySelector(".pagination__current-page").innerText = pswp.currIndex + 1;
          });
        }
      });
    });
    photoswipe.init();
    return this._photoswipe = photoswipe;
  }
  /**
   * Open the zoom by dynamically creating a data source based on the filtered items
   */
  openZoom(index = 0) {
    const dataSource = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) > img:not(.product-gallery__border-image)')).map((image) => {
      return {
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: true
      };
    });
    this.photoswipe.loadAndOpen(index, dataSource);
  }
  _updateViewInSpaceButton(event) {
    if (event.detail.slide.getAttribute("data-media-type") === "model") {
      this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", event.detail.slide.getAttribute("data-media-id"));
    } else {
      this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", this._viewInSpaceButton.getAttribute("data-shopify-model3d-default-id"));
    }
  }
  _onCarouselChanged(event) {
    if (this._customCursor) {
      this._customCursor.toggleAttribute("hidden", event.detail.slide.getAttribute("data-media-type") !== "image");
    }
    this._updateCounter(event.detail.slide);
  }
  /**
   * Keep the "current/total" counter on the slide the carousel reports, counting only the
   * media that the selected variant has not filtered out.
   */
  _updateCounter(slide) {
    if (!this._counter || !slide) {
      return;
    }
    const carousel = slide.closest("media-carousel");
    const visibleSlides = carousel ? carousel.items.filter((item) => !item.hidden) : [];
    const current = visibleSlides.indexOf(slide) + 1;
    if (current < 1) {
      return;
    }
    const total = visibleSlides.length;
    this._counter.querySelector("[data-media-counter-current]").textContent = current;
    this._counter.querySelector("[data-media-counter-total]").textContent = total;
    const label = this._counter.querySelector("[data-media-counter-label]");
    if (label && window.themeVariables?.strings?.itemNthOfCount) {
      label.textContent = window.themeVariables.strings.itemNthOfCount.replace("@index@", current).replace("@count@", total);
    }
  }
  _onVariantChanged(event) {
    const filteredIndexes = this._getFilteredMediaIndexes(event.detail.product, event.detail.variant);
    this._carousels.forEach((carousel) => carousel.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes } })));
    this._pageDots.forEach((pageDots) => pageDots.dispatchEvent(new CustomEvent("control:filter", { detail: { filteredIndexes } })));
    if (event.detail.variant["featured_media"] && event.detail.previousVariant["featured_media"] && event.detail.previousVariant["featured_media"]["id"] !== event.detail.variant["featured_media"]["id"] || !event.detail.previousVariant["featured_media"] && event.detail.variant["featured_media"]) {
      this._carousels.forEach((carousel) => carousel.select(event.detail.variant["featured_media"]["position"] - 1, { animate: false }));
    }
    // Filtering only hides slides, so without a featured media change the carousel can stay on a slide the new
    // variant no longer shows; select a visible one so the counter and thumbnails follow.
    this._carousels.forEach((carousel) => this._selectNearestVisibleSlide(carousel));
    const carousel = this._carousels[0];
    if (carousel) {
      this._updateCounter(carousel.selectedSlide);
    }
  }
  _selectNearestVisibleSlide(carousel) {
    const items = carousel.items;
    const selectedIndex = carousel.selectedIndex;
    if (!items[selectedIndex]?.hidden) {
      return;
    }
    // Prefer the slide the scroll position already shows (as ScrollCarousel does on scroll), so the media does not move.
    const itemOffset = carousel.itemOffset;
    let index = itemOffset ? items.indexOf(carousel.visibleItems[Math.round(carousel.scrollLeft / itemOffset)]) : -1;
    // Otherwise (gallery not laid out) the nearest visible slide in DOM order; on a tie the following one wins.
    for (let distance = 1; index < 0 && distance < items.length; distance++) {
      index = [selectedIndex + distance, selectedIndex - distance].find((candidate) => items[candidate] && !items[candidate].hidden) ?? -1;
    }
    if (index >= 0) {
      carousel.select(index, { animate: false });
    }
  }
  _getFilteredMediaIndexes(product, variant) {
    const filteredMediaIds = [];
    product["media"].forEach((media) => {
      let matchMedia = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
      if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
        if (!matchMedia) {
          const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
          product["options"].forEach((option) => {
            if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
              if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                filteredMediaIds.push(media["position"] - 1);
              }
            }
          });
        }
      }
    });
    return filteredMediaIds;
  }
};
var MediaCarousel = class extends ScrollCarousel {
  connectedCallback() {
    super.connectedCallback();
    this._onGestureChangedListener = this._onGestureChanged.bind(this);
    this.addEventListener("gesturestart", this._onGestureStart, { capture: false, signal: this._abortController.signal });
    this.addEventListener("carousel:settle", this._onMediaSettled, { signal: this._abortController.signal });
    this.addEventListener("click", this._onGalleryClick, { signal: this._abortController.signal });
  }
  _onMediaSettled(event) {
    const media = event.detail.slide;
    this.items.filter((item) => ["video", "external_video", "model"].includes(item.getAttribute("data-media-type"))).forEach((item) => item.firstElementChild.pause());
    switch (media.getAttribute("data-media-type")) {
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay")) {
          media.firstElementChild.play();
        }
        break;
      case "model":
        if (window.matchMedia("(min-width: 1000px)").matches) {
          media.firstElementChild.play();
        }
        break;
    }
  }
  _onGalleryClick(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope") || !window.matchMedia("screen and (pointer: fine)").matches) {
      return;
    }
    if (this.selectedSlide.getAttribute("data-media-type") !== "image") {
      return;
    }
    const rect = event.currentTarget.getBoundingClientRect(), offsetX = event.clientX - rect.left;
    offsetX > this.clientWidth / 2 ? this.next() : this.previous();
  }
  _onGestureStart(event) {
    event.preventDefault();
    this.addEventListener("gesturechange", this._onGestureChangedListener, { capture: false, signal: this._abortController.signal });
  }
  _onGestureChanged(event) {
    event.preventDefault();
    if (event.scale > 1.5) {
      this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: this.selectedIndexAmongVisible } }));
      this.removeEventListener("gesturechange", this._onGestureChangedListener);
    }
  }
};
var ProductZoomButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
  }
  _onButtonClicked() {
    let media = this.closest(".product-gallery__media"), openIndex;
    if (media) {
      const visibleImages = this.closest("media-carousel").visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(media);
    } else {
      const carousel = this.closest(".product-gallery__media-list-wrapper").querySelector("media-carousel"), visibleImages = carousel.visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(carousel.selectedSlide);
    }
    this.dispatchEvent(new CustomEvent("lightbox:open", {
      bubbles: true,
      detail: {
        index: openIndex
      }
    }));
  }
};
if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}
if (!window.customElements.get("product-zoom-button")) {
  window.customElements.define("product-zoom-button", ProductZoomButton, { extends: "button" });
}
if (!window.customElements.get("media-carousel")) {
  window.customElements.define("media-carousel", MediaCarousel);
}

// js/common/product/quick-add.js
var _scopeFromPassed, _scopeToReached, _intersectionObserver;
var ProductQuickAdd = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _scopeFromPassed, false);
    __privateAdd(this, _scopeToReached, false);
    __privateAdd(this, _intersectionObserver, new IntersectionObserver(this._onObserved.bind(this)));
  }
  connectedCallback() {
    // The sticky bar hides once the footer shows; since the navigation upgrade it is footer-v2 (sections/footer-v2.liquid).
    this._scopeTo = document.querySelector(".footer, .footer-v2");
    // The hide-while attribute (a CSS selector list): the bar follows the whole page and only hides while one of those
    // elements (the purchase summary, or the back-in-stock form that replaces it) is on screen, or once the footer is reached.
    this._hideSelector = this.getAttribute("hide-while");
    if (this._hideSelector) {
      this._hideTargets = [];
      this._hideTargetVisible = false;
      this._visibleHideTargets = new Set();
      // Some targets only appear later (the back-in-stock app inserts its form after a sold-out variant is picked),
      // so the selector is re-resolved whenever the section's markup changes.
      this._syncHideTargets();
      this._hideTargetsObserver = new MutationObserver(() => {
        if (this._hideTargetsFrame) return;
        this._hideTargetsFrame = requestAnimationFrame(() => {
          this._hideTargetsFrame = 0;
          this._syncHideTargets();
        });
      });
      this._hideTargetsObserver.observe(this.closest(".shopify-section") || document.body, { childList: true, subtree: true });
      if (this._scopeTo) __privateGet(this, _intersectionObserver).observe(this._scopeTo);
      // show-after (a CSS selector): on phones (below 768px, single column) the bar stays hidden on the first screen
      // until that element (the media) has scrolled above the viewport. Pad and PC show it from the start.
      const showAfter = this.getAttribute("show-after");
      this._showAfterTarget = showAfter ? document.querySelector(showAfter) : null;
      this._showAfterPassed = false;
      if (this._showAfterTarget) {
        this._stackedLayoutQuery = window.matchMedia("screen and (max-width: 767px)");
        this._abortController = new AbortController();
        this._stackedLayoutQuery.addEventListener("change", () => this._updateVisibility(), { signal: this._abortController.signal });
        __privateGet(this, _intersectionObserver).observe(this._showAfterTarget);
      }
      this._updateVisibility();
      return;
    }
    // this._scopeFrom = document.getElementById(this.getAttribute("form"));
    // 修改显现 ProductQuickAdd 时机
    this._scopeFrom = document.querySelector("product-gallery") || document.getElementById(this.getAttribute("form"));
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    __privateGet(this, _intersectionObserver).observe(this._scopeFrom);
    __privateGet(this, _intersectionObserver).observe(this._scopeTo);
  }
  disconnectedCallback() {
    __privateGet(this, _intersectionObserver).disconnect();
    this._hideTargetsObserver?.disconnect();
    if (this._hideTargetsFrame) cancelAnimationFrame(this._hideTargetsFrame);
    this._hideTargetsFrame = 0;
    this._abortController?.abort();
  }
  /**
   * Observe the elements currently matching hide-while; stop observing (and forget the visibility of) any that left.
   */
  _syncHideTargets() {
    const observer = __privateGet(this, _intersectionObserver);
    const next = [...document.querySelectorAll(this._hideSelector)];
    this._hideTargets.forEach((target) => {
      if (next.includes(target)) return;
      observer.unobserve(target);
      this._visibleHideTargets.delete(target);
    });
    next.forEach((target) => {
      if (!this._hideTargets.includes(target)) observer.observe(target);
    });
    this._hideTargets = next;
    this._hideTargetVisible = this._visibleHideTargets.size > 0;
    this._updateVisibility();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      if (this._hideTargets?.includes(entry.target)) {
        // An empty or hidden target (e.g. the back-in-stock block of an available variant) never hides the bar.
        if (entry.isIntersecting && entry.boundingClientRect.height > 0) {
          this._visibleHideTargets.add(entry.target);
        } else {
          this._visibleHideTargets.delete(entry.target);
        }
        this._hideTargetVisible = this._visibleHideTargets.size > 0;
      }
      if (entry.target === this._showAfterTarget) {
        this._showAfterPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      }
      if (entry.target === this._scopeFrom) {
        __privateSet(this, _scopeFromPassed, entry.boundingClientRect.bottom < 0);
      }
      if (entry.target === this._scopeTo) {
        __privateSet(this, _scopeToReached, entry.isIntersecting);
      }
    });
    this._updateVisibility();
  }
  _updateVisibility() {
    if (this._hideSelector) {
      const firstScreenPassed = !this._showAfterTarget || !this._stackedLayoutQuery.matches || this._showAfterPassed;
      this.classList.toggle("is-visible", firstScreenPassed && !this._hideTargetVisible && !__privateGet(this, _scopeToReached));
      return;
    }
    this.classList.toggle("is-visible", __privateGet(this, _scopeFromPassed) && !__privateGet(this, _scopeToReached));
  }
};
_scopeFromPassed = new WeakMap();
_scopeToReached = new WeakMap();
_intersectionObserver = new WeakMap();
if (!window.customElements.get("product-quick-add")) {
  window.customElements.define("product-quick-add", ProductQuickAdd);
}


var ReplaceNBSP = class extends HTMLElement {
  constructor() {
    super();
    this._content = this.getAttribute("content");
    this._flag = this.getAttribute("flag");
  }
  connectedCallback() {
    if(this._flag) {
      if (this._content) {
        this.innerHTML = this._content.replace(/&nbsp;|\s+/g, ' ');
      }
    }
  }
  disconnectedCallback() {
  }
};
if (!window.customElements.get("replace-nbsp")) {
  window.customElements.define("replace-nbsp", ReplaceNBSP);
}

// js/common/product/quick-buy-drawer.js
var QuickBuyDrawer = class extends Drawer {
  constructor() {
    super();
    this._hasLoaded = false;
    this.addEventListener("variant:add", this._onVariantAdded.bind(this));
    this._url = this.getAttribute("url");
    // Drawers rendered without a url attribute (accessory-product-list, horizontal-product) resolve to the site root
    // instead of throwing "Invalid URL" on origin + "null".
    const productUrl = new URL(this._url ?? "", window.location.origin);
    this._variantId = productUrl.searchParams.get("variant") || '';
  }
  async show() {
    this.style.display = "block";
    if (!this._hasLoaded) {
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "true"));
      const responseContent = await (await fetch(`${window.Shopify.routes.root}products/${this.getAttribute("handle")}${this._variantId ? `?variant=${this._variantId}` : ''}`)).text();
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "false"));
      const productDocument = new DOMParser().parseFromString(responseContent, "text/html");
      const quickBuyContent = productDocument.getElementById("quick-buy-content").content;
      // The Variant picker and Buy buttons blocks each render their drawer copy in a template; merge them in
      // block order into the drawer slot (sections/main-product.liquid).
      const quickBuySlot = quickBuyContent.querySelector("[data-quick-buy-parts]");
      if (quickBuySlot) {
        productDocument.querySelectorAll("template[data-quick-buy-part]").forEach((part) => quickBuySlot.append(part.content.cloneNode(true)));
      }
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      // DOMParser leaves the fetched inline scripts inert, so the product's gift data (window.variantMetafields, set by
      // snippets/buy-buttons.liquid) would be missing whenever the host page does not publish it, and a variant change
      // or Buy Now in the drawer would drop the gifts. Run only those data scripts, before the drawer connects.
      [...productDocument.scripts, ...quickBuyContent.querySelectorAll("script")]
        .filter((script) => !script.src && script.textContent.includes("window.variantMetafields["))
        .forEach((script) => {
          const dataScript = document.createElement("script");
          dataScript.textContent = script.textContent;
          document.head.append(dataScript);
          dataScript.remove();
        });
      this.replaceChildren(quickBuyContent);
      Shopify.PaymentButton?.init();
      this._hasLoaded = true;
    }
    return super.show();
  }
  async hide() {
    return super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  /**
   * 加购成功后立刻关掉变体抽屉，并打开购物车抽屉。
   * 不把 variant-added 塞进当前抽屉（会得到空白面板），也不等待关闭动画结束再开购物车。
   */
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "drawer") {
      return;
    }
    event.detail.blockCartDrawerOpening = true;
    this.style.display = "none";
    this.hide();
    document.querySelector("cart-drawer")?.show();
  }
};
if (!window.customElements.get("quick-buy-drawer")) {
  window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
}

var UpdateForm = class {
  constructor(formId, productId, variantId) {
    this.form = document.forms[formId];
    
    if(this.form) {
      try {
        const configuredGifts = window.variantMetafields?.[productId]?.[variantId]?.gifts;
        const gifts = Array.isArray(configuredGifts) ? configuredGifts : [];
        
        // 移除现有的 items[][id] 和 items[][quantity] 输入框
        const existingInputs = this.form.querySelectorAll('input[name="items[][id]"], input[name="items[][quantity]"]');
        existingInputs.forEach(input => input.remove());
        
        if(gifts.length === 0) return;
        
        // 根据 gifts 数组生成新的输入框
        gifts.forEach(gift => {
          if(gift.available === false) return; // 不可用的赠品不加入购物车

          // 创建 items[][id] 输入框
          const idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'items[][id]';
          idInput.className = `test-${new Date().getTime()}`;
          idInput.value = gift.variantId;

          // 创建 items[][quantity] 输入框
          const quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = 'items[][quantity]';
          quantityInput.value = gift.quantity;

          // 将输入框添加到表单中
          this.form.appendChild(idInput);
          this.form.appendChild(quantityInput);
        });
    
      } catch (error) {
        console.error("Error in UpdateForm: ", error);
      }
    } else {
      console.warn(`The form with id ${formId} does not exist.`);
      return;
    }
  }
}

// js/common/product/variant-picker.js
// Pending picker refresh per product form id (see VariantPicker.updateHTML).
var variantPickerRequests = new Map();
// Section Rendering URL for a product variant. It keeps the page's preview_key: a product that is not published to the
// online store renders only with it (the admin "Preview" link), and without it the section request returns 404, so a
// variant change in that preview left the option pills, gifts and delivery text out of date.
function productVariantSectionUrl(handle, variantId, sectionId) {
  const url = new URL(`${Shopify.routes.root}products/${handle}`, window.location.origin);
  url.searchParams.set("variant", variantId);
  url.searchParams.set("section_id", sectionId);
  const previewKey = new URLSearchParams(window.location.search).get("preview_key");
  if (previewKey) url.searchParams.set("preview_key", previewKey);
  return url.toString();
}
var VariantPicker = class extends HTMLElement {
  async connectedCallback() {
    this._abortController = new AbortController();
    const productForm = document.forms[this.getAttribute("form")];
    this.masterSelector = productForm?.querySelector('[name="id"]');
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));
    if (!this.masterSelector) {
      console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    
    // 前缘节流（立即执行第一次）
    function throttleImmediate(fn, delay) {
      let canRun = true;
      
      return function(...args) {
        if (canRun) {
          // 第一次立即执行
          fn.apply(this, args);
          canRun = false;
          
          setTimeout(() => {
            canRun = true;
          }, delay);
        }
        // 后续在冷却期内的调用被忽略
      };
    }
    
    // 按钮点击，立即执行第一次，1秒内忽略后续点击
    const clickOptions = throttleImmediate(
      () => {
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        requestAnimationFrame(() => {
          window.scrollTo(scrollX, scrollY);
        })
      },
      1000
    );

    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("change", this._onOptionChanged.bind(this), { signal: this._abortController.signal });
      
      optionSelector.addEventListener('click', clickOptions);
    });
    this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this), { signal: this._abortController.signal });
    this._updateDisableSelectors();
    // An option picked while the product data was loading had no listener yet: the radio changed but the form kept the
    // old variant. Follow the checked options; they match the form's variant when nothing was picked early.
    const checkedVariant = this._getVariantFromOptions();
    this.selectVariant((checkedVariant ?? this.selectedVariant)["id"]);

  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  /**
   * Select a new variant by its ID
   */
  selectVariant(id) {
    if (!this._isVariantSelectable(this._getVariantById(id))) {
      id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
    }
    // Gift inputs follow the variant that is actually selected, after an unselectable choice fell back to another one.
    new UpdateForm(this.getAttribute("form"), this.product.id, id);
    const previousVariant = this.selectedVariant;
    if (previousVariant && previousVariant.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    this._updateDisableSelectors();
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.selectedVariant,
        previousVariant
      }
    }));

    // 更新 swatch-variant-detail-wrapper 内容
    this.updateHTML();
  }
  // async updateHTML() {
  //   const section = this.closest(".shopify-section");
  //   const url = `${Shopify.routes.root}products/${this.productHandle}?variant=${this.selectedVariant.id}&section_id=${section.id.replace("shopify-section-", "")}`;
  //   const response = await fetch(url, { priority: "low" });
  //   const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html");
  //   console.log('===tempDiv: ', tempDiv);
  //   // 变体切换后，需要隐藏或者替换内容
  //   this.innerHTML = tempDiv.querySelector('.product-info__variant-picker variant-picker').innerHTML;

  //   // const options = this._getSelectedOptionValues();
  //   // const option2Value = options[1];
  //   // const option2Handle = this.handleize(option2Value);

  //   // const fieldsetElement = tempDiv.querySelector(`fieldset.option-2 .swatch-detail-wrapper.value-${option2Handle}`);
  //   // console.log('fieldsetElement: ', fieldsetElement);
  //   // const oldFieldsetElement = this.querySelector(`fieldset.option-2 .swatch-detail-wrapper.value-${option2Handle}`);
  //   // console.log('oldFieldsetElement: ', oldFieldsetElement);
  //   // if(fieldsetElement) {
  //   //   // 替换内容
  //   //   oldFieldsetElement.innerHTML = fieldsetElement.innerHTML;
  //   // }
  // }

  /**
   * Re-render the picker for the selected variant (swatch details depend on it).
   * Only the response for the variant that is still selected may replace the picker: rapid
   * clicks used to let an earlier, slower response win and leave the options showing a
   * different variant than the form. The pending request is tracked per product form because
   * each successful update replaces this element.
   */
  async updateHTML() {
    const section = this.closest(".shopify-section");
    const formId = this.getAttribute("form");
    const variantId = this.selectedVariant?.id;
    if (!section || !variantId) return;

    variantPickerRequests.get(formId)?.abort();
    const controller = new AbortController();
    variantPickerRequests.set(formId, controller);

    const url = productVariantSectionUrl(this.productHandle, variantId, section.id.replace("shopify-section-", ""));
    let htmlText;
    try {
      const response = await fetch(url, { priority: "low", signal: controller.signal });
      if (!response.ok) return;
      htmlText = await response.text();
    } catch (error) {
      if (error.name !== "AbortError") console.error("Variant picker could not be refreshed.", error);
      return;
    } finally {
      if (variantPickerRequests.get(formId) === controller) variantPickerRequests.delete(formId);
    }

    if (controller.signal.aborted || !this.isConnected || String(this.masterSelector?.value) !== String(variantId)) return;

    const newPicker = new DOMParser().parseFromString(htmlText, "text/html").querySelector("variant-picker");
    if (!newPicker) return;
    newPicker.querySelectorAll("noscript").forEach((fallback) => fallback.remove());

    // Keep keyboard focus on the same control after the swap.
    const focusedId = this.contains(document.activeElement) ? document.activeElement.id : "";

    this.disconnectedCallback();
    this.replaceWith(newPicker);
    customElements.upgrade(newPicker);

    if (focusedId) newPicker.querySelector(`#${CSS.escape(focusedId)}`)?.focus({ preventScroll: true });
  }
  _onOptionChanged(event) {
    if (!event.target.name.startsWith("option")) {
      return;
    }
    // A nested option selector (custom.bundle_option_in_card) sits inside the first one; handle its change only once.
    if (event.target.closest("[data-option-selector]") !== event.currentTarget) {
      return;
    }
    this.selectVariant(this._getVariantFromOptions()?.id);
  }
  _onMasterSelectorChanged() {
    const options = this.selectedVariant?.options || [];
    options.forEach((value, index) => {
      let input = this.optionSelectors[index].querySelector(`input[type="radio"][name="option${index + 1}"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
      if (input.tagName === "SELECT" || input.tagName === "INPUT" && input.type === "hidden") {
        triggerChangeEvent = input.value !== value;
        input.value = value;
      } else if (input.tagName === "INPUT" && input.type === "radio") {
        triggerChangeEvent = !input.checked && input.value === value;
        input.checked = input.value === value;
      }
      if (triggerChangeEvent) {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  /**
   * Get the product variant by its ID
   */
  _getVariantById(id) {
    return this.product["variants"].find((variant) => variant["id"] === id);
  }
  /**
   * Get the variant based on the options
   */
  _getVariantFromOptions() {
    const options = this._getSelectedOptionValues();
    return this.product["variants"].find((variant) => {
      return variant["options"].every((value, index) => value === options[index]);
    });
  }
  /**
   * Detect if a specific variant is selectable. This is used when the "hide sold out variant" option is enabled, to allow
   * returning true only if the variant is actually available
   */
  _isVariantSelectable(variant) {
    if (!variant) {
      return false;
    } else {
      return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
    }
  }
  /**
   * This method is used internally to select an available or selectable variant, when the current choice does not
   * match the requirements. For instance, if sold out variants are configured to be hidden, but that the choices end
   * up being a non-valid variant, the theme automatically changes the variant to match the requirements. In the case
   * the customer end up on variant combinations that do not exist, it also switches to a valid combination.
   *
   * The algorithm is as follows: if we have for instance three options "Color", "Size" and "Material", we pop the last
   * option (Material) and try to find the first available variant for the given Color and Size. If none is found we
   * remove the second option (Size) and try to find the first available variant for the selected color. Finally, if none
   * is found we return the first available variant independently of any choice.
   */
  _getFirstMatchingAvailableOrSelectableVariant() {
    let options = this._getSelectedOptionValues(), matchedVariant = null, slicedCount = 0;
    do {
      options.pop();
      slicedCount += 1;
      matchedVariant = this.product["variants"].find((variant) => {
        if (this.hideSoldOutVariants) {
          return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        } else {
          return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        }
      });
    } while (!matchedVariant && options.length > 0);
    return matchedVariant;
  }
  _getSelectedOptionValues() {
    // Read each option by its own name: the nested second option is inside the first option's selector.
    return this.optionSelectors.map((optionSelector, index) => {
      const name = `option${index + 1}`;
      return optionSelector.querySelector(`input[name="${name}"][type="hidden"], input[name="${name}"]:checked, select[name="${name}"]`).value;
    });
  }
  /**
   * We add specific class to sold out variants based on the selectors
   */
  _updateDisableSelectors() {
    const selectedVariant = this.selectedVariant;
    if (!selectedVariant) {
      return;
    }
    const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
      // Only this selector's own values: the nested second option's values sit inside the first option's selected card.
      const optionValue = Array.from(selector.querySelectorAll("[data-option-value]")).filter((element) => element.closest("[data-option-selector]") === selector)[valueIndex];
      optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        optionValue.toggleAttribute("hidden", !available);
      } else {
        optionValue.classList.toggle("is-disabled", !available);
      }
    };
    if (this.optionSelectors && this.optionSelectors[0]) {
      this.product["options"][0]["values"].forEach((value, valueIndex) => {
        const hasAtLeastOneCombination = this.product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = this.product["variants"].some((variant) => variant["option1"] === value && variant["available"]);
        applyClassToSelector(this.optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
        if (this.optionSelectors[1]) {
          this.product["options"][1]["values"].forEach((value2, valueIndex2) => {
            const hasAtLeastOneCombination2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
            applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
            if (this.optionSelectors[2]) {
              this.product["options"][2]["values"].forEach((value3, valueIndex3) => {
                const hasAtLeastOneCombination3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
                applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
              });
            }
          });
        }
      });
    }
  }
};
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    this.innerHTML = event.detail.variant[this.getAttribute("for")];
  }
};
if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}
if (!window.customElements.get("variant-option-value")) {
  window.customElements.define("variant-option-value", VariantOptionValue);
}

var VariantOffer = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._productForm = document.forms[this.getAttribute("form")];
    this._showList = this.getAttribute("show-list");
    if(this._showList) {
      this.showList = this._showList.split(/,\s*/);
    }
    this._default = this.getAttribute("default");
  }
  connectedCallback() {
    // 判断当前的变体ID是否属于列表中的变体
    if (this.showList && this.showList.includes(this._default)) {
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }
    this._productForm.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    this._productForm.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (event.detail.variant) {
      if(this.showList && this.showList.includes(event.detail.variant.id+'')) {
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
      }
    }
  }
}

if (!window.customElements.get("variant-offer")) {
  window.customElements.define("variant-offer", VariantOffer);
}

var AfterPayMsgWrapper = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._productForm = document.forms[this.getAttribute("form")];
    this._amountKey = this.getAttribute("amount-key");
    this._amountHandle = this.getAttribute("amount-handle");
  }
  connectedCallback() {
    this._productForm.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    this._productForm.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    let price = event.detail.variant.price || 0;
    // paypal need
    if(this._amountHandle == 'float') {
      price = event.detail.variant.price / 100
    }

    if (price > 0) {
      const ele = this.querySelector(this.getAttribute('selector'));
      
      this.querySelector(this.getAttribute('selector'))?.setAttribute(this._amountKey, price)
    }
  }
};
if (!window.customElements.get("after-pay-msg-wrapper")) {
  window.customElements.define("after-pay-msg-wrapper", AfterPayMsgWrapper);
}

var AfterPayMsgInfo = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChanged = this._onVariantChanged.bind(this);
    
    this._type = 'klarna';
    
    if(this._type === 'paypal') {
      this.elementName = '.paypal-product-info';
      this._amountAttribute = 'data-pp-amount';
      this._locale = 'DE';
      this._currency = 'EUR';
    } else if (this._type === 'klarna') {
      this.elementName = 'klarna-placement';
      this._amountAttribute = 'data-purchase-amount';
      this._locale = 'en-NL';
      this._currency = 'EUR';
    }
  }
  
  // 监听 amount / pp-text-color 属性变化
  static get observedAttributes() {
    return ['amount', 'pp-text-color'];
  }

  // get amout, 当type 为paypal 时，除100
  get amount() {
    const amount = this.getAttribute('amount') || '0';
    return this._type === 'paypal' ? (parseFloat(amount) / 100).toFixed(2) : amount;
  }

  _getPaypalTextColor() {
    return this.getAttribute('pp-text-color') || 'black';
  }

  _resolveCssTextColor() {
    const ppTextColor = this._getPaypalTextColor();
    if (ppTextColor === 'white') return '#ffffff';
    if (ppTextColor === 'black') return '#000000';
    return ppTextColor;
  }

  _applyKlarnaPresentation() {
    const paymentEl = this.querySelector(this.elementName);
    if (!paymentEl || this._type !== 'klarna') return;

    const isLightText = this._getPaypalTextColor() === 'white';
    paymentEl.setAttribute('data-theme', isLightText ? 'dark' : 'default');
    paymentEl.setAttribute(
      'exportparts',
      'osm-container, osm-badge-container, osm-badge, osm-message, osm-cta, osm-legal, osm-logo'
    );
  }

  _applyPaypalTextColor() {
    const textColor = this._resolveCssTextColor();
    this.style.color = textColor;

    const paymentEl = this.querySelector(this.elementName);
    if (!paymentEl) return;

    if (this._type === 'klarna') {
      this._applyKlarnaPresentation();
    } else if (this._type === 'paypal') {
      paymentEl.style.color = textColor;
      paymentEl.setAttribute('data-pp-style-text-color', textColor);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    if (name === 'amount') {
      this._updateAmount(newValue);
    } else if (name === 'pp-text-color') {
      this._applyPaypalTextColor();
    }
  }

  connectedCallback() {
    // 初始化支付信息元素
    if(this._type === 'paypal') {
      this._renderPaypalPaymentMessage();
    } else if (this._type === 'klarna') {
      this._renderKlarnaPaymentMessage();
    }
    this._applyPaypalTextColor();

    // 监听变体变化
    const form = document.querySelector(`form[id="${this.getAttribute('form')}"]`);
    if (form) {
      form.addEventListener('variant:change', this._onVariantChanged);
    }
  }
  
  disconnectedCallback() {
    const form = document.querySelector(`form[id="${this.getAttribute('form')}"]`);
    if (form) {
      form.removeEventListener('variant:change', this._onVariantChanged);
    }
  }
  
  _renderKlarnaPaymentMessage() {
    // 清空现有内容
    this.innerHTML = '';
    
    // 创建支付信息元素（示例使用Klarna）
    const paymentEl = document.createElement(this.elementName);
    paymentEl.setAttribute('data-key', 'credit-promotion-badge');
    paymentEl.setAttribute('data-theme', 'default');
    paymentEl.setAttribute('data-locale', this.getAttribute('locale') || this._locale);
    paymentEl.setAttribute('data-currency', this.getAttribute('currency') || this._currency);
    paymentEl.setAttribute(this._amountAttribute, this.amount);
    paymentEl.setAttribute(
      'exportparts',
      'osm-container, osm-badge-container, osm-badge, osm-message, osm-cta, osm-legal, osm-logo'
    );
    
    // 添加到组件内部
    this.appendChild(paymentEl);
    this._applyKlarnaPresentation();
  }
  
  _renderPaypalPaymentMessage() {
    // 创建支付信息元素
    this.innerHTML = `
      <div
        class="paypal-product-info"
        data-pp-message
        data-pp-style-layout="text"
        data-pp-style-logo-type="inline"
        data-pp-style-text-color="${this._getPaypalTextColor()}"
        data-pp-style-text-size="12"
        data-pp-buyerCountry="${this._locale}"
        data-pp-amount="${this.amount}"
        data-pp-placement="product"
      ></div>
    `;
  }
  
  _onVariantChanged(event) {
    const price = event.detail.variant?.price || 0;
    this.setAttribute('amount', price);
    
    this._updateAmount(price);
  }
  
  _updateAmount(price) {
    const paymentEl = this.querySelector(this.elementName);
    if (paymentEl) {
      paymentEl.setAttribute(this._amountAttribute, this.amount);
    }
  }
}
if (!window.customElements.get("after-pay-msg-info")) {
  window.customElements.define("after-pay-msg-info", AfterPayMsgInfo);
}

var CustomAfterPayMsg = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChanged = this._onVariantChanged.bind(this);
    this._timestamp = crypto.randomUUID();
    
    this.enableCustom = 'true';
    this.interestFreeNo = 'AT,CH,BE,FI,NO';
    this.interestFree3 = 'DK,NL,IE,PT';
    this.interestFree3Under1500 = 'GR';
    this.interestFree3Under1000 = '';
    this.interestFree3Under1100 = 'PL';
    this.interestFree3Under4100 = 'RO,CZ';
    this.interestFree6 = 'SE';
    this.interestFree12 = '';
  }
  
  // 监听 amount 属性变化
  static get observedAttributes() {
    return ['amount'];
  }
  
  // get amout, 当type 为paypal 时，除100
  get amount() {
    const amount = this.getAttribute('amount') || '0';
    return amount;
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'amount' && oldValue !== newValue) {
      this._updateString(newValue);
    }
  }
  
  async connectedCallback() {
    this.region = await getRegionWithIp();
    console.log('this.region: ', this.region);
    
    if(this.enableCustom) {
      this.type = 'hidden';
      
      if(this.region && this.interestFreeNo && this.interestFreeNo.includes(this.region)) {
        this.type = 'interestFreeNo';
      }else if(this.region && this.interestFree3Under1000 && this.interestFree3Under1000.includes(this.region)) {
        this.type = 'interestFree3Under1000';
      }else if(this.region && this.interestFree3Under1100 && this.interestFree3Under1100.includes(this.region)) {
        this.type = 'interestFree3Under1100';
      }else if(this.region && this.interestFree3Under4100 && this.interestFree3Under4100.includes(this.region)) {
        this.type = 'interestFree3Under4100';
      }else if(this.region && this.interestFree3Under1500 && this.interestFree3Under1500.includes(this.region)) {
        this.type = 'interestFree3Under1500';
      }else if(this.region && this.interestFree3 && this.interestFree3.includes(this.region)) {
        this.type = 'interestFree3';
      } else if(this.region && this.interestFree6 && this.interestFree6.includes(this.region)) {
        this.type = 'interestFree6';
      } else if(this.region && this.interestFree12 && this.interestFree12.includes(this.region)) {
        this.type = 'interestFree12';
      }
    } else {
      this.type = '';
    }
    
    // 初始化支付信息元素
    this._updateString();
    
    // 监听变体变化
    const form = document.querySelector(`form[id="${this.getAttribute('form')}"]`);
    if (form) {
      form.addEventListener('variant:change', this._onVariantChanged);
    }
  }
  
  disconnectedCallback() {
    const form = document.querySelector(`form[id="${this.getAttribute('form')}"]`);
    if (form) {
      form.removeEventListener('variant:change', this._onVariantChanged);
    }
  }
  
  _onVariantChanged(event) {
    const price = event.detail.variant?.price || 0;
    this.setAttribute('amount', price);
    
    this._updateString(price);
  }
  
  // Installment amount this message advertises, formatted like its copy.
  // Surfaces that headline the amount (compare financing row) read it from
  // data-monthly-amount, so they always match the product page.
  _updateString(...args) {
    this._shownBill = '';
    this._renderMessage(...args);
    // Before the region is resolved there is nothing to publish yet.
    if (this.type !== undefined) this.dataset.monthlyAmount = this._shownBill;
  }

  _billText(bill) {
    const text = formatMoney(bill, currencyFormat);
    this._shownBill = text;
    return text;
  }

  _renderMessage() {
    if(this.type === 'interestFreeNo') {
      this.template = 'Buy now and pay later at 0% interest with Klarna.';
    } else if(this.type === 'interestFree3Under1000') {
      const bill = (this.amount / 100 / 3).toFixed(2); 
      // 金额大于1000 则展示另一套文案/隐藏
      if(this.amount >= 100000 ) {
        // this.template = 'Buy now and pay later at 0% interest with Klarna.';
        this.template = '';
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      } else {
        this.template = `3 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
      }
    } else if(this.type === 'interestFree3Under1100') {
      const bill = (this.amount / 100 / 3).toFixed(2); 
      // 金额大于等于1100则隐藏
      if(this.amount >= 110000 ) {
        this.template = '';
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      } else {
        this.template = `3 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
      }
    } else if(this.type === 'interestFree3Under4100') {
      const bill = (this.amount / 100 / 3).toFixed(2); 
      // 金额大于等于4100则隐藏
      if(this.amount >= 410000 ) {
        this.template = '';
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      } else {
        this.template = `3 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
      }
    } else if(this.type === 'interestFree3Under1500') {
      const bill = (this.amount / 100 / 3).toFixed(2);
      // 金额大于1500 则展示另一套文案/隐藏
      if(this.amount >= 150000 ) {
        // this.template = 'Buy now and pay later at 0% interest with Klarna.';
        this.template = '';
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      } else {
        this.template = `3 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
      }
    } else if(this.type === 'interestFree3') {
      const bill = (this.amount / 100 / 3).toFixed(2);
      // 金额大于4500 则展示另一套文案/隐藏
      if(this.amount >= 450000 ) {
        // this.template = 'Buy now and pay later at 0% interest with Klarna.';
        this.template = '';
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      } else {
        this.template = `3 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
      }
    } else if(this.type === 'interestFree6') {
      // 6期免息不限金额
      const bill = (this.amount / 100 / 6).toFixed(2);
      this.template = `6 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
    } else if(this.type === 'interestFree12') {
      const bill = (this.amount / 100 / 12).toFixed(2); 
      this.template = `12 payments of ${this._billText(bill)} at 0% interest with Klarna.`;
    } else if(this.type === 'hidden') {
      this.template = '';
      this.innerHTML = '';
      this.style.display = 'none';
      return;
    } else {
      this.template = '';
      this.innerHTML = '';
      return;
    }
    
    this.style.display = 'flex';
    
    this.innerHTML = `
      <div class="flex-c gap-4">
        <div class="flex-cc" part="osm-badge-container">
          <svg part="osm-badge" role="img" xmlns="http://www.w3.org/2000/svg" width="57" height="24" viewBox="0 0 71.25 30" aria-label="Klarna" version="2.1" >
            <g clip-path="url(#a-${this._timestamp})">
              <path fill="#FFA8CD" d="M62.7688 0H8.48123C3.79718 0 0 3.79718 0 8.48123V21.5188C0 26.2028 3.79718 30 8.48123 30H62.7688c4.684 0 8.4812-3.7972 8.4812-8.4812V8.48123C71.25 3.79718 67.4528 0 62.7688 0Z"></path>
              <path fill="#0B051D" d="M57.412 19.1418c-1.2436 0-2.2134-1.0286-2.2134-2.2776 0-1.2491.9698-2.2776 2.2134-2.2776 1.2441 0 2.2135 1.0285 2.2135 2.2776 0 1.249-.9694 2.2776-2.2135 2.2776Zm-.6215 2.4062c1.0608 0 2.4145-.4041 3.1645-1.9837l.0731.0367c-.329.8633-.329 1.3776-.329 1.5062v.202h2.6704v-8.8901h-2.6704v.2021c0 .1286 0 .6428.329 1.5061l-.0731.0368c-.75-1.5797-2.1037-1.9838-3.1645-1.9838-2.543 0-4.3355 2.0205-4.3355 4.6839 0 2.6633 1.7925 4.6838 4.3355 4.6838Zm-8.9822-9.3677c-1.2073 0-2.1586.4225-2.9268 1.9838l-.0732-.0368c.3292-.8633.3292-1.3775.3292-1.5061v-.2021h-2.6708v8.8901h2.744v-4.6838c0-1.2307.7134-2.0021 1.8659-2.0021 1.1526 0 1.7193.6612 1.7193 1.9837v4.7022H51.54v-5.6573c0-2.0205-1.5731-3.4716-3.7317-3.4716Zm-9.3112 1.9838-.0731-.0368c.3293-.8633.3293-1.3775.3293-1.5061v-.2021h-2.6708v8.8901h2.7439l.0183-4.2797c0-1.249.6586-2.0021 1.7379-2.0021.2926 0 .5305.0367.8048.1102v-2.7185c-1.2073-.2571-2.2866.2021-2.8903 1.745Zm-8.7257 4.9777c-1.244 0-2.2135-1.0286-2.2135-2.2776 0-1.2491.9695-2.2776 2.2135-2.2776 1.2439 0 2.2134 1.0285 2.2134 2.2776 0 1.249-.9695 2.2776-2.2134 2.2776Zm-.622 2.4062c1.061 0 2.4147-.4041 3.1647-1.9837l.0732.0367c-.3293.8633-.3293 1.3776-.3293 1.5062v.202h2.6708v-8.8901H32.058v.2021c0 .1286 0 .6428.3293 1.5061l-.0732.0368c-.75-1.5797-2.1037-1.9838-3.1647-1.9838-2.5428 0-4.3355 2.0205-4.3355 4.6839 0 2.6633 1.7927 4.6838 4.3355 4.6838Zm-8.1588-.2388h2.744V8.45166h-2.744V21.3092ZM18.9784 8.45166h-2.7988c0 2.29594-1.4086 4.35314-3.5489 5.82264l-.8415.5878V8.45166H8.88062V21.3092h2.90858v-6.3736l4.8111 6.3736h3.5489L15.521 15.211c2.1037-1.5245 3.4757-3.894 3.4574-6.75934Z"></path>
            </g>
            <defs>
              <clipPath id="a-${this._timestamp}">
                <path fill="#fff" d="M0 0h71.25v30H0z"></path>
              </clipPath>
            </defs>
          </svg>
        </div>
        <p class="" style="color: var(--after-pay-color); font-size: 14px;">${this.template}</p>
      </div>
    `;
  }
}
if (!window.customElements.get("custom-after-pay-msg")) {
  window.customElements.define("custom-after-pay-msg", CustomAfterPayMsg);
}

var DeliveryInfo = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onClickedListener = this._onClicked.bind(this);
    this._onDialogInfoClickedListener = this._onDialogInfoClicked.bind(this);
    this._productForm = document.forms[this.getAttribute("form")];
    this._info = this.getAttribute("info");
    this._minimumDate = this.getAttribute("minimum-date");
    this._maximumDate = this.getAttribute("maximum-date");
    this._noWeekends = this.getAttribute("no-weekends");
    this._shortName = this.getAttribute("short-name");
    this._dialog = document.querySelector('#product-info-dialog');
    this._dialogInfo = this._dialog.querySelector('.dialog-body-box');
    this._regionDeliveryInfo = JSON.parse(this.getAttribute("delivered-info-json") || null);
    this._deviceRegion = null;
    this._clickDelegateRoot = null;
    // this._regionDeliveryInfo = [{"name":"Austria","delivery_info":"Standard Delivery: {minimum_date} - {maximum_date}"},{"name":"Belgium","delivery_info":"You'll receive your {product_short_name} between {minimum_date} and {maximum_date}","delivered_minimum_date":3,"delivered_maximum_date":5}, {"name":"Bulgaria","delivery_info":"Standard Delivery2"}, {"name":"Denmark","delivery_info":"Standard Delivery3"}, {"name":"England","delivery_info":"Standard Delivery4"}];
  }
  /** 窄屏底栏：与 delivery-info 同级的 .logistics-info-wrapper（在 .add-to-cart-bar-mobile-only 内） */
  get _logisticsWrapper() {
    const mobileRoot = this.closest(".add-to-cart-bar-mobile-only");
    return mobileRoot?.querySelector(".logistics-info-wrapper") ?? null;
  }
  _getSelectModuleTextEl() {
    return this._logisticsWrapper?.querySelector(".delivery-info-select-module-text") || this.querySelector(".delivery-info-select-module-text");
  }
  /** 将完整 render 写入 delivery-info-wrapper；若存在 logistics 容器则把 .delivery-info-select-module 挪入其中 */
  _applyDeliveryRender(render) {
    const mainEl = this.querySelector(".delivery-info-wrapper");
    if (!mainEl) {
      return;
    }
    const logistics = this._logisticsWrapper;
    if (!logistics) {
      mainEl.innerHTML = render;
      return;
    }
    const tmp = document.createElement("div");
    tmp.innerHTML = render;
    const selectBtn = tmp.querySelector(".delivery-info-select-module");
    logistics.innerHTML = "";
    if (selectBtn) {
      logistics.appendChild(selectBtn);
    }
    mainEl.innerHTML = tmp.innerHTML;
  }
  _bindSelectClickListener() {
    if (this._logisticsWrapper) {
      this._clickDelegateRoot = this.closest(".add-to-cart-bar-mobile-only");
      this._clickDelegateRoot?.addEventListener("click", this._onClickedListener);
    } else {
      this.addEventListener("click", this._onClickedListener);
    }
  }
  _unbindSelectClickListener() {
    if (this._clickDelegateRoot) {
      this._clickDelegateRoot.removeEventListener("click", this._onClickedListener);
      this._clickDelegateRoot = null;
    } else {
      this.removeEventListener("click", this._onClickedListener);
    }
  }
  connectedCallback() {
    const render = this.renderInfo();
    this._applyDeliveryRender(render);
    this._productForm.addEventListener("variant:change", this._onVariantChangedListener);
    this._bindSelectClickListener();
    this._dialogInfo.addEventListener("click", this._onDialogInfoClickedListener);
    if(render && render.includes('delivery-info-select-module')) {
      this._initSelectModuleText();
    }
  }
  disconnectedCallback() {
    this._unbindSelectClickListener();
    this._dialogInfo.removeEventListener("click", this._onDialogInfoClickedListener);
    this._productForm.removeEventListener("variant:change", this._onVariantChangedListener);
    this._variantAbortController?.abort();
  }
  _onDialogInfoClicked(event) {
    if (event.target.className && event.target.className.includes('delivery-info-item')) {
      const dataset = event.target.dataset;
      const moduleText = this._getSelectModuleTextEl();
      if (moduleText) moduleText.textContent = event.target.textContent;

      const delivery_info = this.renderInfo(dataset.delivery_info, dataset?.delivered_minimum_date || 0,  dataset?.delivered_maximum_date || 0);
      const wrapper = this.querySelector('.delivery-info-wrapper');
      let dialogInfoDetail = this.querySelector('.delivery-info-dialog-info-detail');
      if (!dialogInfoDetail) {
        dialogInfoDetail = document.createElement('div');
        dialogInfoDetail.className = 'delivery-info-dialog-info-detail';
        wrapper.appendChild(dialogInfoDetail);
      }
      dialogInfoDetail.textContent = delivery_info;

      this._dialog.removeAttribute('open', '');
    }
  }
  _onClicked(event) {
    if (event.target.closest('.delivery-info-select-module')) {
      // 弹窗
      this._dialogInfo.innerHTML = this.renderRegionDeliveryInfo(this._regionDeliveryInfo);

      this._dialog.setAttribute('open', '');
    }
  }
  async _initSelectModuleText(regionDeliveryInfo = this._regionDeliveryInfo) {
    let deviceRegion = this._deviceRegion;
    if(!this._deviceRegion) {
      const deviceRegionInfo = await fetch(
        window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + `&country[exclude]=${window.Shopify.country}`
          + '&language[enabled]=true'
          + `&language[exclude]=${window.Shopify.language}`
      ).then(r => r.json());
      console.log('deviceRegionInfo: ', deviceRegionInfo);
      deviceRegion = await window.Shopify?.customerPrivacy?.getRegion();
      if(deviceRegionInfo?.detected_values?.country?.handle) {
        deviceRegion = deviceRegionInfo.detected_values.country.handle
      }
      if(deviceRegionInfo.suggestions && deviceRegionInfo.suggestions.length > 0) {
        let suggestion = deviceRegionInfo.suggestions[0]?.parts?.country?.handle;
        deviceRegion = suggestion;
      }
      this._deviceRegion = deviceRegion;
      window.sessionStorage.setItem('deviceRegion', deviceRegion);
    }
    const findInfo = regionDeliveryInfo.find(item => item.key.toLocaleUpperCase() === deviceRegion.toLocaleUpperCase());
    const firstInfo = findInfo ? findInfo : regionDeliveryInfo[0];
    const infoText = this.renderInfo(firstInfo.delivery_info, firstInfo?.delivered_minimum_date || 0, firstInfo?.delivered_maximum_date || 0);
    const moduleText = this._getSelectModuleTextEl();
    if (moduleText) moduleText.textContent = firstInfo.name;

    const wrapper = this.querySelector('.delivery-info-wrapper');
    let dialogInfoDetail = this.querySelector('.delivery-info-dialog-info-detail');
    if (!dialogInfoDetail) {
      dialogInfoDetail = document.createElement('div');
      dialogInfoDetail.className = 'delivery-info-dialog-info-detail';
      wrapper.appendChild(dialogInfoDetail);
    }
    dialogInfoDetail.textContent = infoText;
  }
  renderRegionDeliveryInfo(regionDeliveryInfo) {
    let detailsHTML = `<div class="delivery-info-dialog-wrapper">`;
    
    regionDeliveryInfo.forEach(item => {
      // 创建一个div元素
      detailsHTML += `<div class="delivery-info-item" `;

      // 添加data-属性
      for (const key in item) {
        if (key !== "name") { // 排除name字段
          detailsHTML += `data-${key}="${item[key]}" `;
        }
      }

      // 结束div标签并添加name
      detailsHTML += `>${item.name}</div>`;
    });

    detailsHTML += '</div>';
    
    return detailsHTML;
  }
  addBusinessDays(startDate, days) {
    let currentDate = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      // 检查是否是周末
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
          addedDays++;
      }
    }

    return currentDate;
  }
  renderInfo(info = this._info, minimumDate = this._minimumDate, maximumDate = this._maximumDate) {
    let result = info;
    let now = new Date().getTime();
    let ONEDAY = 1000 * 60 * 60 * 24
    const options = { month: 'short', day: '2-digit' }; // 设置格式选项
    const format = 'en-GB';
    let min;
    let max;
    if(this._noWeekends) {
      min = this.addBusinessDays(now, minimumDate);
      max = this.addBusinessDays(now, maximumDate);
    } else {
      min = new Date(now + (minimumDate * ONEDAY));
      max = new Date(now + (maximumDate * ONEDAY));
    }
    min = min.toLocaleDateString(format, options);
    max = max.toLocaleDateString(format, options);
    result = result.replace('{product_short_name}', this._shortName).replace('{minimum_date}', min).replace('{maximum_date}', max);

    // 替换 select_module
    const select_module_html = `<button type="button" class="delivery-info-select-module" aria-haspopup="dialog"><span class="delivery-info-select-module-text"></span><svg class="delivery-info-select-module-chevron" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16"><path d="M7.93872 4.37999L12.4714 8.91264L12.4714 9.74427L7.93872 14.2769L7.10708 13.4453L11.2239 9.32846L7.10708 5.21163L7.93872 4.37999Z" fill="currentColor"/></svg></button>`
    result = result.replace('{select_module}', select_module_html)
    return result;
  }
  // Only the latest variant's response may update the text: each change aborts the previous request, and a response
  // that arrives after the form has moved on to another variant is ignored.
  async _onVariantChanged(event) {
    this._variantAbortController?.abort();
    if (event.detail.variant) {
      const variantId = event.detail.variant.id;
      const abortController = this._variantAbortController = new AbortController();
      const section = this.closest(".shopify-section");
      const url = productVariantSectionUrl(event.detail.product.handle, event.detail.variant.id, section.id.replace("shopify-section-", ""));
      const response = await fetch(url, { priority: "low", signal: abortController.signal }).catch(() => null);
      // Keep the current delivery text when the section request fails or comes back without the element.
      if (!response?.ok) return;
      const html = await response.text().catch(() => null);
      const selectedId = this._productForm.querySelector('[name="id"]')?.value;
      if (html === null || abortController.signal.aborted || (selectedId && String(selectedId) !== String(variantId))) return;
      const tempDiv = new DOMParser().parseFromString(html, "text/html")
      const targetElement = tempDiv.querySelector("delivery-info");
      if (!targetElement) return;
      this._info = targetElement.getAttribute("info");
      this._minimumDate = targetElement.getAttribute("minimum-date");
      this._maximumDate = targetElement.getAttribute("maximum-date");
      this._noWeekends = targetElement.getAttribute("no-weekends");
      this._shortName = targetElement.getAttribute("short-name");
      this._regionDeliveryInfo = JSON.parse(targetElement.getAttribute("delivered-info-json") || null);
      const render = this.renderInfo();
      this._applyDeliveryRender(render);
      if(render && render.includes('delivery-info-select-module')) {
        this._initSelectModuleText();
      }
    }
  }
}
if (!window.customElements.get("delivery-info")) {
  window.customElements.define("delivery-info", DeliveryInfo);
}

// Member moudles
var MemberRedeemDiscount = class extends HTMLElement {
  constructor() {
    super();
    this._onMemberItemClickedListener = this._onMemberItemClicked.bind(this);
    this._background = this.getAttribute("data-background");
    this._widgetId = this.getAttribute("data-widget-id");
    this._type = this.getAttribute("data-type");
    this._dialog = document.querySelector('#member-rules-dialog');
    this._copyButton = this.querySelector('.copy-button');
    this._copySuccessed = this.querySelector('.copy-successed');
    this._copyCode = this.querySelector('.copy-code');
    this._rules = this.querySelector('.item-info__rules');
    this._reedeemButton = this.querySelector('.redeem-button');
    this._variantId = this.getAttribute('data-variant-id');
    this._customer = this.closest('.rewards-component-wrapper').getAttribute('data-customer');

    
  }

  connectedCallback() {
    this.addEventListener("click", this._onMemberItemClickedListener);
  }

  disconnectedCallback() {

  }
  async _onMemberItemClicked(event) {
    this.customer_email = window.localStorage.getItem('customer_email');
    this.customer_external_id = window.localStorage.getItem('customer_external_id');
    this.merchant_id = window.localStorage.getItem('merchant_id');
    this.customer_token = window.localStorage.getItem('customer_token');

    if (this._copyButton.contains(event.target)) {
      if (!this.judgeSignIn()) {
        console.warn('User not logged in');
        return false;
      }
      
      this._copySuccessed.classList.add('successed');
      this.copyToClipboard(`.copy-code`);
      setTimeout(() => {
        this._copySuccessed.classList.remove('successed');
      }, 3000)
    } else if (this._rules.contains(event.target)) {
      this._dialog.setAttribute('data-type', this._type);
      this._dialog.querySelector('.dialog-body-box').innerHTML = this.querySelector('.redeem-rules-wrapper').innerHTML;
      this._dialog.querySelector('.discount-background-wrapper').style.backgroundImage = `url(${this._background})`;
      this._dialog.setAttribute('open', '');
    } else if (this._type === 'redeem_discount' && this._reedeemButton.contains(event.target)) {
      if (!this.judgeSignIn()) {
        console.warn('User not logged in');
        return false;
      }
      var result = confirm("Are you sure you want to redeem this coupon?")
      if (result) {
        fetch("https://loyalty.yotpo.com/api/public/v1/point_redemptions", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "merchant_id": this.merchant_id,
            "redemption_option_id": this._widgetId,
            "redemption_source": "module_interactive_redemption",
            "customer_email": this.customer_email,
            "customer_external_id": this.customer_external_id
          })
        })
        .then(async (response) => {
            // 检查响应状态
            if (!response.ok) {
              const errorData = await response.json(); // 解析错误信息
              
              // swal(JSON.stringify(errorData) || 'Request is illegal!');
              swal("You don't have enough points" || 'Request is illegal!');

              throw new Error('Network response was not ok');
            }
            return response.json(); // 解析 JSON 响应
          })
          .then(data => {
            console.log('data: ', data);
            // 更新积分
            this.updatePoints();

            this._copyCode.textContent = data.reward_text;
            this._copyCode.setAttribute('data-code', data.reward_text);
            this._copyCode.setAttribute('data-token', data.token);
            this.querySelector('.redeem-button').classList.add('hidden');
            this._copyButton.classList.remove('hidden');
          })
          .catch(error => {
            
            console.error('Error:', error); // 处理错误
          });
      } else {
      }
    } else if (this._type === 'redeem_product' && this._reedeemButton.contains(event.target)) {
      if(!this.judgeSignIn()) {
        console.log('User not logged in');
        return false;
      }
      // Comfirm
      var result = confirm("Are you sure you want to redeem this product?")
      if (result) {
        // 判断购物车是否已经存在至少一个商品
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        if (cartContent.item_count >= 0) {
          // 判断购物车是否已经存在免费商品
          const freeProducts = cartContent.items.filter(item => item.final_line_price === 0);
          if (freeProducts.length > 0) {
            console.warn('You can only redeem one free product per purchase');
            swal('You can only redeem one free product per purchase');
            return;
          }
          this.querySelector('.redeem-button').classList.add('loading');
          try {
            // 调用 兑换接口
            const redemptionResponse = await fetch("https://loyalty.yotpo.com/api/public/v1/point_redemptions", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  "merchant_id": this.merchant_id,
                  "redemption_option_id": this._widgetId,
                  "redemption_source": "module_products_redemption",
                  "delay_points_deduction": true,
                  "points_in_cart": 0,
                  "customer_email": this.customer_email,
                  "customer_external_id": this.customer_external_id
                })
              });
            console.log('redemptionResponse: ', redemptionResponse);
            const redemptionResponseJson = await redemptionResponse.json();
            if (!redemptionResponse.ok) {
              console.log('redemptionResponseJson: ', redemptionResponseJson);
              // swal(JSON.stringify(redemptionResponseJson) || 'Request is illegal!');
              swal("You don't have enough points" || 'Request is illegal!');
              throw new Error(JSON.stringify(redemptionResponseJson) || 'Network response was not ok');
            }
            // 调用 接口将商品加入购物车
            try {
              const cartResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
                body: JSON.stringify({
                  "id": this._variantId,
                  "quantity": 1,
                  "properties": {
                    "_swell_points_used": this.querySelector('.item-info__points').getAttribute('data-points'),
                    "_yotpo_loyalty_redemption_id": redemptionResponseJson.id,
                    "_yotpo_loyalty_redemption_token": redemptionResponseJson.token,
                    "_yotpo_loyalty_discount_type": "product"
                  }
                }),
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                }
              });
              const cartResponseJson = await cartResponse.json();
            } catch (error) {
              console.error('error: ', error);
              return;
            }

            // 更新积分
            this.updatePoints();
  
            // 商品添加入购物车成功 可以触发刷新购物车事件
            // TODO
  
            // 展示 View Cart 按钮 引导用户去购物车页结账
            this.querySelector('.redeem-successed').classList.add('successed');
            setTimeout(() => {
              this.querySelector('.redeem-successed').classList.remove('successed');
            }, 3000)
            this.querySelector('.redeem-button').classList.remove('loading');
            this.querySelector('.redeem-button').classList.add('hidden');
            this.querySelector('.view-cart-button').classList.remove('hidden');

          } catch (error) {
            this.querySelector('.redeem-button').classList.remove('loading');
            return false;
          }
        } else {
          console.warn('Add at least one paid product to your cart in order to redeem.');
          swal('Add at least one paid product to your cart in order to redeem.');
          return;
        }

      } else {
      }
    }
  }
  judgeSignIn() {
    if (!this._customer) {
      const pathname = window.location.pathname.replace(/\//g, '%2F');
      window.location.href = `/account/login?return_url=${pathname}`;
      return false;
    }
    return true;
  }

  // 更新积分和积分视图
  async updatePoints() {
    const objectToQueryString = (obj) => {
      const params = new URLSearchParams();

      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          // 直接使用 URLSearchParams 的 append 方法
          params.append(key, obj[key]);
        }
      }

      return params.toString();
    }
    const queryObject = {
      customer_email: this.customer_email,
      customer_external_id: this.customer_external_id,
      customer_token: this.customer_token,
      merchant_id: this.merchant_id
    };
    const queryString = objectToQueryString(queryObject);
    const updatePointsResponse = await fetch(`https://loyalty.yotpo.com/api/v1/customer_details?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: null,
      "credentials": "omit"
    })
    const updatePointsResponseJson = await updatePointsResponse.json();
    const points_balance = updatePointsResponseJson?.points_balance;
    if (points_balance) {
      window.localStorage.setItem('points_balance', points_balance);
      const ele = document.querySelector('.member-info__points-value');
      if (ele) {
        ele.textContent = points_balance;
      }
    }
  }

  copyToClipboard(id) {
    var r = document.createRange();
    const discountCodeInput = this.querySelector(id);
    r.selectNode(discountCodeInput);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
  }

}
if (!window.customElements.get("member-reedeem-discount")) {
  window.customElements.define("member-reedeem-discount", MemberRedeemDiscount);
}

var MemberCouponsWrapper = class extends HTMLElement {
  constructor() {
    super();
    this._blocks = this.getAttribute("data-blocks");
    this.blocks = this._blocks ? JSON.parse(this._blocks) : [];
    this._onCouponsClickedListener = this._onCouponsItemClicked.bind(this);
    this._point_redemptions = window.localStorage.getItem('point_redemptions');
    let point_redemptions = this._point_redemptions ? JSON.parse(this._point_redemptions) : [];
    this.point_redemptions = point_redemptions.filter((point_redemption) => {
      return point_redemption.code_expires_on && new Date(point_redemption.code_expires_on).getTime() > new Date().getTime();
    });
    this._dialog = document.querySelector('#member-rules-dialog');
  }

  connectedCallback() {
    this.addEventListener("click", this._onCouponsClickedListener);
    
    this.handleRender();
    
    // 监听自定义事件 point_redemptions_updated
    document.addEventListener('point_redemptions_updated', (event) => {
      let newValue = window.localStorage.getItem('point_redemptions');
      if (newValue === this._point_redemptions) {
        return;
      }
      this._point_redemptions = newValue;
      let point_redemptions = this._point_redemptions ? JSON.parse(this._point_redemptions) : [];
      this.point_redemptions = point_redemptions.filter((point_redemption) => {
        return point_redemption.code_expires_on && new Date(point_redemption.code_expires_on).getTime() > new Date().getTime();
      });
      this.handleRender();
    })
  }
  
  disconnectedCallback() {
    this.removeEventListener("click", this._onCouponsClickedListener);
  }
  
  handleRender() {
    // 根据 point_redemptions 进行渲染
    if (this.point_redemptions.length > 0 && this.blocks.length > 0) {
      // start
      this.renderCoupons(this.point_redemptions, this.blocks);
      this.closest('.my-coupons-wrapper').classList.add('has-coupons');
    } else {
      this.closest('.my-coupons-wrapper').classList.remove('has-coupons');
    }
  }
  
  // 计算过期时间，单位天
  calcExpiredDay(date) {
    const now = new Date();
    const targetDate = new Date(date);
    const timeDiff = targetDate.getTime() - now.getTime();
    if(timeDiff < 0 || isNaN(timeDiff)) {
      return 0;
    }
    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    return daysDiff;
  }
  
  renderCoupons(point_redemptions, blocks) {
    let resultStr = '';
    point_redemptions.forEach((point_redemption) => {
      const block = blocks.find((block) => block?.settings?.points === point_redemption.redemption_option.amount && block?.settings?.coupon_title.toLocaleLowerCase() === point_redemption.redemption_option.name.toLocaleLowerCase());
      const coupons_expired_days = "{days} Days Left";
      const expiredDay = this.calcExpiredDay(point_redemption?.code_expires_on);
      // 如果过期则不展示
      if(expiredDay > 0 && block) {
        resultStr += `
          <div class="coupon-item" data-widget="${block.settings.widget_id}">
            <div class="redeem-discount-item__top">
              <div class="item-bg" style="background-image: url('${block.settings.image}');"></div>
            </div>
            <div class="expired-day-wrapper">${coupons_expired_days.replace('{days}', expiredDay)}</div>
            <div class="redeem-discount-item__bottom">
              <div class="item-info-wrapper">
                <p class="item-title">${block.settings.coupon_title}</p>
                <div class="item-info">
                  <p class="item-info__points" data-points="${block.settings.points}">${block.settings.points_text}</p>
                  <p class="item-info__rules">Rules</p>
                </div>
                <p class="item-desc">${block.settings.description}</p>
              </div>
              <button class="button copy-button">
                <span class="copy-code">${point_redemption.reward_text}</span>
                <div class="copy-icon">
                  <svg t="1733735928580" class="icon copied-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4789" width="16" height="16">
                    <path d="M85.333333 170.666667a85.333333 85.333333 0 0 1 85.333334-85.333334h426.666666a85.333333 85.333333 0 0 1 85.333334 85.333334v170.666666h170.666666a85.333333 85.333333 0 0 1 85.333334 85.333334v426.666666a85.333333 85.333333 0 0 1-85.333334 85.333334H426.666667a85.333333 85.333333 0 0 1-85.333334-85.333334v-170.666666H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333334V170.666667z m341.333334 512v170.666666h426.666666V426.666667h-170.666666v170.666666a85.333333 85.333333 0 0 1-85.333334 85.333334h-170.666666z m170.666666-85.333334V170.666667H170.666667v426.666666h426.666666z" fill="currentColor" p-id="4790"></path>
                  </svg>
                  
                  <svg
                    role="presentation"
                    focusable="false"
                    stroke-width="2"
                    width="16"
                    height="16"
                    class="success-icon"
                    style="--icon-height: 16px"
                    viewBox="0 0 18 18"
                  >
                    <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                    <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
                  </svg>
                </div>
              </button>
            </div>
            <div class="hidden redeem-rules-wrapper">${block.settings.rules}</div>
          </div>
        `;
      }
    })
    this.innerHTML = resultStr;
  }
  
  _onCouponsItemClicked(event) {
    this.customer_email = window.localStorage.getItem('customer_email');
    this.customer_external_id = window.localStorage.getItem('customer_external_id');
    this.merchant_id = window.localStorage.getItem('merchant_id');
    this.customer_token = window.localStorage.getItem('customer_token');
    
    // 判断点击事件 copy button
    if(event.target.closest('.copy-button')) {
      const copyButton = event.target.closest('.copy-button');
      const copyCode = copyButton.querySelector('.copy-code').textContent;
      this.copyToClipboard(copyButton.querySelector('.copy-code'));
      copyButton.classList.add('copied');
      
      setTimeout(() => {
        copyButton.classList.remove('copied');
      }, 3000);
    } else if (event.target.closest('.item-info__rules')) {
      const item = event.target.closest('.coupon-item');
      this._dialog.setAttribute('data-type', 'redeem_discount');
      this._dialog.querySelector('.dialog-body-box').innerHTML = item.querySelector('.redeem-rules-wrapper').innerHTML;
      this._dialog.querySelector('.discount-background-wrapper').style.backgroundImage = item.querySelector('.item-bg').style.backgroundImage;
      this._dialog.setAttribute('open', '');
    }
    
  }
  
  copyToClipboard(target) {
    var r = document.createRange();
    r.selectNode(target);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
  }
}
if (!window.customElements.get("member-coupons-wrapper")) {
  window.customElements.define("member-coupons-wrapper", MemberCouponsWrapper);
}

// js/common/media/base-media.js
import { inView as inView4 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var BaseMedia = class extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView4(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerHandler(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};

// js/common/media/model.js
var ModelMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    this.player;
  }
  _playerTarget() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = this.querySelector("model-viewer");
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            this.setAttribute("can-play", "");
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerHandler(target, prop) {
    target[prop]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    } else {
      const models = (await ProductLoader.load(this.getAttribute("handle")))["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }
};
if (!window.customElements.get("model-media")) {
  window.customElements.define("model-media", ModelMedia);
}

// js/common/media/video.js
var onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
var VideoMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    if (this.hasAttribute("hover-play")) {
      const _width = window.innerWidth;
      console.log('_width: ', _width);
      if(_width <= 700) {
        this.setAttribute("autoplay", "");
        this.play({ once: true, signal: this._abortController.signal })
      } else {
        this.addEventListener("mouseenter", () => {
          const videoElement = this.querySelector("video");
  
          videoElement.currentTime = 0;
          this.play({ once: true, signal: this._abortController.signal })
        });
        this.addEventListener("mouseleave", () => {
          this.pause({ once: true, signal: this._abortController.signal })
          this.removeAttribute("playing");
        });
      }
    }
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, {
        once: true,
        signal: this._abortController.signal
      });
    }
    if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
      this.attachShadow({
        mode: "open"
      }).appendChild(document.createRange().createContextualFragment(`
        <slot></slot>
        
        <svg part="play-button" fill="none" width="48" height="48" viewBox="0 0 48 48">
          <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z" fill="#ffffff"/>
          <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="#1a1a1a"/>
          <path d="M24 .5C36.979.5 47.5 11.021 47.5 24S36.979 47.5 24 47.5.5 36.979.5 24 11.021.5 24 .5Z" stroke="#1a1a1a" stroke-opacity=".12"/>
        </svg>
      `));
    }
  }
  _playerTarget() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector("template");
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute("autoplay") || window.matchMedia("screen and (max-width: 999px)").matches;
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          this.setAttribute("can-play", "");
          const player = new YT.Player(this.querySelector("iframe"), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector("iframe"));
          if (muteVideo) {
            player.setMuted(true);
          }
          this.setAttribute("can-play", "");
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = this.querySelector("video");
      this.setAttribute("loaded", "");
      this.setAttribute("can-play", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerHandler(target, prop) {
    if (this.getAttribute("host") === "youtube") {
      prop === "play" ? target.playVideo() : target.pauseVideo();
    } else {
      target[prop]();
    }
  }
};
if (!window.customElements.get("video-media")) {
  window.customElements.define("video-media", VideoMedia);
}

// js/common/navigation/accordion-disclosure.js
import { timeline as timeline6 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";

// js/common/navigation/animated-details.js
var AnimatedDetails = class extends HTMLDetailsElement {
  constructor() {
    super();
    this.summaryElement = this.firstElementChild;
    this.contentElement = this.lastElementChild;
    this._open = this.hasAttribute("open");
    this.summaryElement.addEventListener("click", this._onSummaryClicked.bind(this));
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", () => this.open = true);
      this.addEventListener("shopify:block:deselect", () => this.open = false);
    }
  }
  set open(value) {
    if (value !== this._open) {
      this._open = value;
      if (this.isConnected) {
        this._transition(value);
      } else {
        value ? this.setAttribute("open", "") : this.removeAttribute("open");
      }
    }
  }
  get open() {
    return this._open;
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    this.open = !this.open;
  }
  _transition(value) {
  }
};

// js/common/navigation/accordion-disclosure.js
var AccordionDisclosure = class extends AnimatedDetails {
  static get observedAttributes() {
    return ["open"];
  }
  constructor() {
    super();
    this.setAttribute("aria-expanded", this._open ? "true" : "false");
  }
  set open(value) {
    super.open = value;
    this.setAttribute("aria-expanded", value ? "true" : "false");
  }
  get open() {
    return super.open;
  }
  async _transition(value) {
    this.style.overflow = "hidden";
    if (value) {
      this.setAttribute("open", "");
      await timeline6([
        [this, { height: [`${this.summaryElement.clientHeight}px`, `${this.scrollHeight}px`] }, { duration: 0.25, easing: "ease" }],
        [this.contentElement, { opacity: [0, 1], transform: ["translateY(0)", "translateY(-4px)"] }, { duration: 0.15, at: "-0.1" }]
      ]).finished;
    } else {
      await timeline6([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [this, { height: [`${this.clientHeight}px`, `${this.summaryElement.clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
      ]).finished;
      this.removeAttribute("open");
    }
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      this.setAttribute("aria-expanded", newValue === "" ? "true" : "false");
    }
  }
};
if (!window.customElements.get("accordion-disclosure")) {
  window.customElements.define("accordion-disclosure", AccordionDisclosure, { extends: "details" });
}

// js/common/navigation/tabs.js
import { animate as animate8 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var Tabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => this.selectedIndex = index, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transition(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transition(fromPanel, toPanel) {
    await animate8(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate8(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("x-tabs")) {
  window.customElements.define("x-tabs", Tabs);
}

/**
 * Search-drawer result tabs with overflow fade controls.
 */
var PredictiveSearchTabs = class extends Tabs {
  connectedCallback() {
    super.connectedCallback();
    this._tabListWrap = this.shadowRoot.querySelector('[part="tab-list-wrap"]');
    this._prevBtn = this.shadowRoot.querySelector('[part="scroll-prev"]');
    this._nextBtn = this.shadowRoot.querySelector('[part="scroll-next"]');
    if (!this._tabListWrap) {
      return;
    }
    this._tabListWrap.addEventListener("scroll", this._updateScrollFades.bind(this), {
      passive: true,
      signal: this._abortController.signal
    });
    this._bindScrollButton(this._prevBtn, -1);
    this._bindScrollButton(this._nextBtn, 1);
    this._resizeObserver = new ResizeObserver(() => this._updateScrollFades());
    this._resizeObserver.observe(this._tabListWrap);
    requestAnimationFrame(() => this._updateScrollFades());
  }
  disconnectedCallback() {
    this._resizeObserver?.disconnect();
    super.disconnectedCallback();
  }
  /**
   * Touch uses pointerup; ignore the following synthetic click to avoid double-scroll.
   */
  _bindScrollButton(button, direction) {
    if (!button) {
      return;
    }
    let ignoreNextClick = false;
    const onActivate = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this._scrollByTab(direction);
    };
    button.addEventListener("pointerup", (event) => {
      if (event.pointerType !== "touch" && event.pointerType !== "pen") {
        return;
      }
      ignoreNextClick = true;
      onActivate(event);
      setTimeout(() => {
        ignoreNextClick = false;
      }, 400);
    }, { signal: this._abortController.signal });
    button.addEventListener("click", (event) => {
      if (ignoreNextClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      onActivate(event);
    }, { signal: this._abortController.signal, capture: true });
  }
  _getTabItems() {
    return Array.from(this.querySelectorAll('[slot="title"]'));
  }
  _updateScrollFades() {
    if (!this._tabListWrap) {
      return;
    }
    const { scrollLeft, scrollWidth, clientWidth } = this._tabListWrap;
    const epsilon = 2;
    const canScroll = scrollWidth > clientWidth + epsilon;
    const showPrev = canScroll && scrollLeft > epsilon;
    const showNext = canScroll && scrollLeft + clientWidth < scrollWidth - epsilon;
    if (this._prevBtn) {
      this._prevBtn.hidden = !showPrev;
    }
    if (this._nextBtn) {
      this._nextBtn.hidden = !showNext;
    }
  }
  _scrollTo(left) {
    const wrap = this._tabListWrap;
    if (!wrap) {
      return;
    }
    const max = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
    const next = Math.max(0, Math.min(left, max));
    if (typeof wrap.scrollTo === "function") {
      try {
        wrap.scrollTo({ left: next, behavior: "smooth" });
      } catch (error) {
        wrap.scrollLeft = next;
      }
    } else {
      wrap.scrollLeft = next;
    }
    requestAnimationFrame(() => this._updateScrollFades());
  }
  _scrollByTab(direction) {
    const wrap = this._tabListWrap;
    if (!wrap) {
      return;
    }
    const items = this._getTabItems();
    if (items.length === 0) {
      return;
    }
    const nextIndex = Math.min(Math.max(this.selectedIndex + direction, 0), items.length - 1);
    this.selectedIndex = nextIndex;
    const target = items[nextIndex];
    if (!target) {
      return;
    }
    const wrapRect = wrap.getBoundingClientRect();
    const left = target.getBoundingClientRect().left - wrapRect.left + wrap.scrollLeft;
    this._scrollTo(left);
  }
};
if (!window.customElements.get("predictive-search-tabs")) {
  window.customElements.define("predictive-search-tabs", PredictiveSearchTabs);
}

// js/common/search/predictive-search.js
import { animate as animate9 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(`<slot name="idle"></slot>`));
  }
  connectedCallback() {
    this._searchForm = this.closest("form");
    this._queryInput = this._searchForm.elements["q"];
    this._searchForm.addEventListener("submit", this._onFormSubmitted.bind(this));
    this._searchForm.addEventListener("reset", this._onSearchCleared.bind(this));
    this._queryInput.addEventListener("input", debounce(this._onInputChanged.bind(this), this.autoCompleteDelay));
  }
  /**
   * Return the delay in ms before we send the autocomplete request. Using a value too low can cause the results to
   * refresh too often, so we recommend to keep the default one
   */
  get autoCompleteDelay() {
    return 280;
  }
  /**
   * Check if the store supports the predictive API (some languages do not). When not supported, the predictive
   * search is simply disabled and only the standard search is used
   */
  supportsPredictiveApi() {
    return JSON.parse(document.getElementById("shopify-features").innerHTML)["predictiveSearch"];
  }
  /**
   * Check if the input is not empty, and if so, trigger the predictive search
   */
  _onInputChanged() {
    if (this._queryInput.value === "") {
      return this._onSearchCleared();
    }
    this._abortController?.abort();
    this._abortController = new AbortController();
    try {
      return this.supportsPredictiveApi() ? this._doPredictiveSearch() : this._doFallbackSearch();
    } catch (e) {
      if (e.name !== "AbortError") {
        throw e;
      }
    }
  }
  /**
   * Prevent the form submission if the query is empty
   */
  _onFormSubmitted(event) {
    if (this._queryInput.value === "") {
      return event.preventDefault();
    }
  }
  /**
   * Do the actual predictive search
   */
  async _doPredictiveSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[limit]=10&resources[limit_scope]=each`;
    const nodeElement = new DOMParser().parseFromString(await (await cachedFetch(`${window.Shopify.routes.root}search/suggest?${queryParams}`, { signal: this._abortController.signal })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot("results");
  }
  /**
   * For merchants using store that do not support the predictive search, we have to fallback to standard search. Unfortunately,
   * the standard search is less convenient, and we have to simulate one request for each desired resource type
   */
  async _doFallbackSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[limit]=10&resources[limit_scope]=each`;
    const nodeElement = new DOMParser().parseFromString(await (await cachedFetch(`${window.Shopify.routes.root}search?${queryParams}`, { signal: this._abortController.signal })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot("results");
  }
  /**
   * If any search is pending, we abort them, and transition to the idle slot
   */
  _onSearchCleared() {
    this._abortController?.abort();
    this._queryInput.focus();
    return this._transitionToSlot("idle");
  }
  /**
   * Transition between different slot. To prevent useless animation, the slot does not transition if we go to the same slot
   */
  async _transitionToSlot(toSlotName) {
    if (this.shadowRoot.firstElementChild.name === toSlotName) {
      return;
    }
    await animate9(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [1, 0] }, { duration: 0.1 }).finished;
    this.shadowRoot.firstElementChild.setAttribute("name", toSlotName);
    return animate9(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [0, 1], transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.1 }).finished;
  }
};
if (!window.customElements.get("predictive-search")) {
  window.customElements.define("predictive-search", PredictiveSearch);
}

// js/common/search/search-drawer.js
var SearchDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return "right";
  }
  _getClipPathProperties() {
    return super._getClipPathProperties().map((value) => value.replaceAll(" round 8px", ""));
  }
};
if (!window.customElements.get("search-drawer")) {
  window.customElements.define("search-drawer", SearchDrawer);
}

// js/common/text/section-header.js
import { animate as animate10, inView as inView5 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var _reveal2, reveal_fn2;
var SectionHeader = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _reveal2);
  }
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, __privateMethod(this, _reveal2, reveal_fn2).bind(this), { margin: "0px 0px -100px 0px" });
    }
  }
};
_reveal2 = new WeakSet();
reveal_fn2 = function() {
  const heading = this.querySelector('[reveal-on-scroll="true"]'), headingKeyframe = getHeadingKeyframe(heading);
  animate10(...headingKeyframe);
};
if (!window.customElements.get("section-header")) {
  window.customElements.define("section-header", SectionHeader);
}

// js/common/ui/marquee-text.js
var MarqueeText = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
    }
  }
  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5), contentWidth = entries[0].contentRect.width, slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
    this.style.setProperty("--marquee-animation-duration", `${(scrollingSpeed * slowFactor * entries[0].target.querySelector("span").clientWidth / contentWidth).toFixed(3)}s`);
  }
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

// js/theme.js
import { Delegate as Delegate4 } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
(() => {
  const delegateDocument = new Delegate4(document.documentElement);
  if (window.themeVariables.settings.showPageTransition && "animate" in document.documentElement && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    delegateDocument.on("click", "a", async (event, target) => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey) {
        return;
      }
      if (target.hostname !== window.location.hostname || target.pathname === window.location.pathname) {
        return;
      }
      event.preventDefault();
      await document.body.animate({ opacity: [1, 0] }, { duration: 75, fill: "forwards" }).finished;
      window.location = target.href;
    });
  }
  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    delegateDocument.on("click", 'a[href*="#"]', (event, target) => {
      if (event.defaultPrevented || target.pathname !== window.location.pathname || target.search !== window.location.search) {
        return;
      }
      const url = new URL(target.href);
      if (url.hash === "") {
        return;
      }
      const anchorElement = document.querySelector(url.hash);
      if (anchorElement) {
        event.preventDefault();
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }
  const setScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    }
  };
  setScrollbarWidth();
  window.addEventListener("resize", throttle(setScrollbarWidth));
})();

import { animate as animateVS, timeline as timelineVS, stagger as staggerVS } from "//eu.mammotion.com/cdn/shop/t/22/assets/vendor.min.js?v=136053555471622566971766139978";
var VirtualServiceCheckoutButton = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    this.inputEle = this.closest('.product-info__plate-module').querySelector('input');
    this.errorTipEle = this.closest('.product-info__plate-module').querySelector('.plate-module-error-tip');
    this.sessionTipEle = this.closest('.product-info__plate-module').querySelector('.plate-module-session-tip');
    this._onClickListener = this._onClick.bind(this);
    this._onInputChangedListener = this._onInputChanged.bind(this);
    this._apiTipMap = JSON.parse(this.getAttribute('tip') || {});
    console.log('this._apiTipMap: ', this._apiTipMap);
    this.append(this.contentElement, this.animationElement);
  }
  connectedCallback() {
    this.addEventListener("click", this._onClickListener);
    this.inputEle.addEventListener('change', this._onInputChangedListener);
    this.inputEle.addEventListener('input', this._onInputChangedListener);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onClickListener);
    this.inputEle.removeEventListener('change', this._onInputChangedListener);
    this.inputEle.removeEventListener('input', this._onInputChangedListener);
    this.setAttribute("aria-busy", "false");
    this.removeAttribute("disabled");
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild;
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === "true") {
      timelineVS([
        [this.contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
      animateVS(this.animationElement.children, { opacity: [1, 0.1] }, { duration: 0.35, delay: staggerVS(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      timelineVS([
        [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
    }
  }
  
  _onInputChanged(event) {
    this.errorTipEle.textContent = '';
    this.sessionTipEle.textContent = '';
  }
  
  _parseHTML(html) {
    try {
      // 使用 DOMParser 解码 HTML 实体
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      return doc.body.textContent;
    } catch (error) {
      return html;
    }
  }
  
  async _onClick(event) {
    // 判断是否 disabled
    if (this.hasAttribute("disabled")) {
      return;
    }
    
    // 清空输出
    this._onInputChanged();
    
    if (this.classList.value.includes('hidden')) {
      console.warn('Sold out!');

      return false;
    }
    
    
    // 打印 SessionStorage
    let appData = null;
    let userAccount = null;
    try {
      if(window.sessionStorage) {
        console.log('window.sessionStorage: ', window.sessionStorage);
        if(window.sessionStorage.appData) {
          appData = window.sessionStorage.appData;
          let jsonObj = JSON.parse(window.sessionStorage.appData)
          userAccount = jsonObj?.userAccount;
          // this.sessionTipEle.textContent = JSON.stringify(window.sessionStorage.appData);
        }
      }
    } catch (error) {
      console.log('error: ', error);
    }
    
    this._productForm = document.forms[this.getAttribute("form")];
    const mainProductQuantity = getProductFormQuantity(this._productForm);
    const mainProductId = this._productForm.id.value;
    const plate = this.inputEle.value;
    // valid plateNumber
    if(!plate) {
      this.errorTipEle.textContent = this._parseHTML(this._apiTipMap['60601']);
      // this.inputEle.focus();
      return;
    }
    // const url = "https://api-robot-cn-test.mammotion.com/device-server/v1/shopify/validate/plateForPurchase"; // 替换为您的服务器地址

    this.setAttribute("aria-busy", "true");
    this.setAttribute("disabled", "disabled");
    
    const requestData = {
      plateNumber: plate,
      site: "EU",
      ...(userAccount ? { userAccount } : {}), // 仅在 userAccount 不为空时添加
      variantId: mainProductId,
    };
    
    // 加签逻辑
    const appKey = 'mammotion';
    const appSecret = 'ZDHXPTQKLRVFIWJG';
    const timestamp = new Date().getTime();
    const path = '/device-data-server/v1/shopify/product/device/confirmation';
    const paramMapJson = JSON.stringify(requestData);
    const content = appKey + timestamp + path + paramMapJson;
    const sign = CryptoJS.HmacSHA256(content, appSecret).toString(CryptoJS.enc.Hex);
    // https://api-data-us.mammotion.com/device-data-server/v1/shopify/product/device/confirmation
    const url = `https://api-data-eu.mammotion.com${path}`
    
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Request-Id": new Date().getTime(),
          "Project-Code": "ROBOT-SERVER",
          "Ma-Timestamp": timestamp,
          "Ma-Signature": sign,
          "Ma-App-Key": appKey
        },
        body: JSON.stringify(requestData)
      });

      // 检查响应是否成功
      if (!response.ok) {
        const errorData = await response.json();
        console.error("errorData:", errorData);
        return;
      }

      const data = await response.json();
      console.log("验证结果:", data);
      if(data.code !== 0 || !data?.data) {
        
        this.errorTipEle.textContent = this._parseHTML(this._apiTipMap[data.code] || this._apiTipMap['DEFAULT']);
        // this.inputEle.focus();
        return false;
      }
      // 跳转到结账页
      
      let products = [{
        id: mainProductId,
        quantity: mainProductQuantity,
        properties: {
          ...(userAccount ? { userAccount } : {}), // 仅在 userAccount 不为空时添加
          deviceName: plate
        }
      }];
      
      const properties = {
        ...(userAccount ? { userAccount: userAccount  } : {}), // 仅在 userAccount 不为空时添加
        deviceName: plate
      }
      
      let propertiesStr = '';
      let noteStr = `plateNumber=${plate}${userAccount ? `&userAccount=${userAccount}` : ''}`;
      
      // 1. 清空购物车
      await fetch("/cart/clear.js", { method: "POST" })
        .then(() => {
          // 2. 添加新商品
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: mainProductId,
              quantity: mainProductQuantity,
              properties: properties
            }),
          });
        })
        .then(() => {
          // 3. 设置购物车备注和属性
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              note: noteStr,
              attributes: properties
            }),
          });
        })
        .then(() => {
          window.location.href = `/checkout?timestamp=${timestamp}`;
        });
      
      // let checkoutLink = '/cart/' + products.map(item => {
      //   // 将 item.properties 转换为查询参数
      //   propertiesStr += propertiesStr ? '&' : ''
      //   propertiesStr += item.properties ? Object.entries(item.properties).map(([key, value]) => `attributes[${key}]=${encodeURIComponent(value)}`).join('&') : '';
      //   // 生成 line item 字符串
      //   let lineItem = `${item.id}:${item.quantity}`;
      //   return lineItem;
      // }).join(',');
      
      // if(propertiesStr) {
      //   checkoutLink += `?${propertiesStr}&note=${noteStr}`;
      // }
      
      // &return_to=/cart/clear
      // https://mammotion-test.myshopify.com/cart/clear?return_to=/cart/51720215495028:1?attributes[deviceName]=Sakura&attributes[account]=account&note=plateNumber=Sakura
      // console.log('checkoutLink: ', checkoutLink);
      // window.location.href = checkoutLink;
      
      // 在新标签页中打开链接
      // const link = document.createElement("a");
      // link.href = checkoutLink;
      // link.target = "_blank";
      // link.click();
      
    } catch (error) {
      console.error("error:", error);
      return false;
    } finally {
      // 无论是否发生异常，都会执行的代码
      this.setAttribute("aria-busy", "false");
      this.removeAttribute("disabled");
    }

  }
}
if (!window.customElements.get("virtual-service-checkout-button")) {
  window.customElements.define("virtual-service-checkout-button", VirtualServiceCheckoutButton);
}

var ComboInputWrapper = class extends HTMLElement {
  constructor() {
    super();
    this._options = this.querySelector('#combo-options');
    console.log('this._options: ', this._options);
    this._input = this.querySelector('input');
    this._onInputClickListener = this._onInputClick.bind(this);
    this._onInputBlurListener = this._onInputBlur.bind(this);
    this._onInputInputListener = this._onInputInput.bind(this);
    this._onOptionsClickListener = this._onOptionsClick.bind(this);
  }
  
  connectedCallback() {
    this.initComboBox();
    this._input.addEventListener("click", this._onInputClickListener);
    this._input.addEventListener("focus", this._onInputClickListener);
    this._input.addEventListener("blur", this._onInputBlurListener);
    this._input.addEventListener("input", this._onInputInputListener);
    this._options.addEventListener("mousedown", this._onOptionsClickListener);
  }
  disconnectedCallback() {
    this._input.removeEventListener("click", this._onInputClickListener);
    this._input.removeEventListener("focus", this._onInputClickListener);
    this._input.removeEventListener("blur", this._onInputBlurListener);
    this._input.removeEventListener("input", this._onInputInputListener);
    this._options.removeEventListener("mousedown", this._onOptionsClickListener);
  }
  
  // 从 sessionStorage 读取选项列表
  loadOptionsFromStorage() {
    let appData = null;
    let storedOptions = [];
    try {
      appData = JSON.parse(window.sessionStorage.getItem('appData'));
      console.log('appData: ', appData);
      console.log('device: ', appData?.device);
      if(appData?.device && appData?.device?.length > 0) {
        storedOptions = appData?.device.split(',');
      }
    } catch (error) {
      console.warn('error: ', error);
    }
    console.log('storedOptions: ', storedOptions);
    return storedOptions;
  }
  
  // 渲染选项列表
  renderOptions(optionsList) {
    this._options.innerHTML = ''; // 清空现有选项
    optionsList.forEach(option => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.textContent = option;
      li.setAttribute('data-value', option);
      this._options.appendChild(li);
    });
  };
  
  // 初始化组合框
  initComboBox() {
    const optionsList = this.loadOptionsFromStorage();
    console.log('initComboBox optionsList: ', optionsList);

    // 如果选项只有一个，自动填充输入框
    if (optionsList.length === 1) {
      this._input.value = optionsList[0];
    }

    // 渲染选项列表
    this.renderOptions(optionsList);
  };
  
  _onInputClick(event) {
    console.log('_onInputClick event: ', event);
    this._options.style.display = 'block';
  }
  
  // 隐藏下拉列表
  _onInputBlur(event) {
    setTimeout(() => {
      this._options.style.display = 'none';
    }, 100); // 延迟隐藏，以便点击选项时可以触发点击事件
  }
  
  // 输入时过滤选项
  _onInputInput(event) {
    const filter = this._input.value.toLowerCase();
    const optionItems = this._options.querySelectorAll('li');
    optionItems.forEach(item => {
      const text = item.textContent.toLowerCase();
      if (text.includes(filter)) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  }
  
  // 点击选项时，将选项值填入输入框
  _onOptionsClick(event) {
    if (event.target.tagName === 'LI') {
      event.preventDefault(); // 阻止输入框失去焦点
      this._input.value = event.target.textContent;
      this._options.style.display = 'none';
      // 清空错误提示
      document.querySelector('.plate-module-error-tip').textContent = '';
    }
  }
  
}
if (!window.customElements.get("combo-input-wrapper")) {
  window.customElements.define("combo-input-wrapper", ComboInputWrapper);
}

// compare-model-card
var CompareModelCard = class extends HTMLElement {
  constructor() {
    super();
    this._modelKey = this.getAttribute('model_key');
    this._compareKeyList = (this.getAttribute('compare_key_list') || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
    this._compareType = 'compare_data_all';
    this._transformedGroup = null;
    this._transformedData = null;
    this._modelData = null;
    this._requestVersion = 0;
  }

  connectedCallback() {
    this._loadCompareData();
  }

  disconnectedCallback() {
    this._requestVersion += 1;
  }

  async _loadCompareData() {
    const version = ++this._requestVersion;
    if (typeof window.loadCompareData !== 'function') {
      console.error('Compare data loader is unavailable.');
      return;
    }

    try {
      const sheet = await window.loadCompareData(this._compareType);
      if (!this.isConnected || version !== this._requestVersion) return;

      this._transformedGroup = this.cleanObjectKeys(sheet.transformedGroup || {});
      this._transformedData = Array.isArray(sheet.transformedData) ? sheet.transformedData : [];
      this._modelData = this._transformedData.find((item) => item.key === this._modelKey);
      this.renderCompareInfo();
    } catch (error) {
      console.error('Compare model card data could not be loaded.', error);
    }
  }
  
  cleanObjectKeys(obj) {
    const cleanedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        // 去掉key 全部的空格，包括首尾和中间的
        const cleanedKey = key.replace(/\s+/g, '');
        
        cleanedObj[cleanedKey] = obj[key];
      }
    }
    return cleanedObj;
  }
  
  renderCompareInfo() {
    if (!this._transformedGroup || !this._modelData) return;

    let results = '';
    this._compareKeyList.forEach(key => {
      const info = key.split('.');
      const group = info[0];
      const keyItem = info[1];
      const groupItems = this._transformedGroup[group];
      if (!Array.isArray(groupItems)) return;
      groupItems.forEach((groupItem) => {
        if(groupItem.key === keyItem) {
          results += `<div class="compare-info__item">
            <div class="compare-info__item-title">${groupItem.title}</div>
            <div class="compare-info__item-value">${this._modelData[keyItem]}</div>
          </div>`;
        }
      });
    });
    const wrapper = this.querySelector('.compare-info-wrapper');
    if (wrapper) wrapper.innerHTML = results;
  }
};
if (!window.customElements.get("compare-model-card")) {
  window.customElements.define("compare-model-card", CompareModelCard);
}

class UnionSelect extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
  }

  connectedCallback() {
    // 获取目标 class
    this.targetClass = this.getAttribute("target-class");
    if (!this.targetClass) {
      console.error("Missing 'target-class' attribute.");
      return;
    }

    // 获取目标 checkbox 元素
    this.targetCheckboxes = this.closest(".checkbox-list").querySelectorAll(`.${this.targetClass} input[type="checkbox"]`);
    if (this.targetCheckboxes.length === 0) {
      console.error(`No checkboxes found with class '${this.targetClass}'.`);
      return;
    }

    // 监听 unionSelect 的点击事件
    this.checkbox.addEventListener("change", (e) => {
      this._updateTargetCheckboxes();
    });

    // 监听目标 checkbox 的变化
    this.targetCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this._updateUnionSelectState();
      });
    });

    // 初始化 unionSelect 状态
    this._updateUnionSelectState();
  }

  // 更新目标 checkbox 的选中状态
  _updateTargetCheckboxes() {
    this.targetCheckboxes.forEach((checkbox) => {
      checkbox.checked = this.checkbox.checked;
    });
  }

  // 更新 unionSelect 的选中状态
  _updateUnionSelectState() {
    const checkedCount = Array.from(this.targetCheckboxes).filter((checkbox) => checkbox.checked).length;
    if (checkedCount === 0) {
      this.checkbox.checked = false;
      this.checkbox.indeterminate = false;
    } else if (checkedCount === this.targetCheckboxes.length) {
      this.checkbox.checked = true;
      this.checkbox.indeterminate = false;
    } else {
      this.checkbox.checked = false;
      this.checkbox.indeterminate = true;
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("union-select")) {
  window.customElements.define("union-select", UnionSelect);
}

class RatingComponent extends HTMLElement {
  static get observedAttributes() {
    return ['value', 'max', 'step', 'read-only'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // 默认值
    this._value = 0;
    this._max = 5;
    this._step = 0.5;
    this._readOnly = false;
    this._hoverValue = -1;
    
    this._mobileClickAble = true;
   
    
    // 事件绑定
    this._handleMouseMove = this._handleMouseMove.bind(this);
    this._handleMouseLeave = this._handleMouseLeave.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this._handleTouchMove = this._handleTouchMove.bind(this);
    this._handleTouchEnd = this._handleTouchEnd.bind(this);
  }

  connectedCallback() {
    this.lowScore = this.getAttribute('low-score') || '';
    this.bgStarColor = this.getAttribute('bg-star-color') || '#CCCCCC';
    console.log('this.bgStarColor: ', this.bgStarColor);
    this.activeStarColor = this.getAttribute('active-star-color') || '#FFD700';
    console.log('this.activeStarColor: ', this.activeStarColor);
    console.log('this.lowScore: ', this.lowScore);
    
    this._render();
    this._addEventListeners();
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    switch (name) {
      case 'value':
        this.value = parseFloat(newValue) || 0;
        break;
      case 'max':
        this.max = parseInt(newValue) || 5;
        break;
      case 'step':
        this.step = parseFloat(newValue) || 0.5;
        break;
      case 'read-only':
        this.readOnly = newValue !== null;
        this._updateCursor();
        break;
    }
  }

  get value() {
    return this._value;
  }

  set value(newValue) {
    const rounded = this._roundValue(newValue);
    if (rounded !== this._value) {
      this._value = rounded;
      this.setAttribute('value', rounded);
      this._updateStars();
      
      // 触发自定义事件
      this.dispatchEvent(new CustomEvent('change', {
        detail: { value: this._value },
        bubbles: true,
        composed: true
      }));
    }
  }

  get max() {
    return this._max;
  }

  set max(val) {
    this._max = val;
    this.setAttribute('max', val);
  }

  get step() {
    return this._step;
  }

  set step(val) {
    this._step = val;
    this.setAttribute('step', val);
  }

  get readOnly() {
    return this._readOnly;
  }

  set readOnly(val) {
    this._readOnly = val;
    if (val) {
        this.setAttribute('read-only', '');
    } else {
        this.removeAttribute('read-only');
    }
    this._updateCursor();
  }

  _roundValue(value) {
    if (this._step === 1) {
      return Math.round(value);
    }
    return Math.round(value * 2) / 2;
  }

  _render() {
    // 创建容器
    const container = document.createElement('div');
    container.className = 'rating-container';
    container.style.display = 'inline-flex';
    container.style.alignItems = 'center';
    
    // 创建星星
    for (let i = 1; i <= this._max; i++) {
      const wrapper = document.createElement('div');
      wrapper.className = 'rating-icon-wrapper';
      wrapper.dataset.value = i;
      wrapper.style.position = 'relative';
      wrapper.style.marginRight = '4px';
      wrapper.style.cursor = this._readOnly ? 'default' : 'pointer';
      
      // 背景星（灰色）
      const bgStar = document.createElement('div');
      bgStar.className = 'rating-icon bg';
      bgStar.innerHTML = this._getStarSVG();
      bgStar.style.color = this.bgStarColor;
      bgStar.style.width = '24px';
      bgStar.style.height = '24px';
        
      // 前景星（金色）
      const fgStar = document.createElement('div');
      fgStar.className = 'rating-icon fg';
      fgStar.innerHTML = this._getStarSVG();
      fgStar.style.color = this.activeStarColor;
      fgStar.style.position = 'absolute';
      fgStar.style.top = '0';
      fgStar.style.left = '0';
      fgStar.style.width = '0%';
      fgStar.style.overflow = 'hidden';
      fgStar.style.whiteSpace = 'nowrap';
      
      wrapper.appendChild(bgStar);
      wrapper.appendChild(fgStar);
      container.appendChild(wrapper);
    }
    
    // 添加样式
    const style = document.createElement('style');
    style.textContent = `
      .rating-icon {
        display: inline-block;
        transition: transform 0.1s;
      }
      
      .rating-icon svg {
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
      
      :host(:not([read-only])) .rating-icon-wrapper:hover {
        transform: scale(1.1);
      }
      
      /* ==== 新增：反馈区域样式 ==== */
      .feedback-container {
        margin-top: 8px;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.08);
        display: none;
        flex-direction: column;
        gap: 8px;
        animation: fadeIn 0.3s ease;
      }

      .feedback-input {
        resize: none;
        min-height: 60px;
        border: 1px solid #ddd;
        border-radius: 6px;
        padding: 8px;
        font-size: 14px;
        line-height: 1.4;
        transition: border-color 0.2s, box-shadow 0.2s;
      }

      .feedback-input:focus {
        border-color: #4a90e2;
        box-shadow: 0 0 4px rgba(74,144,226,0.3);
        outline: none;
      }

      .feedback-submit {
        align-self: flex-end;
        background: #4a90e2;
        color: white;
        border: none;
        padding: 6px 14px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
        transition: background 0.2s, transform 0.1s;
      }

      .feedback-submit:hover {
        background: #357ab8;
      }

      .feedback-submit:active {
        transform: scale(0.95);
      }

      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-6px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
    
    // 添加 advice input
    const feedbackContainer = document.createElement('div');
    feedbackContainer.setAttribute('part', 'feedback-container');
    feedbackContainer.className = 'feedback-container';
    feedbackContainer.style.display = 'none'; // 默认隐藏
    const textarea = document.createElement('textarea');
    textarea.placeholder = 'please leave your advice...';
    textarea.className = 'feedback-input';
    textarea.maxLength = 1000;
    textarea.id = 'FeedbackInput';
    
    const submitBtn = document.createElement('button');
    submitBtn.textContent = 'Submit';
    submitBtn.className = 'feedback-submit';
    
    feedbackContainer.appendChild(textarea);
    feedbackContainer.appendChild(submitBtn);
    
    this.shadowRoot.innerHTML = '';
    this.shadowRoot.appendChild(style);
    this.shadowRoot.appendChild(container);
    this.shadowRoot.appendChild(feedbackContainer);

    this.container = this.shadowRoot.querySelector('.rating-container');
    this.feedbackContainer = feedbackContainer;
    this.feedbackInput = textarea;
    this.feedbackSubmit = submitBtn;
    
    // 初始状态
    this._updateStars();
  }

  _getStarSVG() {
    return `
      <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="0">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
      </svg>
    `;
  }

  _addEventListeners() {
    this.shadowRoot.addEventListener('mousemove', this._handleMouseMove);
    this.container.addEventListener('mouseleave', this._handleMouseLeave);
    this.container.addEventListener('click', this._handleClick);
    
    // 添加触摸事件支持
    this.shadowRoot.addEventListener('touchmove', this._handleTouchMove, { passive: false });
    this.shadowRoot.addEventListener('touchend', this._handleTouchEnd);
    
    if (this.feedbackSubmit) {
      this.feedbackSubmit.addEventListener('click', () => {
        const feedback = this.feedbackInput.value.trim();
        if (!feedback) return; // 如果输入为空则不提交
        this.dispatchEvent(new CustomEvent('rating:feedback', {
          detail: {
            value: this.value,
            feedback
          },
          bubbles: true,
          composed: true
        }));
        // 提交后清空输入框并隐藏
        this.feedbackInput.value = '';
        this.feedbackContainer.style.display = 'none';
      });
    }
  }

  _removeEventListeners() {
    this.shadowRoot.removeEventListener('mousemove', this._handleMouseMove);
    this.container.removeEventListener('mouseleave', this._handleMouseLeave);
    this.container.removeEventListener('click', this._handleClick);
    this.shadowRoot.removeEventListener('touchmove', this._handleTouchMove);
    this.shadowRoot.removeEventListener('touchend', this._handleTouchEnd);
  }

  _updateCursor() {
    const wrappers = this.shadowRoot.querySelectorAll('.rating-icon-wrapper');
    wrappers.forEach(wrapper => {
      wrapper.style.cursor = this._readOnly ? 'default' : 'pointer';
    });
  }

  _updateStars() {
    const displayValue = this._hoverValue >= 0 ? this._hoverValue : this._value;
    const wrappers = this.shadowRoot.querySelectorAll('.rating-icon-wrapper');
    
    wrappers.forEach((wrapper, index) => {
      const value = index + 1;
      const fgStar = wrapper.querySelector('.fg');
      
      if (value <= displayValue) {
        fgStar.style.width = '100%';
      } else if (displayValue > index && displayValue < value) {
        const partialWidth = (displayValue - index) * 100;
        fgStar.style.width = `${partialWidth}%`;
      } else {
        fgStar.style.width = '0%';
      }
    });
  }

  _calculateValue(event) {
    if (this._readOnly) return this._value;
    
    const container = this.shadowRoot.querySelector('.rating-container');
    const rect = container.getBoundingClientRect();
    
    // 获取事件坐标
    let clientX;
    if (event.type.includes('touch')) {
      if (event.touches && event.touches.length > 0) {
        clientX = event.touches[0].clientX;
      } else {
        return this._value;
      }
    } else {
      clientX = event.clientX;
    }
    
    const relativeX = clientX - rect.left;
    const containerWidth = rect.width;
    const positionRatio = relativeX / containerWidth;
    
    // 计算临时值
    let tempValue = positionRatio * this._max;
      
    // 对于1步长模式，只要碰到一点就算满足
    if (this._step === 1) {
      tempValue = Math.ceil(tempValue);
    } else {
      // 对于非1步长模式，需要根据临时值的小数部分来判断
      tempValue = this._customRound(tempValue);
    }
    
    // 确保值在有效范围内
    return Math.max(0, Math.min(this._max, tempValue));
  }
  
  _customRound(tempValue) {
    const integerPart = Math.floor(tempValue); // 获取整数部分
    const decimalPart = tempValue - integerPart; // 获取小数部分

    if (decimalPart <= 0.1) {
      return integerPart;
    } else if (decimalPart > 0.1 && decimalPart <= 0.4) {
      return integerPart + 0.5;
    } else { // decimalPart > 0.4
      return integerPart + 1;
    }
  }

  _handleMouseMove(event) {
    if (this._readOnly) return;
    this._hoverValue = this._calculateValue(event);
    this._updateStars();
  }

  _handleMouseLeave() {
    if (this._readOnly) return;
    this._hoverValue = -1;
    this._updateStars();
  }

  _handleClick(event) {
    if (this._readOnly) return;
    const newValue = this._calculateValue(event);
    let clearFlag = false;
    console.log('clck', this.lowScore, newValue);
    if (newValue === 0) return;
    
    // 如果点击的值与当前值相同，则清除评分
    if(newValue === this.value && newValue > 0) {
      clearFlag = true;
      this.value = 0;
    } else {
      clearFlag = false;
      this.value = newValue;
    }
    this._hoverValue = -1;
    this._updateStars();
    let type = 'click';
    
    if(clearFlag) {
      this.dispatchEvent(new CustomEvent('rating:clear', {
        detail: { value: newValue },
        bubbles: true,
        composed: true
      }));
      
      type = 'clear';
    } else {
      if(this.lowScore && this.value > 0 && this.value <= parseFloat(this.lowScore)) {
        setTimeout(() => {
          this.feedbackContainer.style.display = 'flex';
          // 点击后隐藏评分组件
          this.container.style.display = 'none';
        }, 300);
        type = 'show-feedback';
        this._mobileClickAble = false;
      } else {
        this.feedbackContainer.style.display = 'none';
      }
    }
    
    // 点击后触发自定义事件
    this.dispatchEvent(new CustomEvent('rating:click', {
      detail: { value: this.value, type },
      bubbles: true,
      composed: true
    }));
    
  }

  _handleTouchMove(event) {
    if (this._readOnly || !this._mobileClickAble) return;
    event.preventDefault(); // 防止页面滚动
    this._hoverValue = this._calculateValue(event);
    this._updateStars();
  }

  _handleTouchEnd(event) {
    if (this._readOnly || !this._mobileClickAble) return;
    const newValue = this._calculateValue(event);
    
    // 如果触摸的值与当前值相同，则清除评分
    this.value = (newValue === this.value && newValue > 0) ? 0 : newValue;
    
    // 重置hover状态
    this._hoverValue = -1;
    this._updateStars();
  }
}

// 注册自定义元素
if (!window.customElements.get('rating-component')) {
    window.customElements.define('rating-component', RatingComponent);
}

class HoverWithVideo extends HTMLElement {
  constructor() {
    super();
    
    this._videoUrl = this.getAttribute('data-video-url');
    this._video = this.querySelector('.card-video source');
    if (this._video && this._videoUrl) {
      this._video.setAttribute('src', this._videoUrl);
      this._video.load();
    }
    
    this._onMouseEnterListener = this._onMouseEnter.bind(this);
    this._onMouseLeaveListener = this._onMouseLeave.bind(this);
  }

  connectedCallback() {
    if (this._video) {
      this.addEventListener('mouseenter', this._onMouseEnterListener);
      this.addEventListener('mouseleave', this._onMouseLeaveListener);
    }
  }

  disconnectedCallback() {
    if (this._video) {
      this.removeEventListener('mouseenter', this._onMouseEnterListener);
      this.removeEventListener('mouseleave', this._onMouseLeaveListener);
    }
  }

  _onMouseEnter() {
    if (this._video) {
      this._video.play();
    }
  }

  _onMouseLeave() {
    if (this._video) {
      this._video.pause();
    }
  }
}
if (!window.customElements.get('hover-with-video')) {
  window.customElements.define('hover-with-video', HoverWithVideo);
}

class CustomAction extends HTMLElement {
  constructor() {
    super();
    this._onClickListener = this._onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this._onClickListener);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClickListener);
  }

  _onClick(event) {
    console.log('CustomAction _onClick event: ', event);
    const actionType = this.getAttribute('action-type'); // link, blankLink or action(toggle, add, remove) or custom
    // link => target => href
    // blankLink => target => href
    // action => target => selector
    // custom => target => custom action handler (with data)
    let targetElement;
    const target = this.getAttribute('target'); 
    const data = this.getAttribute('data'); // optional data for custom action or action
    if (!actionType || !target) {
      console.error("Missing 'action-type' or 'target-selector' attribute.");
      return;
    }
    
    switch (actionType) {
      case "link":
        window.location.href = target;
        break;
      case "blankLink":
        window.open(target, '_blank');
        break;
      case "toggle":
        targetElement = document.querySelector(target);
        if (!targetElement) {
          console.error(`No element found with selector '${target}'.`);
          return;
        }
        targetElement.classList.toggle(data || "active");
        break;
      case "add":
        targetElement = document.querySelector(target);
        if (!targetElement) {
          console.error(`No element found with selector '${target}'.`);
          return;
        }
        targetElement.classList.add(data || "active");
        break;
      case "remove":
        targetElement = document.querySelector(target);
        if (!targetElement) {
          console.error(`No element found with selector '${target}'.`);
          return;
        }
        targetElement.classList.remove(data || "active");
        break;
      case "custom":
        console.log('custom target: ', target);
        document.dispatchEvent(new CustomEvent(target, {
          detail: { data },
        }))
        break;
      default:
        console.error(`Unsupported action type '${actionType}'.`);
    }
  }
}

if (!window.customElements.get('custom-action')) {
  window.customElements.define('custom-action', CustomAction);
}

class TextCollapser extends HTMLElement {
  constructor() {
    super();
    // 创建 Shadow DOM 并附加
    this.attachShadow({ mode: 'open' });

    // 状态管理
    this.isExpanded = false;

    // 内部元素引用
    this.wrapper = null;
    this.contentElement = null;
    this.button = null;

    // 绑定事件处理器
    this.handleToggle = this.handleToggle.bind(this);
  }

  // ----------------------------------------------------
  // 1. Web Component 生命周期方法
  // ----------------------------------------------------

  /**
   * 组件首次连接到文档 DOM 时调用
   */
  connectedCallback() {
    this.render();
    this.initializeElements();
    this.setupEventListeners();

    // 初始检查是否需要折叠 (确保内容已渲染完毕)
    // 使用 setTimeout 确保 slot 内容已完全渲染并计算出正确的高度
    // 尤其是在外部内容是动态加载或复杂结构时
    setTimeout(() => {
      this.checkAndApplyCollapsing();
    }, 0); 
  }

  /**
   * 组件与文档 DOM 断开连接时调用
   */
  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleToggle);
    }
  }

  /**
   * 监听属性变化
   */
  static get observedAttributes() {
    return ['lines', 'expanded-text', 'collapsed-text'];
  }

  /**
   * 属性变化时调用
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    if (name === 'lines') {
      // lines 属性变化，需要重新评估是否折叠
      this.applyInitialStyles(); // 重新设置 line-clamp
      // 只有在组件已经初始化后才执行完整检查
      if (this.contentElement) { 
        this.checkAndApplyCollapsing();
      }
    } else if (this.button) {
      // 按钮文本变化
      this.updateButtonText();
    }
  }

  // ----------------------------------------------------
  // 2. 渲染和初始化
  // ----------------------------------------------------

  render() {
    const shadow = this.shadowRoot;
    shadow.innerHTML = `
      <style>
        :host {
          display: block;
          contain: layout style; /* 提升性能隔离 */
        }
        .content-wrapper {
          position: relative;
          overflow: hidden;
          transition: max-height 0.3s ease-out; /* 平滑过渡 */
        }
        .content {
          margin: 0;
          display: -webkit-box; /* 启用弹性盒布局以使用 line-clamp */
          -webkit-box-orient: vertical; /* 垂直方向 */
        }
        /* 当内容展开时，移除 line-clamp 限制 */
        .content.is-expanded {
          display: block; /* 展开时确保块级显示，并覆盖 -webkit-box */
          -webkit-line-clamp: unset !important; /* 移除行数限制 */
        }
        
        /* ============== 蒙版渐变样式 ============== */
        .content-wrapper::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: var(--collapser-fade-height, 4em); /* 渐变蒙版的高度，可以根据行高调整 */
          /* Fade into the host's background; set --collapser-fade-color when it isn't white. */
          background: linear-gradient(to bottom, transparent, var(--collapser-fade-color, #fff) 85%);
          pointer-events: none; /* 确保不影响文本选择和点击 */
          opacity: 1; /* 默认可见 */
          transition: opacity 0.3s ease-out; /* 渐变蒙版自身的过渡效果 */
          z-index: 1; /* 确保蒙版在内容上方 */
        }

        /* 展开时隐藏蒙版 */
        .content-wrapper.is-expanded::after {
          opacity: 0;
        }

        /* 如果你的背景不是白色，需要调整渐变颜色 */
        /* 例如，如果背景是 #f0f0f0: 
        .content-wrapper::after {
          background: linear-gradient(to bottom, rgba(240, 240, 240, 0), rgba(240, 240, 240, 1) 70%);
        }
        */
        /* ============== 蒙版渐变样式结束 ============== */
        
        .toggle-button {
          display: none; /* 默认隐藏，只有需要折叠时才显示 */
          cursor: pointer;
          color: var(--collapser-link-color, #007bff); /* 可配置颜色 */
          margin-top: var(--collapser-toggle-gap, 8px);
          text-decoration: none;
          user-select: none; /* 防止文本被选中 */
        }
        .toggle-button:hover .toggle-label {
          text-decoration: underline;
        }
        /* Expand / collapse chevron (Figma icon-outline-cheveron-down); it points up while expanded. */
        .toggle-button {
          align-items: center;
          gap: 2px;
        }
        .toggle-icon {
          flex: none;
          transition: transform 0.2s ease;
        }
        .toggle-button[aria-expanded="true"] .toggle-icon {
          transform: rotate(180deg);
        }
        @media (prefers-reduced-motion: reduce) {
          .toggle-icon {
            transition: none;
          }
        }
      </style>
      
      <div class="content-wrapper">
        <div class="content" id="content-element">
          <slot></slot> 
        </div>
      </div>
      <a class="toggle-button" aria-expanded="false" role="button">
        <span class="toggle-label">Learn more</span>
        <svg class="toggle-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M13.6094 5.9998L8.4714 11.1379H7.5286L2.3906 5.9998L3.3333 5.0571L8 9.7238L12.6667 5.0571L13.6094 5.9998Z" fill="currentColor"/></svg>
      </a>
    `;
  }
  
  initializeElements() {
    this.wrapper = this.shadowRoot.querySelector('.content-wrapper');
    this.contentElement = this.shadowRoot.querySelector('#content-element');
    this.button = this.shadowRoot.querySelector('.toggle-button');
    // 初始应用样式，特别是 line-clamp
    this.applyInitialStyles();
  }

  setupEventListeners() {
    if (this.button) {
      this.button.addEventListener('click', this.handleToggle);
    }
  }

  // ----------------------------------------------------
  // 3. 核心逻辑
  // ----------------------------------------------------

  /**
   * 根据 'lines' 属性应用初始样式
   */
  applyInitialStyles() {
    const lines = parseInt(this.getAttribute('lines') || '3', 10);

    if(this.contentElement) this.contentElement.style.webkitLineClamp = lines;
    // 在测量前不限制 max-height，让 line-clamp 实际影响高度
    if(this.wrapper) this.wrapper.style.maxHeight = 'none';
  }

  getComputedLineHeight() {
    const style = getComputedStyle(this.contentElement);
    const lineHeight = style.lineHeight;
    if (lineHeight === 'normal') {
      const fontSize = parseFloat(style.fontSize);
      return fontSize * 1.2;
    }
    return parseFloat(lineHeight);
  }

  getTargetCollapsedHeight(lines) {
    var webkitClampedHeight = this.contentElement.offsetHeight;
    var fullHeight = this.contentElement.scrollHeight;

    if (webkitClampedHeight < fullHeight) {
      return webkitClampedHeight;
    }
    return Math.ceil(this.getComputedLineHeight() * lines);
  }

  /**
   * 检查内容高度是否超出，并决定是否显示按钮和应用折叠
   */
  checkAndApplyCollapsing() {
    // 测量内容实际完整高度
    this.contentElement.style.webkitLineClamp = 'unset'; // 暂时移除 line-clamp 限制
    this.contentElement.classList.add('is-expanded'); // 确保 display: block
    const fullHeight = this.contentElement.scrollHeight;
    
    // 恢复 line-clamp 限制以获取折叠后的高度
    const lines = parseInt(this.getAttribute('lines') || '3', 10);
    this.contentElement.style.webkitLineClamp = lines;
    this.contentElement.classList.remove('is-expanded'); // 恢复到折叠状态的 class
    
    // 使用 requestAnimationFrame 确保 DOM 测量是在正确的布局状态下进行的
    requestAnimationFrame(() => {
      const targetCollapsedHeight = this.getTargetCollapsedHeight(lines);

      if (fullHeight > targetCollapsedHeight) {
        // 内容确实超出了，需要折叠
        this.button.style.display = 'flex';
        this.wrapper.style.maxHeight = `${targetCollapsedHeight}px`; // 设置折叠高度
        this.updateButtonText();
        this.isExpanded = false; // 确保初始状态为折叠
        this.wrapper.classList.remove('is-expanded'); // 确保初始折叠时蒙版可见
      } else {
        // 内容没有超出，不需要折叠
        this.button.style.display = 'none';
        this.wrapper.style.maxHeight = 'none'; // 不限制高度
        this.contentElement.classList.add('is-expanded'); // 确保移除 line-clamp 效果
        this.isExpanded = true; // 既然不折叠，就视为已展开
        this.wrapper.classList.add('is-expanded'); // 确保初始不折叠时蒙版隐藏
      }
    });
  }

  /**
   * 切换展开/折叠状态
   */
  handleToggle(event) {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      // 展开
      this.contentElement.classList.add('is-expanded'); // 立即移除 line-clamp 样式
      this.wrapper.classList.add('is-expanded'); // 为 wrapper 添加 class 来控制蒙版
      // 获取完整的 scrollHeight
      const fullHeight = this.contentElement.scrollHeight;
      this.wrapper.style.maxHeight = `${fullHeight}px`; // 设置 max-height 以触发 CSS 过渡

      // 过渡结束后，将 max-height 设为 'none'，以防内容在展开后又动态变化
      this.wrapper.addEventListener('transitionend', () => {
        if (this.isExpanded) { // 再次确认当前状态是展开
          this.wrapper.style.maxHeight = 'none';
        }
      }, { once: true });

    } else {
      // 收起
      // 核心修复点：先计算折叠高度，再开始过渡
      const lines = parseInt(this.getAttribute('lines') || '3', 10);
      
      // 暂时性地应用 line-clamp 样式到 contentElement，用于测量目标折叠高度
      this.contentElement.classList.remove('is-expanded'); 
      this.wrapper.classList.remove('is-expanded');
      this.contentElement.style.webkitLineClamp = lines;

      const targetCollapsedHeight = this.getTargetCollapsedHeight(lines);
      
      // 为了平滑过渡，先确保 wrapper 的 max-height 是当前完整高度
      // 如果之前是 `none`，这里需要先设置成实际高度，才能触发后续的过渡
      this.wrapper.style.maxHeight = `${this.wrapper.scrollHeight}px`; 

      requestAnimationFrame(() => {
        // 然后设置到目标折叠高度，触发 CSS 过渡
        this.wrapper.style.maxHeight = `${targetCollapsedHeight}px`;

        // 过渡结束后，确保移除 is-expanded class，完成折叠状态
        this.wrapper.addEventListener('transitionend', () => {
          if (!this.isExpanded) { // 再次确认当前状态是折叠
            // 确保 line-clamp 样式已应用 (在上面测量时已经设置，这里是冗余确认)
            // this.contentElement.style.webkitLineClamp = lines; 
            this.contentElement.classList.remove('is-expanded'); 
          }
        }, { once: true });
      });
    }

    this.updateButtonText();
    this.button.setAttribute('aria-expanded', this.isExpanded);
  }

  /**
   * 更新按钮文本和 ARIA 属性
   */
  updateButtonText() {
    const expandedText = this.getAttribute('expanded-text') || 'Show less';
    const collapsedText = this.getAttribute('collapsed-text') || 'Learn more';
    // The chevron icon shows the direction, so drop the "<" / ">" that the translations end with.
    const label = (this.isExpanded ? expandedText : collapsedText).replace(/\s*[<>‹›«»]\s*$/, '');
    const labelElement = this.button.querySelector('.toggle-label');
    if (labelElement) labelElement.textContent = label;
  }
}

if (!window.customElements.get('text-collapser')) {
  window.customElements.define('text-collapser', TextCollapser);
}

class BuyButtonDetailsCard extends HTMLElement {
  constructor() {
    super();
    this._form = this.getAttribute('form');
    this._productId = this.getAttribute('product-id');
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._deviceRegion = null;
    this._currentVariant = null;

    // this._product = JSON.parse(this.getAttribute('product') || '{}');
    // console.log('==this._product: ', this._product);
    // this._variant = JSON.parse(this.getAttribute('variant') || '{}');
    // console.log('==this._variant: ', this._variant);
  }

  connectedCallback() {
    this.render();

    this.form = document.getElementById(this._form);
    if(this.form) {
      this.form.addEventListener("variant:change", this._onVariantChangedListener);
      this.salePriceEle = document.querySelector('.product-info__price sale-price');
      this.giftsEle = this.querySelector('.buy-button-details-card-gifts');
    }

    this.stopWatchingFormDataItems = this.observeFormItems(this._form);
    this._detectDeviceRegion();
  }
  
  disconnectedCallback() {
    this.stopWatchingFormDataItems();
  }
  
  render() {
    // 变体：变体图片，变体名称，变体价格，该变体的赠品
    // 勾选的配件列表
  }

  // 查询当前的国家区域
  async _detectDeviceRegion() {
    try {
      this._deviceRegion = await window.getDeviceRegion()
      // 检测完成后，用实际位置重新渲染首次显示的 tip
      this._renderInitialTip();
    } catch (e) {
      // 获取失败时保持 null，renderVariantTip 将使用 data-country 回退, 此处打印原因即可
      console.log('get device region fail,', e)
    }
  }

  _onVariantChanged(event) {
    if (event.detail.variant) {
      // 2026 design: the summary stays visible for a sold-out variant; its buy button shows the sold-out state.
      this.toggleAttribute('data-sold-out', !event.detail.variant.available);
      
      const variantNameEle = this.querySelector('.buy-button-details-card-title .variant-title');
      const imageEle = this.querySelector('.buy-button-details-card-image');
      
      variantNameEle.textContent = event.detail.variant.title || event.detail.variant.name;
      if(event.detail.variant?.featured_image?.src) {
        imageEle.src = event.detail.variant.featured_image.src;
      }
      
      // 重新渲染 Gift 元素
      this.renderGifts(event);

      // 重新渲染变体 tip
      this.renderVariantTip(event);

      this._currentVariant = event.detail.variant;
      this.renderPrice(event.detail.variant);
    }
  }
  
  renderGifts() {
    if (event.detail.variant) {
      const gifts = window?.variantMetafields[this._productId] && window.variantMetafields[this._productId][event.detail.variant.id]?.gifts;
      let giftsHTML = ''
      if(gifts) {
        gifts.forEach(gift => {
          if(gift.available === false) return; // 不可用的赠品不加入购物车
          console.log('==gift: ', gift);
          giftsHTML += `
            <div class="details-card--gift-item">
              <label class="gift-item__label">Free</label>
              <span class="gift-item__title">${gift.title}</span>
              <span class="gift-item__quantity">× ${gift.quantity}</span>
            </div>
          `
        });
      }
      this.giftsEle.style.display = giftsHTML ? 'flex' : 'none';
      this.giftsEle.innerHTML = giftsHTML;
    }
  }

  renderVariantTip(event) {
    const tipEle = this.querySelector('.buy-button-details-card-tip');
    if (!tipEle) return;
    const metafields = window?.variantMetafields[this._productId]?.[event.detail.variant.id];
    if (!metafields) return;
    this._applyTip(tipEle, metafields);
  }

  _applyTip(tipEle, metafields) {
    let tip = '';
    // 先检查 detail_card_tip_json 是否有对应国家配置
    if (metafields.detail_card_tip_json) {
      const country = (this._deviceRegion || this.dataset.country)?.toUpperCase();
      const items = typeof metafields.detail_card_tip_json === 'string'
        ? JSON.parse(metafields.detail_card_tip_json)
        : metafields.detail_card_tip_json;
      const match = items.find(item => item.key?.toUpperCase() === country);
      tip = match?.tip || '';
    }
    // 没有 JSON 匹配时，使用 detail_card_tip 作为默认值
    if (!tip) {
      tip = metafields.detail_card_tip || '';
    }
    if (tip) {
      tipEle.textContent = tip;
      tipEle.style.display = '';
    } else {
      tipEle.style.display = 'none';
    }
  }

  _renderInitialTip() {
    const tipEle = this.querySelector('.buy-button-details-card-tip');
    if (!tipEle) return;
    const variantIdInput = this.form?.querySelector('.variant_id');
    if (!variantIdInput) return;
    const metafields = window?.variantMetafields[this._productId]?.[variantIdInput.value];
    if (!metafields) return;
    this._applyTip(tipEle, metafields);
  }
  
  renderPrice(variant = this._currentVariant) {
    // 重新渲染价格
    const _this = this;
    const {
      itemsComparePriceTotal = 0,
      itemsPriceTotal = 0,
      mainProductPrice: formMainProductPrice = 0,
      mainProductComparePrice: formMainProductComparePrice = 0
    } = this.form?.dataset || {};
    const mainProductPrice = Number(variant?.price ?? formMainProductPrice ?? _this.salePriceEle?.dataset?.price ?? 0);
    const rawMainProductComparePrice = Number(variant?.compare_at_price ?? formMainProductComparePrice ?? 0);
    const mainProductComparePrice = rawMainProductComparePrice > mainProductPrice ? rawMainProductComparePrice : 0;
    const totalPrice = Number(mainProductPrice) + Number(itemsPriceTotal);
    const totalComparePrice = Number(mainProductComparePrice) + Number(itemsComparePriceTotal);
    
    const hasSaleFlag = totalComparePrice && totalComparePrice > totalPrice;
    
    const salePriceEle = _this.querySelector('.card-sale-price');
    salePriceEle.innerText = formatMoney(totalPrice, currencyFormat);
    salePriceEle.classList.toggle("sale", hasSaleFlag);
    
    const comparePriceEle = _this.querySelector('.card-compare-price');
    const saleLabelWrapEle = _this.querySelector('.card-sale-label');
    const saleLabelEle = saleLabelWrapEle?.querySelector('.label-value');
    
    if(hasSaleFlag) {
      comparePriceEle.innerText = formatMoney(totalComparePrice, currencyFormat);
      comparePriceEle.hidden = false;
      if (saleLabelEle) {
        // Whole amounts drop the .00, like the price badge and the add-to-cart bar.
        saleLabelEle.innerText = formatMoney(totalComparePrice - totalPrice, currencyFormat).replace(/[.,]00(?=\D*$)/, "");
      }
    } else {
      comparePriceEle.innerText = '';
      comparePriceEle.hidden = true;
      if (saleLabelEle) {
        saleLabelEle.innerText = '';
      }
    }
    comparePriceEle.classList.toggle("show", hasSaleFlag);
    saleLabelWrapEle?.classList.toggle("show", hasSaleFlag);
    
    const paypalEle = _this.querySelector('.card-total-paypal');
    if(paypalEle) {
      paypalEle.setAttribute('amount', totalPrice);
    }
  }
  
  /**
   * 监听指定表单的 data-items 变化，并触发回调。
   * @param {string} formId - 要监听的 form 元素 ID
   */
  observeFormItems(formId) {
    const form = document.getElementById(formId);
    const _this = this;
    if (!form) {
      console.error(`未找到 id 为 "${formId}" 的 form 元素`);
      return;
    }

    // 初始化时读取一次
    function parseItems() {
      try {
        const raw = form.dataset.items;
        if (!raw) return [];
        // dataset 会转义 HTML 引号，需要 decode + JSON.parse
        const decoded = raw.replace(/&quot;/g, '"');
        return JSON.parse(decoded);
      } catch (e) {
        console.warn("解析 data-items 出错：", e);
        return [];
      }
    }
    
    
    // 渲染 Items 其它项
    function renderItems() {
      const items = parseItems();

      // 举例：重新渲染 UI
      const accessoriesEl = _this.querySelector(".buy-button-details-card-accessories");
      accessoriesEl.innerHTML = items
        .map(
          (item) => `
            <div class="details-card--accessories-item">
              <span>${item.name}</span>
            </div>
          `
        )
        .join("");
    }
    
    // 首次渲染
    renderItems();
    
    // 处理 dataset 变化
    function handleDatasetChange(form, attributeName) {
      switch (attributeName) {
        case 'data-items':
          renderItems();
          break;
        case 'data-items-price-total':
        case 'data-items-compare-price-total':
          _this.renderPrice();
          break;
        default:
          console.log(`未处理的属性变化: ${attributeName}`);
      }
    }

    // 创建 MutationObserver 监听属性变化
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName.startsWith('data-')
        ) {
          handleDatasetChange(form, mutation.attributeName);
        }
      }
    });
    
    observer.observe(form, { attributes: true, attributeFilter: ['data-items', 'data-items-price-total', 'data-items-compare-price-total'] });

    // 返回取消监听的方法
    return () => observer.disconnect();
  }
}

if (!window.customElements.get('buy-button-details-card')) {
  window.customElements.define('buy-button-details-card', BuyButtonDetailsCard);
}

class TriggerDialogElement extends HTMLElement {
  constructor() {
    super();
    this._onClickListener = this._onClick.bind(this);
    
    this._dialogTitle = this.getAttribute('dialog-title');
    this._dialogElement = this.getAttribute('dialog-element');
  }

  connectedCallback() {
    this.addEventListener("click", this._onClickListener);
    this._dialogDetail = this.querySelector('.trigger-dialog-element--detail').innerHTML;
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClickListener);
  }

  _onClick(event) {
    const dialog = document.querySelector(this._dialogElement);
    const dialogInfo = dialog.querySelector('.dialog-body-box');
    const dialogTitle = dialog.querySelector('.dialog-title-text');
    
    const detailsHTML = this._dialogDetail;
    const title = this._dialogTitle;
    
    dialogInfo.innerHTML = detailsHTML;

    if (title && title.trim().length > 0) {
      dialogTitle.textContent = title;
    }
        
    dialog.setAttribute('open', '');
  }
}

if (!window.customElements.get('trigger-dialog-element')) {
  window.customElements.define('trigger-dialog-element', TriggerDialogElement);
}

class PasswordGuide extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    // 配置
    this.targetSequence = ['tl', 'tr', 'bl'];
    this.targetCounts = { tl: 1, tr: 2, bl: 3 };

    // 状态
    this.currentStepIndex = 0;
    this.clickAccumulator = 0;
    this.timer = null;
    this.isUnlocked = false;
  }

  connectedCallback() {
    this.render();

    this.wrapper = this.querySelector('.password-guide-wrapper');

    // 1. 监听热区点击
    const hotspots = this.shadowRoot.querySelectorAll('.hotspot');
    hotspots.forEach((spot) => {
      spot.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到全局，防止触发“无效区域重置”
        this.handleTargetClick(e.target.dataset.zone);
      });
    });

    // 2. 监听全局点击（实现：点击三个区域外重置）
    // 使用 pointerdown 或 click 均可
    window.addEventListener('click', (e) => {
      if (!this.isUnlocked) {
        // console.log('点击了无效区域，进度重置');
        this.resetProgress();
      }
    });
  }

  handleTargetClick(zone) {
    if (this.isUnlocked) return;

    // 如果点击顺序错误
    if (zone !== this.targetSequence[this.currentStepIndex]) {
      this.resetProgress();
      return;
    }

    this.clickAccumulator++;

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.checkStep();
    }, 400);
  }

  checkStep() {
    const requiredZone = this.targetSequence[this.currentStepIndex];
    const requiredCount = this.targetCounts[requiredZone];

    if (this.clickAccumulator === requiredCount) {
      this.currentStepIndex++;
      this.clickAccumulator = 0;
      // console.log(`验证通过: 步骤 ${this.currentStepIndex}`);

      if (this.currentStepIndex === this.targetSequence.length) {
        this.unlock();
      }
    } else {
      this.resetProgress();
    }
  }

  resetProgress() {
    this.currentStepIndex = 0;
    this.clickAccumulator = 0;
    // 调试用：可以加一个短暂的红闪效果提示重置
    this.wrapper.style.display = 'none';
  }

  unlock() {
    this.isUnlocked = true;
    const content = this.shadowRoot.getElementById('content');

    // 移除所有热区防止干扰
    this.shadowRoot
      .querySelectorAll('.hotspot')
      .forEach((s) => s.remove());
    content.style.display = 'block';

    this.dispatchEvent(new CustomEvent('unlocked'));
    this.wrapper.style.display = 'block';
  }

  render() {
    this.shadowRoot.innerHTML = `
          <style>
              .hotspot {
                  position: fixed;
                  width: 100px;
                  height: 100px;
                  z-index: 10000;
                  /* 测试时可以改为 rgba(0, 255, 0, 0.1) 观察位置 */
                  background: transparent; 
                  cursor: default;
              }
              .tl { top: 0; left: 0; }
              .tr { top: 0; right: 0; }
              .bl { bottom: 0; left: 0; }
              
              #content {
                  display: none;
                  animation: slideUp 0.6s cubic-bezier(0.23, 1, 0.32, 1);
              }

              @keyframes slideUp {
                  from { opacity: 0; transform: translateY(20px); }
                  to { opacity: 1; transform: translateY(0); }
              }
          </style>
          <div id="container">
              <div class="hotspot tl" data-zone="tl"></div>
              <div class="hotspot tr" data-zone="tr"></div>
              <div class="hotspot bl" data-zone="bl"></div>
              
              <div id="content">
                  <slot></slot>
              </div>
          </div>
          `;
  }
}

if (!window.customElements.get("password-guide")) {
  window.customElements.define("password-guide", PasswordGuide);
}

class VariantOptionBadge extends HTMLElement {
  constructor() {
    super();
    
    this.includeRegions = this.dataset.includeRegions;
    this.excludeRegions = this.dataset.excludeRegions;
  }

  async connectedCallback() {
    if(this.includeRegions || this.excludeRegions) {
      this.region = await getRegionWithIp();
      
      // includeRegions 和 excludeRegions 互赤，当同时填了两个，只会取includeRegions
      if(this.includeRegions) {
        // 默认隐藏
        this.style.display = 'none';
        
        if(this.includeRegions.includes(this.region)) {
          this.style.display = 'flex';
        }
        return;
      }
      
      if(this.excludeRegions) {
        // 默认显示
        this.style.display = 'flex';
        
        if(this.excludeRegions.includes(this.region)) {
          this.style.display = 'none';
        }
        return;
      }
    }
  }
  
  disconnectedCallback() {}
}

if (!window.customElements.get("variant-option-badge")) {
  window.customElements.define("variant-option-badge", VariantOptionBadge);
}

export {
  VariantOptionBadge,
  TriggerDialogElement,
  BuyButtonDetailsCard,
  TextCollapser,
  CustomAction,
  HoverWithVideo,
  RatingComponent,
  AccordionDisclosure,
  AnimatedDetails,
  BuyButtons,
  CartCount,
  CartDrawer,
  CartNote,
  CartNotificationDrawer,
  CompareAtPrice,
  ConfirmButton,
  CopyButton,
  CountrySelector,
  CustomButton,
  CustomCursor,
  DialogElement,
  Drawer,
  EffectCarousel,
  FacetApplyButton,
  FacetDialog,
  FacetDrawer,
  FacetFloatingFilter,
  FacetForm,
  FacetLink,
  FacetSortBy,
  FreeShippingBar,
  GestureArea,
  HeightObserver,
  LineItem,
  LineItemQuantity,
  Listbox,
  MarqueeText,
  MediaCarousel,
  ModelMedia,
  NextButton,
  OnSaleBadge,
  PageDots,
  PaymentTerms,
  PickupAvailability,
  PillLoader,
  Player,
  Popover,
  PredictiveSearch,
  PrevButton,
  PriceRange,
  PrivacyBar,
  ProductCard,
  ProductForm,
  PromotionForm,
  ProductGallery,
  ProductLoader,
  ProductQuickAdd,
  ProductZoomButton,
  ProgressBar,
  QuantitySelector,
  QuickBuyDrawer,
  ResizableTextarea,
  RevealItems,
  SafeSticky,
  ProductGift,
  CustomCheckoutButton,
  CopyElementSlot,
  VariantOffer,
  AfterPayMsgWrapper,
  AfterPayMsgInfo,
  CustomAfterPayMsg,
  AddToCartPrice,
  SalePrice,
  PointPrice,
  ScrollArea,
  ScrollCarousel,
  ScrollProgress,
  ScrollShadow,
  SearchDrawer,
  SectionHeader,
  ShareButton,
  ShippingEstimator,
  SoldOutBadge,
  SoldOnBadge,
  SplitLines,
  Tabs,
  PredictiveSearchTabs,
  UnitPrice,
  VariantInventory,
  VariantMedia,
  VariantPicker,
  VariantSku,
  VideoMedia,
  VisibilityProgress,
  cachedFetch,
  createMediaImg,
  debounce,
  extractSectionId,
  fetchCart,
  formatMoney,
  generateSrcset,
  getHeadingKeyframe,
  imageLoaded,
  throttle,
  waitForEvent,
  MemberRedeemDiscount,
  MemberCouponsWrapper,
  VirtualServiceCheckoutButton,
  ComboInputWrapper,
  CompareModelCard,
  VariantCard,
  UnionSelect
};

// Handle fromModule for buy buttons GTA
(function() {
  function handleFromModule() {
    var fromModule = sessionStorage.getItem('fromModule');
    if (!fromModule) return;

    // Clear sessionStorage after reading
    sessionStorage.removeItem('fromModule');

    // Select all buy button elements
    var buyButtons = document.querySelectorAll('.click-gta.buy-buttons, .click-gta.button');

    if(buyButtons) {
      buyButtons.forEach(function(button) {
        var currentGta = button.getAttribute('data-gta');
        if (currentGta && !currentGta.includes('__' + fromModule)) {
          button.setAttribute('data-gta', currentGta + '__' + fromModule);
        }
      });
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleFromModule);
  } else {
    handleFromModule();
  }
})();

// Normalize Judge.me review widget title to h2
(function () {
  function normalizeJudgeMeWidgetTitle() {
    document.querySelectorAll('.jdgm-rev-widg__title').forEach(function (title) {
      if (title.tagName.toLowerCase() === 'h2') return;
      var h2 = document.createElement('h2');
      h2.className = title.className;
      h2.innerHTML = title.innerHTML;
      title.replaceWith(h2);
    });
  }

  document.addEventListener('jdgm.doneSetup', normalizeJudgeMeWidgetTitle);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeJudgeMeWidgetTitle);
  } else {
    normalizeJudgeMeWidgetTitle();
  }
})();
